webpackJsonp(["pages.projects.boards"],{

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./boards/components/board_new_issue.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventhub__ = __webpack_require__("./boards/eventhub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project_select_vue__ = __webpack_require__("./boards/components/project_select.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_issue__ = __webpack_require__("./boards/models/issue.js");





var Store = gl.issueBoards.BoardsStore;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BoardNewIssue',
  components: {
    ProjectSelect: __WEBPACK_IMPORTED_MODULE_1__project_select_vue__["a" /* default */]
  },
  props: {
    groupId: {
      type: Number,
      required: false,
      default: 0
    },
    list: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      title: '',
      error: false,
      selectedProject: {}
    };
  },

  computed: {
    disabled: function disabled() {
      if (this.groupId) {
        return this.title === '' || !this.selectedProject.name;
      }
      return this.title === '';
    }
  },
  mounted: function mounted() {
    this.$refs.input.focus();
    __WEBPACK_IMPORTED_MODULE_0__eventhub__["a" /* default */].$on('setSelectedProject', this.setSelectedProject);
  },

  methods: {
    submit: function submit(e) {
      var _this = this;

      e.preventDefault();
      if (this.title.trim() === '') return Promise.resolve();

      this.error = false;

      var labels = this.list.label ? [this.list.label] : [];
      var issue = new __WEBPACK_IMPORTED_MODULE_2__models_issue__["a" /* default */]({
        title: this.title,
        labels: labels,
        subscribed: true,
        assignees: [],
        project_id: this.selectedProject.id
      });

      __WEBPACK_IMPORTED_MODULE_0__eventhub__["a" /* default */].$emit('scroll-board-list-' + this.list.id);
      this.cancel();

      return this.list.newIssue(issue).then(function () {
        // Need this because our jQuery very kindly disables buttons on ALL form submissions
        $(_this.$refs.submitButton).enable();

        Store.detail.issue = issue;
        Store.detail.list = _this.list;
      }).catch(function () {
        // Need this because our jQuery very kindly disables buttons on ALL form submissions
        $(_this.$refs.submitButton).enable();

        // Remove the issue
        _this.list.removeIssue(issue);

        // Show error message
        _this.error = true;
      });
    },
    cancel: function cancel() {
      this.title = '';
      __WEBPACK_IMPORTED_MODULE_0__eventhub__["a" /* default */].$emit('hide-issue-form-' + this.list.id);
    },
    setSelectedProject: function setSelectedProject(selectedProject) {
      this.selectedProject = selectedProject;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./boards/components/project_select.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventhub__ = __webpack_require__("./boards/eventhub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("./api.js");

/* global ListIssue */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BoardProjectSelect',
  components: {
    loadingIcon: __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__["a" /* default */]
  },
  props: {
    groupId: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data: function data() {
    return {
      loading: true,
      selectedProject: {}
    };
  },

  computed: {
    selectedProjectName: function selectedProjectName() {
      return this.selectedProject.name || 'Select a project';
    }
  },
  mounted: function mounted() {
    var _this = this;

    $(this.$refs.projectsDropdown).glDropdown({
      filterable: true,
      filterRemote: true,
      search: {
        fields: ['name_with_namespace']
      },
      clicked: function clicked(_ref) {
        var $el = _ref.$el,
            e = _ref.e;

        e.preventDefault();
        _this.selectedProject = {
          id: $el.data('project-id'),
          name: $el.data('project-name')
        };
        __WEBPACK_IMPORTED_MODULE_1__eventhub__["a" /* default */].$emit('setSelectedProject', _this.selectedProject);
      },
      selectable: true,
      data: function data(term, callback) {
        _this.loading = true;
        return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].groupProjects(_this.groupId, term, function (projects) {
          _this.loading = false;
          callback(projects);
        });
      },
      renderRow: function renderRow(project) {
        return '\n          <li>\n            <a href=\'#\' class=\'dropdown-menu-link\' data-project-id="' + project.id + '" data-project-name="' + project.name + '">\n              ' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(project.name) + '\n            </a>\n          </li>\n        ';
      },

      text: function text(project) {
        return project.name;
      }
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/pikaday/pikaday.js":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/dbushell/Pikaday
 */

(function (root, factory)
{
    'use strict';

    var moment;
    if (true) {
        // CommonJS module
        // Load moment.js as an optional dependency
        try { moment = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"moment\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())); } catch (e) {}
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (req)
        {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try { moment = req(id); } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
}(this, function (moment)
{
    'use strict';

    /**
     * feature detection and helper functions
     */
    var hasMoment = typeof moment === 'function',

    hasEventListeners = !!window.addEventListener,

    document = window.document,

    sto = window.setTimeout,

    addEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },

    removeEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },

    trim = function(str)
    {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
    },

    hasClass = function(el, cn)
    {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },

    addClass = function(el, cn)
    {
        if (!hasClass(el, cn)) {
            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
        }
    },

    removeClass = function(el, cn)
    {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },

    isArray = function(obj)
    {
        return (/Array/).test(Object.prototype.toString.call(obj));
    },

    isDate = function(obj)
    {
        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
    },

    isWeekend = function(date)
    {
        var day = date.getDay();
        return day === 0 || day === 6;
    },

    isLeapYear = function(year)
    {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    },

    getDaysInMonth = function(year, month)
    {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },

    setToStartOfDay = function(date)
    {
        if (isDate(date)) date.setHours(0,0,0,0);
    },

    compareDates = function(a,b)
    {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
    },

    extend = function(to, from, overwrite)
    {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                }
                else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },

    fireEvent = function(el, eventName, data)
    {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },

    adjustCalendar = function(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month)/12);
            calendar.month -= 12;
        }
        return calendar;
    },

    /**
     * defaults and localisation
     */
    defaults = {

        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        format: 'YYYY-MM-DD',

        // the toString function which gets passed a current date object and format
        // and returns a string
        toString: null,

        // used to create date object from current input string
        parse: null,

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // the default flag for moment's strict date parsing
        formatStrict: false,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // Week picker mode
        pickWholeWeek: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,

        // Allows user to select days that fall in the next or previous month
        enableSelectionDaysInNextAndPreviousMonths: false,

        // how many months are visible
        numberOfMonths: 1,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // Blur field when date is selected
        blurFieldOnSelect : true,

        // internationalization
        i18n: {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        },

        // Theme Classname
        theme: null,

        // events array
        events: [],

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function(opts, day, abbr)
    {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },

    renderDay = function(opts)
    {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
            if (opts.showDaysInNextAndPreviousMonths) {
                arr.push('is-outside-current-month');

                if(!opts.enableSelectionDaysInNextAndPreviousMonths) {
                    arr.push('is-selection-disabled');
                }

            } else {
                return '<td class="is-empty"></td>';
            }
        }
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
            ariaSelected = 'true';
        }
        if (opts.hasEvent) {
            arr.push('has-event');
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
                 '<button class="pika-button pika-day" type="button" ' +
                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
                        opts.day +
                 '</button>' +
               '</td>';
    },

    renderWeek = function (d, m, y) {
        // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
        var onejan = new Date(y, 0, 1),
            weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay()+1)/7);
        return '<td class="pika-week">' + weekNum + '</td>';
    },

    renderRow = function(days, isRTL, pickWholeWeek, isRowSelected)
    {
        return '<tr class="pika-row' + (pickWholeWeek ? ' pick-whole-week' : '') + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },

    renderBody = function(rows)
    {
        return '<tbody>' + rows.join('') + '</tbody>';
    },

    renderHead = function(opts)
    {
        var i, arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
    },

    renderTitle = function(instance, c, year, month, refYear, randId)
    {
        var i, j, arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
                (i === month ? ' selected="selected"': '') +
                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled="disabled"' : '') + '>' +
                opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"': '') + '>' + (i) + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === (instance._o.numberOfMonths - 1) ) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },

    renderTable = function(opts, data, randId)
    {
        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
    },


    /**
     * Pikaday constructor
     */
    Pikaday = function(options)
    {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function(e)
        {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                    if (opts.bound) {
                        sto(function() {
                            self.hide();
                            if (opts.blurFieldOnSelect && opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                }
                else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                }
                else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            }
            else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
        };

        self._onKeyChange = function(e)
        {
            e = e || window.event;

            if (self.isVisible()) {

                switch(e.keyCode){
                    case 13:
                    case 27:
                        if (opts.field) {
                            opts.field.blur();
                        }
                        break;
                    case 37:
                        e.preventDefault();
                        self.adjustDate('subtract', 1);
                        break;
                    case 38:
                        self.adjustDate('subtract', 7);
                        break;
                    case 39:
                        self.adjustDate('add', 1);
                        break;
                    case 40:
                        self.adjustDate('add', 7);
                        break;
                }
            }
        };

        self._onInputChange = function(e)
        {
            var date;

            if (e.firedBy === self) {
                return;
            }
            if (opts.parse) {
                date = opts.parse(opts.field.value, opts.format);
            } else if (hasMoment) {
                date = moment(opts.field.value, opts.format, opts.formatStrict);
                date = (date && date.isValid()) ? date.toDate() : null;
            }
            else {
                date = new Date(Date.parse(opts.field.value));
            }
            if (isDate(date)) {
              self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };

        self._onInputFocus = function()
        {
            self.show();
        };

        self._onInputClick = function()
        {
            self.show();
        };

        self._onInputBlur = function()
        {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));

            if (!self._c) {
                self._b = sto(function() {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);
        addEvent(document, 'keydown', self._onKeyChange);

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                if (hasMoment && opts.field.value) {
                    opts.defaultDate = moment(opts.field.value, opts.format).toDate();
                } else {
                    opts.defaultDate = new Date(Date.parse(opts.field.value));
                }
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };


    /**
     * public Pikaday API
     */
    Pikaday.prototype = {


        /**
         * configure functionality
         */
        config: function(options)
        {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;

            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
                this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function(format)
        {
            format = format || this._o.format;
            if (!isDate(this._d)) {
                return '';
            }
            if (this._o.toString) {
              return this._o.toString(this._d, format);
            }
            if (hasMoment) {
              return moment(this._d).format(format);
            }
            return this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function()
        {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function(date, preventOnSelect)
        {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection
         */
        getDate: function()
        {
            return isDate(this._d) ? new Date(this._d.getTime()) : null;
        },

        /**
         * set the current selection
         */
        setDate: function(date, preventOnSelect)
        {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());
            setToStartOfDay(this._d);
            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * change view to a specific date
         */
        gotoDate: function(date)
        {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustDate: function(sign, days) {

            var day = this.getDate() || new Date();
            var difference = parseInt(days)*24*60*60*1000;

            var newDay;

            if (sign === 'add') {
                newDay = new Date(day.valueOf() + difference);
            } else if (sign === 'subtract') {
                newDay = new Date(day.valueOf() - difference);
            }

            this.setDate(newDay);
        },

        adjustCalendars: function() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function()
        {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function(month)
        {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function()
        {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function()
        {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function(year)
        {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.minDate = value;
                this._o.minYear  = value.getFullYear();
                this._o.minMonth = value.getMonth();
            } else {
                this._o.minDate = defaults.minDate;
                this._o.minYear  = defaults.minYear;
                this._o.minMonth = defaults.minMonth;
                this._o.startRange = defaults.startRange;
            }

            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.maxDate = value;
                this._o.maxYear = value.getFullYear();
                this._o.maxMonth = value.getMonth();
            } else {
                this._o.maxDate = defaults.maxDate;
                this._o.maxYear = defaults.maxYear;
                this._o.maxMonth = defaults.maxMonth;
                this._o.endRange = defaults.endRange;
            }

            this.draw();
        },

        setStartRange: function(value)
        {
            this._o.startRange = value;
        },

        setEndRange: function(value)
        {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function(force)
        {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '',
                randId;

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);

            for (var c = 0; c < opts.numberOfMonths; c++) {
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if(opts.field.type !== 'hidden') {
                    sto(function() {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                this._o.onDraw(this);
            }

            if (opts.bound) {
                // let the screen reader user know to use arrow keys
                opts.field.setAttribute('aria-label', 'Use the arrow keys to pick a date');
            }
        },

        adjustPosition: function()
        {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top  = pEl.offsetTop + pEl.offsetHeight;
                while((pEl = pEl.offsetParent)) {
                    left += pEl.offsetLeft;
                    top  += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if ((this._o.reposition && left + width > viewportWidth) ||
                (
                    this._o.position.indexOf('right') > -1 &&
                    left - width + field.offsetWidth > 0
                )
            ) {
                left = left - width + field.offsetWidth;
            }
            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
                (
                    this._o.position.indexOf('top') > -1 &&
                    top - height - field.offsetHeight > 0
                )
            ) {
                top = top - height - field.offsetHeight;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';
        },

        /**
         * render HTML for a particular month
         */
        render: function(year, month, randId)
        {
            var opts   = this._o,
                now    = new Date(),
                days   = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data   = [],
                row    = [];
            setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var previousMonth = month === 0 ? 11 : month - 1,
                nextMonth = month === 11 ? 0 : month + 1,
                yearOfPreviousMonth = month === 0 ? year - 1 : year,
                yearOfNextMonth = month === 11 ? year + 1 : year,
                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
            var cells = days + before,
                after = cells;
            while(after > 7) {
                after -= 7;
            }
            cells += 7 - after;
            var isWeekSelected = false;
            for (var i = 0, r = 0; i < cells; i++)
            {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
                    isEmpty = i < before || i >= (days + before),
                    dayNumber = 1 + (i - before),
                    monthNumber = month,
                    yearNumber = year,
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = (opts.minDate && day < opts.minDate) ||
                                 (opts.maxDate && day > opts.maxDate) ||
                                 (opts.disableWeekends && isWeekend(day)) ||
                                 (opts.disableDayFn && opts.disableDayFn(day));

                if (isEmpty) {
                    if (i < before) {
                        dayNumber = daysInPreviousMonth + dayNumber;
                        monthNumber = previousMonth;
                        yearNumber = yearOfPreviousMonth;
                    } else {
                        dayNumber = dayNumber - days;
                        monthNumber = nextMonth;
                        yearNumber = yearOfNextMonth;
                    }
                }

                var dayConfig = {
                        day: dayNumber,
                        month: monthNumber,
                        year: yearNumber,
                        hasEvent: hasEvent,
                        isSelected: isSelected,
                        isToday: isToday,
                        isDisabled: isDisabled,
                        isEmpty: isEmpty,
                        isStartRange: isStartRange,
                        isEndRange: isEndRange,
                        isInRange: isInRange,
                        showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths,
                        enableSelectionDaysInNextAndPreviousMonths: opts.enableSelectionDaysInNextAndPreviousMonths
                    };

                if (opts.pickWholeWeek && isSelected) {
                    isWeekSelected = true;
                }

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year));
                    }
                    data.push(renderRow(row, opts.isRTL, opts.pickWholeWeek, isWeekSelected));
                    row = [];
                    r = 0;
                    isWeekSelected = false;
                }
            }
            return renderTable(opts, data, randId);
        },

        isVisible: function()
        {
            return this._v;
        },

        show: function()
        {
            if (!this.isVisible()) {
                this._v = true;
                this.draw();
                removeClass(this.el, 'is-hidden');
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function()
        {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }
                this.el.style.position = 'static'; // reset
                this.el.style.left = 'auto';
                this.el.style.top = 'auto';
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function()
        {
            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            removeEvent(document, 'keydown', this._onKeyChange);
            if (this._o.field) {
                removeEvent(this._o.field, 'change', this._onInputChange);
                if (this._o.bound) {
                    removeEvent(this._o.trigger, 'click', this._onInputClick);
                    removeEvent(this._o.trigger, 'focus', this._onInputFocus);
                    removeEvent(this._o.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;

}));


/***/ }),

/***/ "../../../vendor/assets/javascripts/Sortable.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**!
 * Sortable
 * @author	RubaXa   <trash@rubaxa.org>
 * @license MIT
 */

(function sortableModule(factory) {
	"use strict";

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module != "undefined" && typeof module.exports != "undefined") {
		module.exports = factory();
	}
	else if (typeof Package !== "undefined") {
		//noinspection JSUnresolvedVariable
		Sortable = factory();  // export for Meteor.js
	}
	else {
		/* jshint sub:true */
		window["Sortable"] = factory();
	}
})(function sortableFactory() {
	"use strict";

	if (typeof window == "undefined" || !window.document) {
		return function sortableError() {
			throw new Error("Sortable.js requires a window with a document");
		};
	}

	var dragEl,
		parentEl,
		ghostEl,
		cloneEl,
		rootEl,
		nextEl,

		scrollEl,
		scrollParentEl,
		scrollCustomFn,

		lastEl,
		lastCSS,
		lastParentCSS,

		oldIndex,
		newIndex,

		activeGroup,
		putSortable,

		autoScroll = {},

		tapEvt,
		touchEvt,

		moved,

		/** @const */
		RSPACE = /\s+/g,

		expando = 'Sortable' + (new Date).getTime(),

		win = window,
		document = win.document,
		parseInt = win.parseInt,

		$ = win.jQuery || win.Zepto,
		Polymer = win.Polymer,

		supportDraggable = !!('draggable' in document.createElement('div')),
		supportCssPointerEvents = (function (el) {
			// false when IE11
			if (!!navigator.userAgent.match(/Trident.*rv[ :]?11\./)) {
				return false;
			}
			el = document.createElement('x');
			el.style.cssText = 'pointer-events:auto';
			return el.style.pointerEvents === 'auto';
		})(),

		_silent = false,

		abs = Math.abs,
		min = Math.min,
		slice = [].slice,

		touchDragOverListeners = [],

		_autoScroll = _throttle(function (/**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
			// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
			if (rootEl && options.scroll) {
				var el,
					rect,
					sens = options.scrollSensitivity,
					speed = options.scrollSpeed,

					x = evt.clientX,
					y = evt.clientY,

					winWidth = window.innerWidth,
					winHeight = window.innerHeight,

					vx,
					vy,

					scrollOffsetX,
					scrollOffsetY
				;

				// Delect scrollEl
				if (scrollParentEl !== rootEl) {
					scrollEl = options.scroll;
					scrollParentEl = rootEl;
					scrollCustomFn = options.scrollFn;

					if (scrollEl === true) {
						scrollEl = rootEl;

						do {
							if ((scrollEl.offsetWidth < scrollEl.scrollWidth) ||
								(scrollEl.offsetHeight < scrollEl.scrollHeight)
							) {
								break;
							}
							/* jshint boss:true */
						} while (scrollEl = scrollEl.parentNode);
					}
				}

				if (scrollEl) {
					el = scrollEl;
					rect = scrollEl.getBoundingClientRect();
					vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
					vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
				}


				if (!(vx || vy)) {
					vx = (winWidth - x <= sens) - (x <= sens);
					vy = (winHeight - y <= sens) - (y <= sens);

					/* jshint expr:true */
					(vx || vy) && (el = win);
				}


				if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
					autoScroll.el = el;
					autoScroll.vx = vx;
					autoScroll.vy = vy;

					clearInterval(autoScroll.pid);

					if (el) {
						autoScroll.pid = setInterval(function () {
							scrollOffsetY = vy ? vy * speed : 0;
							scrollOffsetX = vx ? vx * speed : 0;

							if ('function' === typeof(scrollCustomFn)) {
								return scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt);
							}

							if (el === win) {
								win.scrollTo(win.pageXOffset + scrollOffsetX, win.pageYOffset + scrollOffsetY);
							} else {
								el.scrollTop += scrollOffsetY;
								el.scrollLeft += scrollOffsetX;
							}
						}, 24);
					}
				}
			}
		}, 30),

		_prepareGroup = function (options) {
			function toFn(value, pull) {
				if (value === void 0 || value === true) {
					value = group.name;
				}

				if (typeof value === 'function') {
					return value;
				} else {
					return function (to, from) {
						var fromGroup = from.options.group.name;

						return pull
							? value
							: value && (value.join
								? value.indexOf(fromGroup) > -1
								: (fromGroup == value)
							);
					};
				}
			}

			var group = {};
			var originalGroup = options.group;

			if (!originalGroup || typeof originalGroup != 'object') {
				originalGroup = {name: originalGroup};
			}

			group.name = originalGroup.name;
			group.checkPull = toFn(originalGroup.pull, true);
			group.checkPut = toFn(originalGroup.put);

			options.group = group;
		}
	;



	/**
	 * @class  Sortable
	 * @param  {HTMLElement}  el
	 * @param  {Object}       [options]
	 */
	function Sortable(el, options) {
		if (!(el && el.nodeType && el.nodeType === 1)) {
			throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
		}

		this.el = el; // root element
		this.options = options = _extend({}, options);


		// Export instance
		el[expando] = this;


		// Default options
		var defaults = {
			group: Math.random(),
			sort: true,
			disabled: false,
			store: null,
			handle: null,
			scroll: true,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
			ghostClass: 'sortable-ghost',
			chosenClass: 'sortable-chosen',
			dragClass: 'sortable-drag',
			ignore: 'a, img',
			filter: null,
			animation: 0,
			setData: function (dataTransfer, dragEl) {
				dataTransfer.setData('Text', dragEl.textContent);
			},
			dropBubble: false,
			dragoverBubble: false,
			dataIdAttr: 'data-id',
			delay: 0,
			forceFallback: false,
			fallbackClass: 'sortable-fallback',
			fallbackOnBody: false,
			fallbackTolerance: 0,
			fallbackOffset: {x: 0, y: 0}
		};


		// Set default options
		for (var name in defaults) {
			!(name in options) && (options[name] = defaults[name]);
		}

		_prepareGroup(options);

		// Bind all private methods
		for (var fn in this) {
			if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
				this[fn] = this[fn].bind(this);
			}
		}

		// Setup drag mode
		this.nativeDraggable = options.forceFallback ? false : supportDraggable;

		// Bind events
		_on(el, 'mousedown', this._onTapStart);
		_on(el, 'touchstart', this._onTapStart);

		if (this.nativeDraggable) {
			_on(el, 'dragover', this);
			_on(el, 'dragenter', this);
		}

		touchDragOverListeners.push(this._onDragOver);

		// Restore sorting
		options.store && this.sort(options.store.get(this));
	}


	Sortable.prototype = /** @lends Sortable.prototype */ {
		constructor: Sortable,

		_onTapStart: function (/** Event|TouchEvent */evt) {
			var _this = this,
				el = this.el,
				options = this.options,
				type = evt.type,
				touch = evt.touches && evt.touches[0],
				target = (touch || evt).target,
				originalTarget = evt.target.shadowRoot && evt.path[0] || target,
				filter = options.filter,
				startIndex;

			// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
			if (dragEl) {
				return;
			}

			if (type === 'mousedown' && evt.button !== 0 || options.disabled) {
				return; // only left button or enabled
			}

			if (options.handle && !_closest(originalTarget, options.handle, el)) {
				return;
			}

			target = _closest(target, options.draggable, el);

			if (!target) {
				return;
			}

			// Get the index of the dragged element within its parent
			startIndex = _index(target, options.draggable);

			// Check filter
			if (typeof filter === 'function') {
				if (filter.call(this, evt, target, this)) {
					_dispatchEvent(_this, originalTarget, 'filter', target, el, startIndex);
					evt.preventDefault();
					return; // cancel dnd
				}
			}
			else if (filter) {
				filter = filter.split(',').some(function (criteria) {
					criteria = _closest(originalTarget, criteria.trim(), el);

					if (criteria) {
						_dispatchEvent(_this, criteria, 'filter', target, el, startIndex);
						return true;
					}
				});

				if (filter) {
					evt.preventDefault();
					return; // cancel dnd
				}
			}

			// Prepare `dragstart`
			this._prepareDragStart(evt, touch, target, startIndex);
		},

		_prepareDragStart: function (/** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex) {
			var _this = this,
				el = _this.el,
				options = _this.options,
				ownerDocument = el.ownerDocument,
				dragStartFn;

			if (target && !dragEl && (target.parentNode === el)) {
				tapEvt = evt;

				rootEl = el;
				dragEl = target;
				parentEl = dragEl.parentNode;
				nextEl = dragEl.nextSibling;
				activeGroup = options.group;
				oldIndex = startIndex;

				this._lastX = (touch || evt).clientX;
				this._lastY = (touch || evt).clientY;

				dragEl.style['will-change'] = 'transform';

				dragStartFn = function () {
					// Delayed drag has been triggered
					// we can re-enable the events: touchmove/mousemove
					_this._disableDelayedDrag();

					// Make the element draggable
					dragEl.draggable = _this.nativeDraggable;

					// Chosen item
					_toggleClass(dragEl, options.chosenClass, true);

					// Bind the events: dragstart/dragend
					_this._triggerDragStart(touch);

					// Drag start event
					_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, oldIndex);
				};

				// Disable "draggable"
				options.ignore.split(',').forEach(function (criteria) {
					_find(dragEl, criteria.trim(), _disableDraggable);
				});

				_on(ownerDocument, 'mouseup', _this._onDrop);
				_on(ownerDocument, 'touchend', _this._onDrop);
				_on(ownerDocument, 'touchcancel', _this._onDrop);

				if (options.delay) {
					// If the user moves the pointer or let go the click or touch
					// before the delay has been reached:
					// disable the delayed drag
					_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
					_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);

					_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
				} else {
					dragStartFn();
				}
			}
		},

		_disableDelayedDrag: function () {
			var ownerDocument = this.el.ownerDocument;

			clearTimeout(this._dragStartTimer);
			_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
			_off(ownerDocument, 'touchend', this._disableDelayedDrag);
			_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
			_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
			_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
		},

		_triggerDragStart: function (/** Touch */touch) {
			if (touch) {
				// Touch device support
				tapEvt = {
					target: dragEl,
					clientX: touch.clientX,
					clientY: touch.clientY
				};

				this._onDragStart(tapEvt, 'touch');
			}
			else if (!this.nativeDraggable) {
				this._onDragStart(tapEvt, true);
			}
			else {
				_on(dragEl, 'dragend', this);
				_on(rootEl, 'dragstart', this._onDragStart);
			}

			try {
				if (document.selection) {
					// Timeout neccessary for IE9
					setTimeout(function () {
						document.selection.empty();
					});
				} else {
					window.getSelection().removeAllRanges();
				}
			} catch (err) {
			}
		},

		_dragStarted: function () {
			if (rootEl && dragEl) {
				var options = this.options;

				// Apply effect
				_toggleClass(dragEl, options.ghostClass, true);
				_toggleClass(dragEl, options.dragClass, false);

				Sortable.active = this;

				// Drag start event
				_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, oldIndex);
			}
		},

		_emulateDragOver: function () {
			if (touchEvt) {
				if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
					return;
				}

				this._lastX = touchEvt.clientX;
				this._lastY = touchEvt.clientY;

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', 'none');
				}

				var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY),
					parent = target,
					i = touchDragOverListeners.length;

				if (parent) {
					do {
						if (parent[expando]) {
							while (i--) {
								touchDragOverListeners[i]({
									clientX: touchEvt.clientX,
									clientY: touchEvt.clientY,
									target: target,
									rootEl: parent
								});
							}

							break;
						}

						target = parent; // store last element
					}
					/* jshint boss:true */
					while (parent = parent.parentNode);
				}

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', '');
				}
			}
		},


		_onTouchMove: function (/**TouchEvent*/evt) {
			if (tapEvt) {
				var	options = this.options,
					fallbackTolerance = options.fallbackTolerance,
					fallbackOffset = options.fallbackOffset,
					touch = evt.touches ? evt.touches[0] : evt,
					dx = (touch.clientX - tapEvt.clientX) + fallbackOffset.x,
					dy = (touch.clientY - tapEvt.clientY) + fallbackOffset.y,
					translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';

				// only set the status to dragging, when we are actually dragging
				if (!Sortable.active) {
					if (fallbackTolerance &&
						min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance
					) {
						return;
					}

					this._dragStarted();
				}

				// as well as creating the ghost element on the document body
				this._appendGhost();

				moved = true;
				touchEvt = touch;

				_css(ghostEl, 'webkitTransform', translate3d);
				_css(ghostEl, 'mozTransform', translate3d);
				_css(ghostEl, 'msTransform', translate3d);
				_css(ghostEl, 'transform', translate3d);

				evt.preventDefault();
			}
		},

		_appendGhost: function () {
			if (!ghostEl) {
				var rect = dragEl.getBoundingClientRect(),
					css = _css(dragEl),
					options = this.options,
					ghostRect;

				ghostEl = dragEl.cloneNode(true);

				_toggleClass(ghostEl, options.ghostClass, false);
				_toggleClass(ghostEl, options.fallbackClass, true);
				_toggleClass(ghostEl, options.dragClass, true);

				_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
				_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
				_css(ghostEl, 'width', rect.width);
				_css(ghostEl, 'height', rect.height);
				_css(ghostEl, 'opacity', '0.8');
				_css(ghostEl, 'position', 'fixed');
				_css(ghostEl, 'zIndex', '100000');
				_css(ghostEl, 'pointerEvents', 'none');

				options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);

				// Fixing dimensions.
				ghostRect = ghostEl.getBoundingClientRect();
				_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
				_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
			}
		},

		_onDragStart: function (/**Event*/evt, /**boolean*/useFallback) {
			var dataTransfer = evt.dataTransfer,
				options = this.options;

			this._offUpEvents();

			if (activeGroup.checkPull(this, this, dragEl, evt) == 'clone') {
				cloneEl = _clone(dragEl);
				_css(cloneEl, 'display', 'none');
				rootEl.insertBefore(cloneEl, dragEl);
				_dispatchEvent(this, rootEl, 'clone', dragEl);
			}

			_toggleClass(dragEl, options.dragClass, true);

			if (useFallback) {
				if (useFallback === 'touch') {
					// Bind touch events
					_on(document, 'touchmove', this._onTouchMove);
					_on(document, 'touchend', this._onDrop);
					_on(document, 'touchcancel', this._onDrop);
				} else {
					// Old brwoser
					_on(document, 'mousemove', this._onTouchMove);
					_on(document, 'mouseup', this._onDrop);
				}

				this._loopId = setInterval(this._emulateDragOver, 50);
			}
			else {
				if (dataTransfer) {
					dataTransfer.effectAllowed = 'move';
					options.setData && options.setData.call(this, dataTransfer, dragEl);
				}

				_on(document, 'drop', this);
				setTimeout(this._dragStarted, 0);
			}
		},

		_onDragOver: function (/**Event*/evt) {
			var el = this.el,
				target,
				dragRect,
				targetRect,
				revert,
				options = this.options,
				group = options.group,
				activeSortable = Sortable.active,
				isOwner = (activeGroup === group),
				canSort = options.sort;

			if (evt.preventDefault !== void 0) {
				evt.preventDefault();
				!options.dragoverBubble && evt.stopPropagation();
			}

			moved = true;

			if (activeGroup && !options.disabled &&
				(isOwner
					? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
					: (
						putSortable === this ||
						activeGroup.checkPull(this, activeSortable, dragEl, evt) && group.checkPut(this, activeSortable, dragEl, evt)
					)
				) &&
				(evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
			) {
				// Smart auto-scrolling
				_autoScroll(evt, options, this.el);

				if (_silent) {
					return;
				}

				target = _closest(evt.target, options.draggable, el);
				dragRect = dragEl.getBoundingClientRect();
				putSortable = this;

				if (revert) {
					_cloneHide(true);
					parentEl = rootEl; // actualization

					if (cloneEl || nextEl) {
						rootEl.insertBefore(dragEl, cloneEl || nextEl);
					}
					else if (!canSort) {
						rootEl.appendChild(dragEl);
					}

					return;
				}


				if ((el.children.length === 0) || (el.children[0] === ghostEl) ||
					(el === evt.target) && (target = _ghostIsLast(el, evt))
				) {
					if (target) {
						if (target.animated) {
							return;
						}

						targetRect = target.getBoundingClientRect();
					}

					_cloneHide(isOwner);

					if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt) !== false) {
						if (!dragEl.contains(el)) {
							el.appendChild(dragEl);
							parentEl = el; // actualization
						}

						this._animate(dragRect, dragEl);
						target && this._animate(targetRect, target);
					}
				}
				else if (target && !target.animated && target !== dragEl && (target.parentNode[expando] !== void 0)) {
					if (lastEl !== target) {
						lastEl = target;
						lastCSS = _css(target);
						lastParentCSS = _css(target.parentNode);
					}

					targetRect = target.getBoundingClientRect();

					var width = targetRect.right - targetRect.left,
						height = targetRect.bottom - targetRect.top,
						floating = /left|right|inline/.test(lastCSS.cssFloat + lastCSS.display)
							|| (lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0),
						isWide = (target.offsetWidth > dragEl.offsetWidth),
						isLong = (target.offsetHeight > dragEl.offsetHeight),
						halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
						nextSibling = target.nextElementSibling,
						moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt),
						after
					;

					if (moveVector !== false) {
						_silent = true;
						setTimeout(_unsilent, 30);

						_cloneHide(isOwner);

						if (moveVector === 1 || moveVector === -1) {
							after = (moveVector === 1);
						}
						else if (floating) {
							var elTop = dragEl.offsetTop,
								tgTop = target.offsetTop;

							if (elTop === tgTop) {
								after = (target.previousElementSibling === dragEl) && !isWide || halfway && isWide;
							}
							else if (target.previousElementSibling === dragEl || dragEl.previousElementSibling === target) {
								after = (evt.clientY - targetRect.top) / height > 0.5;
							} else {
								after = tgTop > elTop;
							}
						} else {
							after = (nextSibling !== dragEl) && !isLong || halfway && isLong;
						}

						if (!dragEl.contains(el)) {
							if (after && !nextSibling) {
								el.appendChild(dragEl);
							} else {
								target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
							}
						}

						parentEl = dragEl.parentNode; // actualization

						this._animate(dragRect, dragEl);
						this._animate(targetRect, target);
					}
				}
			}
		},

		_animate: function (prevRect, target) {
			var ms = this.options.animation;

			if (ms) {
				var currentRect = target.getBoundingClientRect();

				_css(target, 'transition', 'none');
				_css(target, 'transform', 'translate3d('
					+ (prevRect.left - currentRect.left) + 'px,'
					+ (prevRect.top - currentRect.top) + 'px,0)'
				);

				target.offsetWidth; // repaint

				_css(target, 'transition', 'all ' + ms + 'ms');
				_css(target, 'transform', 'translate3d(0,0,0)');

				clearTimeout(target.animated);
				target.animated = setTimeout(function () {
					_css(target, 'transition', '');
					_css(target, 'transform', '');
					target.animated = false;
				}, ms);
			}
		},

		_offUpEvents: function () {
			var ownerDocument = this.el.ownerDocument;

			_off(document, 'touchmove', this._onTouchMove);
			_off(ownerDocument, 'mouseup', this._onDrop);
			_off(ownerDocument, 'touchend', this._onDrop);
			_off(ownerDocument, 'touchcancel', this._onDrop);
		},

		_onDrop: function (/**Event*/evt) {
			var el = this.el,
				options = this.options;

			clearInterval(this._loopId);
			clearInterval(autoScroll.pid);
			clearTimeout(this._dragStartTimer);

			// Unbind events
			_off(document, 'mousemove', this._onTouchMove);

			if (this.nativeDraggable) {
				_off(document, 'drop', this);
				_off(el, 'dragstart', this._onDragStart);
			}

			this._offUpEvents();

			if (evt) {
				if (moved) {
					evt.preventDefault();
					!options.dropBubble && evt.stopPropagation();
				}

				ghostEl && ghostEl.parentNode.removeChild(ghostEl);

				if (dragEl) {
					if (this.nativeDraggable) {
						_off(dragEl, 'dragend', this);
					}

					_disableDraggable(dragEl);
					dragEl.style['will-change'] = '';

					// Remove class's
					_toggleClass(dragEl, this.options.ghostClass, false);
					_toggleClass(dragEl, this.options.chosenClass, false);

					if (rootEl !== parentEl) {
						newIndex = _index(dragEl, options.draggable);

						if (newIndex >= 0) {

							// Add event
							_dispatchEvent(null, parentEl, 'add', dragEl, rootEl, oldIndex, newIndex);

							// Remove event
							_dispatchEvent(this, rootEl, 'remove', dragEl, rootEl, oldIndex, newIndex);

							// drag from one list and drop into another
							_dispatchEvent(null, parentEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
						}
					}
					else {
						// Remove clone
						cloneEl && cloneEl.parentNode.removeChild(cloneEl);

						if (dragEl.nextSibling !== nextEl) {
							// Get the index of the dragged element within its parent
							newIndex = _index(dragEl, options.draggable);

							if (newIndex >= 0) {
								// drag & drop within the same list
								_dispatchEvent(this, rootEl, 'update', dragEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							}
						}
					}

					if (Sortable.active) {
						/* jshint eqnull:true */
						if (newIndex == null || newIndex === -1) {
							newIndex = oldIndex;
						}

						_dispatchEvent(this, rootEl, 'end', dragEl, rootEl, oldIndex, newIndex);

						// Save sorting
						this.save();
					}
				}

			}

			this._nulling();
		},

		_nulling: function() {
			rootEl =
			dragEl =
			parentEl =
			ghostEl =
			nextEl =
			cloneEl =

			scrollEl =
			scrollParentEl =

			tapEvt =
			touchEvt =

			moved =
			newIndex =

			lastEl =
			lastCSS =

			putSortable =
			activeGroup =
			Sortable.active = null;
		},

		handleEvent: function (/**Event*/evt) {
			var type = evt.type;

			if (type === 'dragover' || type === 'dragenter') {
				if (dragEl) {
					this._onDragOver(evt);
					_globalDragOver(evt);
				}
			}
			else if (type === 'drop' || type === 'dragend') {
				this._onDrop(evt);
			}
		},


		/**
		 * Serializes the item into an array of string.
		 * @returns {String[]}
		 */
		toArray: function () {
			var order = [],
				el,
				children = this.el.children,
				i = 0,
				n = children.length,
				options = this.options;

			for (; i < n; i++) {
				el = children[i];
				if (_closest(el, options.draggable, this.el)) {
					order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
				}
			}

			return order;
		},


		/**
		 * Sorts the elements according to the array.
		 * @param  {String[]}  order  order of the items
		 */
		sort: function (order) {
			var items = {}, rootEl = this.el;

			this.toArray().forEach(function (id, i) {
				var el = rootEl.children[i];

				if (_closest(el, this.options.draggable, rootEl)) {
					items[id] = el;
				}
			}, this);

			order.forEach(function (id) {
				if (items[id]) {
					rootEl.removeChild(items[id]);
					rootEl.appendChild(items[id]);
				}
			});
		},


		/**
		 * Save the current sorting
		 */
		save: function () {
			var store = this.options.store;
			store && store.set(this);
		},


		/**
		 * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
		 * @param   {HTMLElement}  el
		 * @param   {String}       [selector]  default: `options.draggable`
		 * @returns {HTMLElement|null}
		 */
		closest: function (el, selector) {
			return _closest(el, selector || this.options.draggable, this.el);
		},


		/**
		 * Set/get option
		 * @param   {string} name
		 * @param   {*}      [value]
		 * @returns {*}
		 */
		option: function (name, value) {
			var options = this.options;

			if (value === void 0) {
				return options[name];
			} else {
				options[name] = value;

				if (name === 'group') {
					_prepareGroup(options);
				}
			}
		},


		/**
		 * Destroy
		 */
		destroy: function () {
			var el = this.el;

			el[expando] = null;

			_off(el, 'mousedown', this._onTapStart);
			_off(el, 'touchstart', this._onTapStart);

			if (this.nativeDraggable) {
				_off(el, 'dragover', this);
				_off(el, 'dragenter', this);
			}

			// Remove draggable attributes
			Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
				el.removeAttribute('draggable');
			});

			touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);

			this._onDrop();

			this.el = el = null;
		}
	};


	function _cloneHide(state) {
		if (cloneEl && (cloneEl.state !== state)) {
			_css(cloneEl, 'display', state ? 'none' : '');
			!state && cloneEl.state && rootEl.insertBefore(cloneEl, dragEl);
			cloneEl.state = state;
		}
	}


	function _closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
		if (el) {
			ctx = ctx || document;

			do {
				if ((selector === '>*' && el.parentNode === ctx) || _matches(el, selector)) {
					return el;
				}
				/* jshint boss:true */
			} while (el = _getParentOrHost(el));
		}

		return null;
	}


	function _getParentOrHost(el) {
		var parent = el.host;

		return (parent && parent.nodeType) ? parent : el.parentNode;
	}


	function _globalDragOver(/**Event*/evt) {
		if (evt.dataTransfer) {
			evt.dataTransfer.dropEffect = 'move';
		}
		evt.preventDefault();
	}


	function _on(el, event, fn) {
		el.addEventListener(event, fn, false);
	}


	function _off(el, event, fn) {
		el.removeEventListener(event, fn, false);
	}


	function _toggleClass(el, name, state) {
		if (el) {
			if (el.classList) {
				el.classList[state ? 'add' : 'remove'](name);
			}
			else {
				var className = (' ' + el.className + ' ').replace(RSPACE, ' ').replace(' ' + name + ' ', ' ');
				el.className = (className + (state ? ' ' + name : '')).replace(RSPACE, ' ');
			}
		}
	}


	function _css(el, prop, val) {
		var style = el && el.style;

		if (style) {
			if (val === void 0) {
				if (document.defaultView && document.defaultView.getComputedStyle) {
					val = document.defaultView.getComputedStyle(el, '');
				}
				else if (el.currentStyle) {
					val = el.currentStyle;
				}

				return prop === void 0 ? val : val[prop];
			}
			else {
				if (!(prop in style)) {
					prop = '-webkit-' + prop;
				}

				style[prop] = val + (typeof val === 'string' ? '' : 'px');
			}
		}
	}


	function _find(ctx, tagName, iterator) {
		if (ctx) {
			var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;

			if (iterator) {
				for (; i < n; i++) {
					iterator(list[i], i);
				}
			}

			return list;
		}

		return [];
	}



	function _dispatchEvent(sortable, rootEl, name, targetEl, fromEl, startIndex, newIndex) {
		sortable = (sortable || rootEl[expando]);

		var evt = document.createEvent('Event'),
			options = sortable.options,
			onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);

		evt.initEvent(name, true, true);

		evt.to = rootEl;
		evt.from = fromEl || rootEl;
		evt.item = targetEl || rootEl;
		evt.clone = cloneEl;

		evt.oldIndex = startIndex;
		evt.newIndex = newIndex;

		rootEl.dispatchEvent(evt);

		if (options[onName]) {
			options[onName].call(sortable, evt);
		}
	}


	function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt) {
		var evt,
			sortable = fromEl[expando],
			onMoveFn = sortable.options.onMove,
			retVal;

		evt = document.createEvent('Event');
		evt.initEvent('move', true, true);

		evt.to = toEl;
		evt.from = fromEl;
		evt.dragged = dragEl;
		evt.draggedRect = dragRect;
		evt.related = targetEl || toEl;
		evt.relatedRect = targetRect || toEl.getBoundingClientRect();

		fromEl.dispatchEvent(evt);

		if (onMoveFn) {
			retVal = onMoveFn.call(sortable, evt, originalEvt);
		}

		return retVal;
	}


	function _disableDraggable(el) {
		el.draggable = false;
	}


	function _unsilent() {
		_silent = false;
	}


	/** @returns {HTMLElement|false} */
	function _ghostIsLast(el, evt) {
		var lastEl = el.lastElementChild,
			rect = lastEl.getBoundingClientRect();

		// 5 — min delta
		// abs — нельзя добавлять, а то глюки при наведении сверху
		return (
			(evt.clientY - (rect.top + rect.height) > 5) ||
			(evt.clientX - (rect.right + rect.width) > 5)
		) && lastEl;
	}


	/**
	 * Generate id
	 * @param   {HTMLElement} el
	 * @returns {String}
	 * @private
	 */
	function _generateId(el) {
		var str = el.tagName + el.className + el.src + el.href + el.textContent,
			i = str.length,
			sum = 0;

		while (i--) {
			sum += str.charCodeAt(i);
		}

		return sum.toString(36);
	}

	/**
	 * Returns the index of an element within its parent for a selected set of
	 * elements
	 * @param  {HTMLElement} el
	 * @param  {selector} selector
	 * @return {number}
	 */
	function _index(el, selector) {
		var index = 0;

		if (!el || !el.parentNode) {
			return -1;
		}

		while (el && (el = el.previousElementSibling)) {
			if ((el.nodeName.toUpperCase() !== 'TEMPLATE') && (selector === '>*' || _matches(el, selector))) {
				index++;
			}
		}

		return index;
	}

	function _matches(/**HTMLElement*/el, /**String*/selector) {
		if (el) {
			selector = selector.split('.');

			var tag = selector.shift().toUpperCase(),
				re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');

			return (
				(tag === '' || el.nodeName.toUpperCase() == tag) &&
				(!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length)
			);
		}

		return false;
	}

	function _throttle(callback, ms) {
		var args, _this;

		return function () {
			if (args === void 0) {
				args = arguments;
				_this = this;

				setTimeout(function () {
					if (args.length === 1) {
						callback.call(_this, args[0]);
					} else {
						callback.apply(_this, args);
					}

					args = void 0;
				}, ms);
			}
		};
	}

	function _extend(dst, src) {
		if (dst && src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) {
					dst[key] = src[key];
				}
			}
		}

		return dst;
	}

	function _clone(el) {
		return $
			? $(el).clone(true)[0]
			: (Polymer && Polymer.dom
				? Polymer.dom(el).cloneNode(true)
				: el.cloneNode(true)
			);
	}


	// Export utils
	Sortable.utils = {
		on: _on,
		off: _off,
		css: _css,
		find: _find,
		is: function (el, selector) {
			return !!_closest(el, selector, el);
		},
		extend: _extend,
		throttle: _throttle,
		closest: _closest,
		toggleClass: _toggleClass,
		clone: _clone,
		index: _index
	};


	/**
	 * Create sortable instance
	 * @param {HTMLElement}  el
	 * @param {Object}      [options]
	 */
	Sortable.create = function (el, options) {
		return new Sortable(el, options);
	};


	// Export
	Sortable.version = '1.4.2';
	return Sortable;
});


/***/ }),

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./boards/components/board.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_Sortable__ = __webpack_require__("../../../vendor/assets/javascripts/Sortable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_Sortable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendor_Sortable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__board_list_vue__ = __webpack_require__("./boards/components/board_list.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__board_blank_state__ = __webpack_require__("./boards/components/board_blank_state.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__board_delete__ = __webpack_require__("./boards/components/board_delete.js");
/* eslint-disable comma-dangle, space-before-function-paren, one-var */







var Store = gl.issueBoards.BoardsStore;

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.Board = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].extend({
  template: '#js-board-template',
  components: {
    boardList: __WEBPACK_IMPORTED_MODULE_3__board_list_vue__["a" /* default */],
    'board-delete': gl.issueBoards.BoardDelete,
    boardBlankState: __WEBPACK_IMPORTED_MODULE_4__board_blank_state__["a" /* default */]
  },
  props: {
    list: Object,
    disabled: Boolean,
    issueLinkBase: String,
    rootPath: String,
    boardId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      detailIssue: Store.detail,
      filter: Store.filter
    };
  },

  watch: {
    filter: {
      handler: function handler() {
        this.list.page = 1;
        this.list.getIssues(true).catch(function () {
          // TODO: handle request error
        });
      },

      deep: true
    },
    detailIssue: {
      handler: function handler() {
        if (!Object.keys(this.detailIssue.issue).length) return;

        var issue = this.list.findIssue(this.detailIssue.issue.id);

        if (issue) {
          var offsetLeft = this.$el.offsetLeft;
          var boardsList = document.querySelectorAll('.boards-list')[0];
          var left = boardsList.scrollLeft - offsetLeft;
          var right = offsetLeft + this.$el.offsetWidth;

          if (window.innerWidth > 768 && boardsList.classList.contains('is-compact')) {
            // -290 here because width of boardsList is animating so therefore
            // getting the width here is incorrect
            // 290 is the width of the sidebar
            right -= boardsList.offsetWidth - 290;
          } else {
            right -= boardsList.offsetWidth;
          }

          if (right - boardsList.scrollLeft > 0) {
            $(boardsList).animate({
              scrollLeft: right
            }, this.sortableOptions.animation);
          } else if (left > 0) {
            $(boardsList).animate({
              scrollLeft: offsetLeft
            }, this.sortableOptions.animation);
          }
        }
      },

      deep: true
    }
  },
  methods: {
    showNewIssueForm: function showNewIssueForm() {
      this.$refs['board-list'].showIssueForm = !this.$refs['board-list'].showIssueForm;
    },
    toggleExpanded: function toggleExpanded(e) {
      if (this.list.isExpandable && !e.target.classList.contains('js-no-trigger-collapse')) {
        this.list.isExpanded = !this.list.isExpanded;

        if (__WEBPACK_IMPORTED_MODULE_2__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe()) {
          localStorage.setItem('boards.' + this.boardId + '.' + this.list.type + '.expanded', this.list.isExpanded);
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.sortableOptions = gl.issueBoards.getBoardSortableDefaultOptions({
      disabled: this.disabled,
      group: 'boards',
      draggable: '.is-draggable',
      handle: '.js-board-handle',
      onEnd: function onEnd(e) {
        gl.issueBoards.onEnd();

        if (e.newIndex !== undefined && e.oldIndex !== e.newIndex) {
          var order = _this.sortable.toArray();
          var list = Store.findList('id', parseInt(e.item.dataset.id, 10));

          _this.$nextTick(function () {
            Store.moveList(list, order);
          });
        }
      }
    });

    this.sortable = __WEBPACK_IMPORTED_MODULE_0_vendor_Sortable___default.a.create(this.$el.parentNode, this.sortableOptions);
  },
  created: function created() {
    if (this.list.isExpandable && __WEBPACK_IMPORTED_MODULE_2__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe()) {
      var isCollapsed = localStorage.getItem('boards.' + this.boardId + '.' + this.list.type + '.expanded') === 'false';

      this.list.isExpanded = !isCollapsed;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/components/board_blank_state.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* global ListLabel */




var Store = gl.issueBoards.BoardsStore;

/* harmony default export */ __webpack_exports__["a"] = ({
  template: '\n    <div class="board-blank-state">\n      <p>\n        \u53EA\u9700\u70B9\u51FB\u4E00\u4E0B\uFF0C\u5373\u53EF\u5C06\u4EE5\u4E0B\u9ED8\u8BA4\u5217\u8868\u6DFB\u52A0\u5230\u95EE\u9898\u770B\u677F\uFF1A\n      </p>\n      <ul class="board-blank-state-list">\n        <li v-for="label in predefinedLabels">\n          <span\n            class="label-color"\n            :style="{ backgroundColor: label.color }">\n          </span>\n          {{ label.title }}\n        </li>\n      </ul>\n      <p>\n        \u4F7F\u7528\u9ED8\u8BA4\u5217\u8868\u5C06\u8BA9\u60A8\u80FD\u6B63\u786E\u5E76\u5145\u5206\u5730\u5229\u7528\u60A8\u7684\u7684\u95EE\u9898\u770B\u677F\u3002\n      </p>\n      <button\n        class="btn btn-create btn-inverted btn-block"\n        type="button"\n        @click.stop="addDefaultLists">\n        \u6DFB\u52A0\u9ED8\u8BA4\u5217\u8868\n      </button>\n      <button\n        class="btn btn-default btn-block"\n        type="button"\n        @click.stop="clearBlankState">\n        \u6CA1\u5173\u7CFB\uFF0C\u6211\u5C06\u81EA\u5DF1\u521B\u5EFA\u5217\u8868\n      </button>\n    </div>\n  ',
  data: function data() {
    return {
      predefinedLabels: [new ListLabel({ title: 'To Do', color: '#F0AD4E' }), new ListLabel({ title: 'Doing', color: '#5CB85C' })]
    };
  },

  methods: {
    addDefaultLists: function addDefaultLists() {
      this.clearBlankState();

      this.predefinedLabels.forEach(function (label, i) {
        Store.addList({
          title: label.title,
          position: i,
          list_type: 'label',
          label: {
            title: label.title,
            color: label.color
          }
        });
      });

      Store.state.lists = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortBy(Store.state.lists, 'position');

      // Save the labels
      gl.boardService.generateDefaultLists().then(function (res) {
        return res.data;
      }).then(function (data) {
        data.forEach(function (listObj) {
          var list = Store.findList('title', listObj.title);

          list.id = listObj.id;
          list.label.id = listObj.label.id;
          list.getIssues().catch(function () {
            // TODO: handle request error
          });
        });
      }).catch(function () {
        Store.removeList(undefined, 'label');
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.remove('issue_board_welcome_hidden', {
          path: ''
        });
        Store.addBlankState();
      });
    },

    clearBlankState: Store.removeBlankState.bind(Store)
  }
});

/***/ }),

/***/ "./boards/components/board_delete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable comma-dangle, space-before-function-paren, no-alert */



window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.BoardDelete = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    list: Object
  },
  methods: {
    deleteBoard: function deleteBoard() {
      $(this.$el).tooltip('hide');

      if (confirm('您确定要删除这个列表？')) {
        this.list.destroy();
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/components/board_list.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/vendor/assets/javascripts/Sortable.js
var Sortable = __webpack_require__("../../../vendor/assets/javascripts/Sortable.js");
var Sortable_default = /*#__PURE__*/__webpack_require__.n(Sortable);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./boards/components/board_new_issue.vue
var board_new_issue = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./boards/components/board_new_issue.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9de8df4","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./boards/components/board_new_issue.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board-new-issue-form"},[_c('div',{staticClass:"card"},[_c('form',{on:{"submit":function($event){_vm.submit($event)}}},[(_vm.error)?_c('div',{staticClass:"flash-container"},[_c('div',{staticClass:"flash-alert"},[_vm._v("\n          出现错误，请重试。\n        ")])]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"label-light",attrs:{"for":_vm.list.id + '-title'}},[_vm._v("\n        标题\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],ref:"input",staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","id":_vm.list.id + '-title'},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),(_vm.groupId)?_c('project-select',{attrs:{"group-id":_vm.groupId}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix prepend-top-10"},[_c('button',{ref:"submit-button",staticClass:"btn btn-success pull-left",attrs:{"type":"submit","disabled":_vm.disabled}},[_vm._v("\n          提交问题\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default pull-right",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n          取消\n        ")])])],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./boards/components/board_new_issue.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  board_new_issue["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_board_new_issue = (Component.exports);

// EXTERNAL MODULE: ./boards/components/issue_card_inner.js
var issue_card_inner = __webpack_require__("./boards/components/issue_card_inner.js");

// EXTERNAL MODULE: ./boards/eventhub.js
var eventhub = __webpack_require__("./boards/eventhub.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./boards/components/board_card.vue

/* eslint-disable vue/require-default-prop */



var Store = gl.issueBoards.BoardsStore;

/* harmony default export */ var board_card = ({
  name: 'BoardsIssueCard',
  components: {
    'issue-card-inner': gl.issueBoards.IssueCardInner
  },
  props: {
    list: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    issue: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    issueLinkBase: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    rootPath: {
      type: String,
      default: ''
    },
    groupId: {
      type: Number
    }
  },
  data: function data() {
    return {
      showDetail: false,
      detailIssue: Store.detail
    };
  },

  computed: {
    issueDetailVisible: function issueDetailVisible() {
      return this.detailIssue.issue && this.detailIssue.issue.id === this.issue.id;
    }
  },
  methods: {
    mouseDown: function mouseDown() {
      this.showDetail = true;
    },
    mouseMove: function mouseMove() {
      this.showDetail = false;
    },
    showIssue: function showIssue(e) {
      if (e.target.classList.contains('js-no-trigger')) return;

      if (this.showDetail) {
        this.showDetail = false;

        if (Store.detail.issue && Store.detail.issue.id === this.issue.id) {
          eventhub["a" /* default */].$emit('clearDetailIssue');
        } else {
          eventhub["a" /* default */].$emit('newDetailIssue', this.issue);
          Store.detail.list = this.list;
        }
      }
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8a4f3ca","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./boards/components/board_card.vue
var board_card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"card",class:{
    'user-can-drag': !_vm.disabled && _vm.issue.id,
    'is-disabled': _vm.disabled || !_vm.issue.id,
    'is-active': _vm.issueDetailVisible
  },attrs:{"index":_vm.index,"data-issue-id":_vm.issue.id},on:{"mousedown":_vm.mouseDown,"mousemove":_vm.mouseMove,"mouseup":function($event){_vm.showIssue($event)}}},[_c('issue-card-inner',{attrs:{"list":_vm.list,"issue":_vm.issue,"issue-link-base":_vm.issueLinkBase,"group-id":_vm.groupId,"root-path":_vm.rootPath,"update-filters":true}})],1)}
var board_card_staticRenderFns = []

// CONCATENATED MODULE: ./boards/components/board_card.vue
/* script */


/* template */

/* template functional */
var board_card___vue_template_functional__ = false
/* styles */
var board_card___vue_styles__ = null
/* scopeId */
var board_card___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var board_card___vue_module_identifier__ = null

var board_card_Component = Object(component_normalizer["a" /* default */])(
  board_card,
  board_card_render,
  board_card_staticRenderFns,
  board_card___vue_template_functional__,
  board_card___vue_styles__,
  board_card___vue_scopeId__,
  board_card___vue_module_identifier__
)

/* harmony default export */ var components_board_card = (board_card_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./boards/components/board_list.vue







var board_list_Store = gl.issueBoards.BoardsStore;

/* harmony default export */ var board_list = ({
  name: 'BoardList',
  components: {
    boardCard: components_board_card,
    boardNewIssue: components_board_new_issue,
    loadingIcon: loading_icon["a" /* default */]
  },
  props: {
    groupId: {
      type: Number,
      required: false,
      default: 0
    },
    disabled: {
      type: Boolean,
      required: true
    },
    list: {
      type: Object,
      required: true
    },
    issues: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    issueLinkBase: {
      type: String,
      required: true
    },
    rootPath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      scrollOffset: 250,
      filters: board_list_Store.state.filters,
      showCount: false,
      showIssueForm: false
    };
  },

  watch: {
    filters: {
      handler: function handler() {
        this.list.loadingMore = false;
        this.$refs.list.scrollTop = 0;
      },

      deep: true
    },
    issues: function issues() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.scrollHeight() <= _this.listHeight() && _this.list.issuesSize > _this.list.issues.length) {
          _this.list.page += 1;
          _this.list.getIssues(false).catch(function () {
            // TODO: handle request error
          });
        }

        if (_this.scrollHeight() > Math.ceil(_this.listHeight())) {
          _this.showCount = true;
        } else {
          _this.showCount = false;
        }
      });
    }
  },
  created: function created() {
    eventhub["a" /* default */].$on('hide-issue-form-' + this.list.id, this.toggleForm);
    eventhub["a" /* default */].$on('scroll-board-list-' + this.list.id, this.scrollToTop);
  },
  mounted: function mounted() {
    var _this2 = this;

    var options = gl.issueBoards.getBoardSortableDefaultOptions({
      scroll: true,
      group: 'issues',
      disabled: this.disabled,
      filter: '.board-list-count, .is-disabled',
      dataIdAttr: 'data-issue-id',
      onStart: function onStart(e) {
        var card = _this2.$refs.issue[e.oldIndex];

        card.showDetail = false;
        board_list_Store.moving.list = card.list;
        board_list_Store.moving.issue = board_list_Store.moving.list.findIssue(+e.item.dataset.issueId);

        gl.issueBoards.onStart();
      },
      onAdd: function onAdd(e) {
        gl.issueBoards.BoardsStore.moveIssueToList(board_list_Store.moving.list, _this2.list, board_list_Store.moving.issue, e.newIndex);

        _this2.$nextTick(function () {
          e.item.remove();
        });
      },
      onUpdate: function onUpdate(e) {
        var sortedArray = _this2.sortable.toArray().filter(function (id) {
          return id !== '-1';
        });
        gl.issueBoards.BoardsStore.moveIssueInList(_this2.list, board_list_Store.moving.issue, e.oldIndex, e.newIndex, sortedArray);
      },
      onMove: function onMove(e) {
        return !e.related.classList.contains('board-list-count');
      }
    });

    this.sortable = Sortable_default.a.create(this.$refs.list, options);

    // Scroll event on list to load more
    this.$refs.list.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy: function beforeDestroy() {
    eventhub["a" /* default */].$off('hide-issue-form-' + this.list.id, this.toggleForm);
    eventhub["a" /* default */].$off('scroll-board-list-' + this.list.id, this.scrollToTop);
    this.$refs.list.removeEventListener('scroll', this.onScroll);
  },

  methods: {
    listHeight: function listHeight() {
      return this.$refs.list.getBoundingClientRect().height;
    },
    scrollHeight: function scrollHeight() {
      return this.$refs.list.scrollHeight;
    },
    scrollTop: function scrollTop() {
      return this.$refs.list.scrollTop + this.listHeight();
    },
    scrollToTop: function scrollToTop() {
      this.$refs.list.scrollTop = 0;
    },
    loadNextPage: function loadNextPage() {
      var _this3 = this;

      var getIssues = this.list.nextPage();
      var loadingDone = function loadingDone() {
        _this3.list.loadingMore = false;
      };

      if (getIssues) {
        this.list.loadingMore = true;
        getIssues.then(loadingDone).catch(loadingDone);
      }
    },
    toggleForm: function toggleForm() {
      this.showIssueForm = !this.showIssueForm;
    },
    onScroll: function onScroll() {
      if (!this.loadingMore && this.scrollTop() > this.scrollHeight() - this.scrollOffset) {
        this.loadNextPage();
      }
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd7bff00","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./boards/components/board_list.vue
var board_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board-list-component"},[(_vm.loading)?_c('div',{staticClass:"board-list-loading text-center",attrs:{"aria-label":"Loading issues"}},[_c('loading-icon')],1):_vm._e(),_vm._v(" "),(_vm.list.type !== 'closed' && _vm.showIssueForm)?_c('board-new-issue',{attrs:{"group-id":_vm.groupId,"list":_vm.list}}):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"list",staticClass:"board-list",class:{ 'is-smaller': _vm.showIssueForm },attrs:{"data-board":_vm.list.id}},[_vm._l((_vm.issues),function(issue,index){return _c('board-card',{key:issue.id,ref:"issue",refInFor:true,attrs:{"index":index,"list":_vm.list,"issue":issue,"issue-link-base":_vm.issueLinkBase,"group-id":_vm.groupId,"root-path":_vm.rootPath,"disabled":_vm.disabled}})}),_vm._v(" "),(_vm.showCount)?_c('li',{staticClass:"board-list-count text-center",attrs:{"data-issue-id":"-1"}},[_c('loading-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.list.loadingMore),expression:"list.loadingMore"}],attrs:{"label":"Loading more issues"}}),_vm._v(" "),(_vm.list.issues.length === _vm.list.issuesSize)?_c('span',[_vm._v("\n        Showing all issues\n      ")]):_c('span',[_vm._v("\n        Showing "+_vm._s(_vm.list.issues.length)+" of "+_vm._s(_vm.list.issuesSize)+" issues\n      ")])],1):_vm._e()],2)],1)}
var board_list_staticRenderFns = []

// CONCATENATED MODULE: ./boards/components/board_list.vue
/* script */


/* template */

/* template functional */
var board_list___vue_template_functional__ = false
/* styles */
var board_list___vue_styles__ = null
/* scopeId */
var board_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var board_list___vue_module_identifier__ = null

var board_list_Component = Object(component_normalizer["a" /* default */])(
  board_list,
  board_list_render,
  board_list_staticRenderFns,
  board_list___vue_template_functional__,
  board_list___vue_styles__,
  board_list___vue_scopeId__,
  board_list___vue_module_identifier__
)

/* harmony default export */ var components_board_list = __webpack_exports__["a"] = (board_list_Component.exports);


/***/ }),

/***/ "./boards/components/board_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__right_sidebar__ = __webpack_require__("./right_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sidebar_event_hub__ = __webpack_require__("./sidebar/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sidebar_components_assignees_assignee_title__ = __webpack_require__("./sidebar/components/assignees/assignee_title.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sidebar_components_assignees_assignees_vue__ = __webpack_require__("./sidebar/components/assignees/assignees.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__due_date_select__ = __webpack_require__("./due_date_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sidebar_remove_issue__ = __webpack_require__("./boards/components/sidebar/remove_issue.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__issuable_context__ = __webpack_require__("./issuable_context.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__labels_select__ = __webpack_require__("./labels_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sidebar_components_subscriptions_subscriptions_vue__ = __webpack_require__("./sidebar/components/subscriptions/subscriptions.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__milestone_select__ = __webpack_require__("./milestone_select.js");
/* eslint-disable comma-dangle, space-before-function-paren, no-new */















var Store = gl.issueBoards.BoardsStore;

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.BoardSidebar = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    currentUser: Object
  },
  data: function data() {
    return {
      detail: Store.detail,
      issue: {},
      list: {},
      loadingAssignees: false
    };
  },

  computed: {
    showSidebar: function showSidebar() {
      return Object.keys(this.issue).length;
    },
    milestoneTitle: function milestoneTitle() {
      return this.issue.milestone ? this.issue.milestone.title : 'No Milestone';
    },
    canRemove: function canRemove() {
      return !this.list.preset;
    }
  },
  watch: {
    detail: {
      handler: function handler() {
        var _this = this;

        if (this.issue.id !== this.detail.issue.id) {
          $('.block.assignee').find('input:not(.js-vue)[name="issue[assignee_ids][]"]').each(function (i, el) {
            $(el).remove();
          });

          $('.js-issue-board-sidebar', this.$el).each(function (i, el) {
            $(el).data('glDropdown').clearMenu();
          });
        }

        this.issue = this.detail.issue;
        this.list = this.detail.list;

        this.$nextTick(function () {
          _this.endpoint = _this.$refs.assigneeDropdown.dataset.issueUpdate;
        });
      },

      deep: true
    }
  },
  methods: {
    closeSidebar: function closeSidebar() {
      this.detail.issue = {};
    },
    assignSelf: function assignSelf() {
      // Notify gl dropdown that we are now assigning to current user
      this.$refs.assigneeBlock.dispatchEvent(new Event('assignYourself'));

      this.addAssignee(this.currentUser);
      this.saveAssignees();
    },
    removeAssignee: function removeAssignee(a) {
      gl.issueBoards.BoardsStore.detail.issue.removeAssignee(a);
    },
    addAssignee: function addAssignee(a) {
      gl.issueBoards.BoardsStore.detail.issue.addAssignee(a);
    },
    removeAllAssignees: function removeAllAssignees() {
      gl.issueBoards.BoardsStore.detail.issue.removeAllAssignees();
    },
    saveAssignees: function saveAssignees() {
      var _this2 = this;

      this.loadingAssignees = true;

      gl.issueBoards.BoardsStore.detail.issue.update(this.endpoint).then(function () {
        _this2.loadingAssignees = false;
      }).catch(function () {
        _this2.loadingAssignees = false;
        Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('An error occurred while saving assignees'));
      });
    }
  },
  created: function created() {
    // Get events from glDropdown
    __WEBPACK_IMPORTED_MODULE_4__sidebar_event_hub__["a" /* default */].$on('sidebar.removeAssignee', this.removeAssignee);
    __WEBPACK_IMPORTED_MODULE_4__sidebar_event_hub__["a" /* default */].$on('sidebar.addAssignee', this.addAssignee);
    __WEBPACK_IMPORTED_MODULE_4__sidebar_event_hub__["a" /* default */].$on('sidebar.removeAllAssignees', this.removeAllAssignees);
    __WEBPACK_IMPORTED_MODULE_4__sidebar_event_hub__["a" /* default */].$on('sidebar.saveAssignees', this.saveAssignees);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_4__sidebar_event_hub__["a" /* default */].$off('sidebar.removeAssignee', this.removeAssignee);
    __WEBPACK_IMPORTED_MODULE_4__sidebar_event_hub__["a" /* default */].$off('sidebar.addAssignee', this.addAssignee);
    __WEBPACK_IMPORTED_MODULE_4__sidebar_event_hub__["a" /* default */].$off('sidebar.removeAllAssignees', this.removeAllAssignees);
    __WEBPACK_IMPORTED_MODULE_4__sidebar_event_hub__["a" /* default */].$off('sidebar.saveAssignees', this.saveAssignees);
  },
  mounted: function mounted() {
    new __WEBPACK_IMPORTED_MODULE_9__issuable_context__["a" /* default */](this.currentUser);
    new __WEBPACK_IMPORTED_MODULE_12__milestone_select__["a" /* default */]();
    new __WEBPACK_IMPORTED_MODULE_7__due_date_select__["a" /* default */]();
    new __WEBPACK_IMPORTED_MODULE_10__labels_select__["a" /* default */]();
    new __WEBPACK_IMPORTED_MODULE_3__right_sidebar__["a" /* default */]();
  },

  components: {
    assigneeTitle: __WEBPACK_IMPORTED_MODULE_5__sidebar_components_assignees_assignee_title__["a" /* default */],
    assignees: __WEBPACK_IMPORTED_MODULE_6__sidebar_components_assignees_assignees_vue__["a" /* default */],
    removeBtn: gl.issueBoards.RemoveIssueBtn,
    subscriptions: __WEBPACK_IMPORTED_MODULE_11__sidebar_components_subscriptions_subscriptions_vue__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/components/issue_card_inner.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_link_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventhub__ = __webpack_require__("./boards/eventhub.js");




var Store = gl.issueBoards.BoardsStore;

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.IssueCardInner = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    issue: {
      type: Object,
      required: true
    },
    issueLinkBase: {
      type: String,
      required: true
    },
    list: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    rootPath: {
      type: String,
      required: true
    },
    updateFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    groupId: {
      type: Number,
      required: false
    }
  },
  data: function data() {
    return {
      limitBeforeCounter: 3,
      maxRender: 4,
      maxCounter: 99
    };
  },

  components: {
    userAvatarLink: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_link_vue__["a" /* default */]
  },
  computed: {
    numberOverLimit: function numberOverLimit() {
      return this.issue.assignees.length - this.limitBeforeCounter;
    },
    assigneeCounterTooltip: function assigneeCounterTooltip() {
      return this.assigneeCounterLabel + ' more';
    },
    assigneeCounterLabel: function assigneeCounterLabel() {
      if (this.numberOverLimit > this.maxCounter) {
        return this.maxCounter + '+';
      }

      return '+' + this.numberOverLimit;
    },
    shouldRenderCounter: function shouldRenderCounter() {
      if (this.issue.assignees.length <= this.maxRender) {
        return false;
      }

      return this.issue.assignees.length > this.numberOverLimit;
    },
    cardUrl: function cardUrl() {
      var baseUrl = this.issueLinkBase;

      if (this.groupId && this.issue.project) {
        baseUrl = this.issueLinkBase.replace(':project_path', this.issue.project.path);
      }

      return baseUrl + '/' + this.issue.iid;
    },
    issueId: function issueId() {
      if (this.issue.iid) {
        return '#' + this.issue.iid;
      }
      return false;
    },
    showLabelFooter: function showLabelFooter() {
      var _this = this;

      return this.issue.labels.find(function (l) {
        return _this.showLabel(l);
      }) !== undefined;
    }
  },
  methods: {
    isIndexLessThanlimit: function isIndexLessThanlimit(index) {
      return index < this.limitBeforeCounter;
    },
    shouldRenderAssignee: function shouldRenderAssignee(index) {
      // Eg. maxRender is 4,
      // Render up to all 4 assignees if there are only 4 assigness
      // Otherwise render up to the limitBeforeCounter
      if (this.issue.assignees.length <= this.maxRender) {
        return index < this.maxRender;
      }

      return index < this.limitBeforeCounter;
    },
    assigneeUrl: function assigneeUrl(assignee) {
      return '' + this.rootPath + assignee.username;
    },
    assigneeUrlTitle: function assigneeUrlTitle(assignee) {
      return 'Assigned to ' + assignee.name;
    },
    avatarUrlTitle: function avatarUrlTitle(assignee) {
      return 'Avatar for ' + assignee.name;
    },
    showLabel: function showLabel(label) {
      if (!label.id) return false;
      return true;
    },
    filterByLabel: function filterByLabel(label, e) {
      if (!this.updateFilters) return;

      var filterPath = gl.issueBoards.BoardsStore.filter.path.split('&');
      var labelTitle = encodeURIComponent(label.title);
      var param = 'label_name[]=' + labelTitle;
      var labelIndex = filterPath.indexOf(param);
      $(e.currentTarget).tooltip('hide');

      if (labelIndex === -1) {
        filterPath.push(param);
      } else {
        filterPath.splice(labelIndex, 1);
      }

      gl.issueBoards.BoardsStore.filter.path = filterPath.join('&');

      Store.updateFiltersUrl();

      __WEBPACK_IMPORTED_MODULE_2__eventhub__["a" /* default */].$emit('updateTokens');
    },
    labelStyle: function labelStyle(label) {
      return {
        backgroundColor: label.color,
        color: label.textColor
      };
    }
  },
  template: '\n    <div>\n      <div class="card-header">\n        <h4 class="card-title">\n          <i\n            class="fa fa-eye-slash confidential-icon"\n            v-if="issue.confidential"\n            aria-hidden="true"\n          />\n          <a\n            class="js-no-trigger"\n            :href="cardUrl"\n            :title="issue.title">{{ issue.title }}</a>\n          <span\n            class="card-number"\n            v-if="issueId"\n          >\n            <template v-if="groupId && issue.project">{{issue.project.path}}</template>{{ issueId }}\n          </span>\n        </h4>\n        <div class="card-assignee">\n          <user-avatar-link\n            v-for="(assignee, index) in issue.assignees"\n            :key="assignee.id"\n            v-if="shouldRenderAssignee(index)"\n            class="js-no-trigger"\n            :link-href="assigneeUrl(assignee)"\n            :img-alt="avatarUrlTitle(assignee)"\n            :img-src="assignee.avatar"\n            :tooltip-text="assigneeUrlTitle(assignee)"\n            tooltip-placement="bottom"\n          />\n          <span\n            class="avatar-counter has-tooltip"\n            :title="assigneeCounterTooltip"\n            v-if="shouldRenderCounter"\n          >\n           {{ assigneeCounterLabel }}\n          </span>\n        </div>\n      </div>\n      <div\n        class="card-footer"\n        v-if="showLabelFooter"\n      >\n        <button\n          class="label color-label has-tooltip"\n          v-for="label in issue.labels"\n          type="button"\n          v-if="showLabel(label)"\n          @click="filterByLabel(label, $event)"\n          :style="labelStyle(label)"\n          :title="label.description"\n          data-container="body">\n          {{ label.title }}\n        </button>\n      </div>\n    </div>\n  '
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/components/modal/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: ./boards/utils/query_data.js
var query_data = __webpack_require__("./boards/utils/query_data.js");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./boards/filtered_search_boards.js
var filtered_search_boards = __webpack_require__("./boards/filtered_search_boards.js");

// EXTERNAL MODULE: ./filtered_search/container.js
var container = __webpack_require__("./filtered_search/container.js");

// CONCATENATED MODULE: ./boards/components/modal/filters.js



/* harmony default export */ var filters = ({
  name: 'modal-filters',
  props: {
    store: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    container["a" /* default */].container = this.$el;

    this.filteredSearch = new filtered_search_boards["a" /* default */](this.store);
    this.filteredSearch.setup();
    this.filteredSearch.removeTokens();
    this.filteredSearch.handleInputPlaceholder();
    this.filteredSearch.toggleClearSearchButton();
  },
  destroyed: function destroyed() {
    this.filteredSearch.cleanup();
    container["a" /* default */].container = document;
    this.store.path = '';
  },

  template: '#js-board-modal-filter'
});
// CONCATENATED MODULE: ./boards/components/modal/tabs.js


var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalTabs = vue_esm["a" /* default */].extend({
  mixins: [gl.issueBoards.ModalMixins],
  data: function data() {
    return ModalStore.store;
  },

  computed: {
    selectedCount: function selectedCount() {
      return ModalStore.selectedCount();
    }
  },
  destroyed: function destroyed() {
    this.activeTab = 'all';
  },

  template: '\n    <div class="top-area prepend-top-10 append-bottom-10">\n      <ul class="nav-links issues-state-filters">\n        <li :class="{ \'active\': activeTab == \'all\' }">\n          <a\n            href="#"\n            role="button"\n            @click.prevent="changeTab(\'all\')">\n            Open issues\n            <span class="badge">\n              {{ issuesCount }}\n            </span>\n          </a>\n        </li>\n        <li :class="{ \'active\': activeTab == \'selected\' }">\n          <a\n            href="#"\n            role="button"\n            @click.prevent="changeTab(\'selected\')">\n            Selected issues\n            <span class="badge">\n              {{ selectedCount }}\n            </span>\n          </a>\n        </li>\n      </ul>\n    </div>\n  '
});
// CONCATENATED MODULE: ./boards/components/modal/header.js




var header_ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalHeader = vue_esm["a" /* default */].extend({
  mixins: [gl.issueBoards.ModalMixins],
  props: {
    projectId: {
      type: Number,
      required: true
    },
    milestonePath: {
      type: String,
      required: true
    },
    labelPath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return header_ModalStore.store;
  },

  computed: {
    selectAllText: function selectAllText() {
      if (header_ModalStore.selectedCount() !== this.issues.length || this.issues.length === 0) {
        return '全选';
      }

      return '取消全选';
    },
    showSearch: function showSearch() {
      return this.activeTab === 'all' && !this.loading && this.issuesCount > 0;
    }
  },
  methods: {
    toggleAll: function toggleAll() {
      this.$refs.selectAllBtn.blur();

      header_ModalStore.toggleAll();
    }
  },
  components: {
    'modal-tabs': gl.issueBoards.ModalTabs,
    modalFilters: filters
  },
  template: '\n    <div>\n      <header class="add-issues-header form-actions">\n        <h2>\n          \u6DFB\u52A0\u95EE\u9898\n          <button\n            type="button"\n            class="close"\n            data-dismiss="modal"\n            aria-label="\u5173\u95ED"\n            @click="toggleModal(false)">\n            <span aria-hidden="true">\xD7</span>\n          </button>\n        </h2>\n      </header>\n      <modal-tabs v-if="!loading && issuesCount > 0"></modal-tabs>\n      <div\n        class="add-issues-search append-bottom-10"\n        v-if="showSearch">\n        <modal-filters :store="filter" />\n        <button\n          type="button"\n          class="btn btn-success btn-inverted prepend-left-10"\n          ref="selectAllBtn"\n          @click="toggleAll">\n          {{ selectAllText }}\n        </button>\n      </div>\n    </div>\n  '
});
// EXTERNAL MODULE: ./breakpoints.js
var breakpoints = __webpack_require__("./breakpoints.js");

// CONCATENATED MODULE: ./boards/components/modal/list.js
/* global ListIssue */




var list_ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalList = vue_esm["a" /* default */].extend({
  props: {
    issueLinkBase: {
      type: String,
      required: true
    },
    rootPath: {
      type: String,
      required: true
    },
    emptyStateSvg: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return list_ModalStore.store;
  },

  watch: {
    activeTab: function activeTab() {
      if (this.activeTab === 'all') {
        list_ModalStore.purgeUnselectedIssues();
      }
    }
  },
  computed: {
    loopIssues: function loopIssues() {
      if (this.activeTab === 'all') {
        return this.issues;
      }

      return this.selectedIssues;
    },
    groupedIssues: function groupedIssues() {
      var _this = this;

      var groups = [];
      this.loopIssues.forEach(function (issue, i) {
        var index = i % _this.columns;

        if (!groups[index]) {
          groups.push([]);
        }

        groups[index].push(issue);
      });

      return groups;
    }
  },
  methods: {
    scrollHandler: function scrollHandler() {
      var currentPage = Math.floor(this.issues.length / this.perPage);

      if (this.scrollTop() > this.scrollHeight() - 100 && !this.loadingNewPage && currentPage === this.page) {
        this.loadingNewPage = true;
        this.page += 1;
      }
    },
    toggleIssue: function toggleIssue(e, issue) {
      if (e.target.tagName !== 'A') {
        list_ModalStore.toggleIssue(issue);
      }
    },
    listHeight: function listHeight() {
      return this.$refs.list.getBoundingClientRect().height;
    },
    scrollHeight: function scrollHeight() {
      return this.$refs.list.scrollHeight;
    },
    scrollTop: function scrollTop() {
      return this.$refs.list.scrollTop + this.listHeight();
    },
    showIssue: function showIssue(issue) {
      if (this.activeTab === 'all') return true;

      var index = list_ModalStore.selectedIssueIndex(issue);

      return index !== -1;
    },
    setColumnCount: function setColumnCount() {
      var breakpoint = breakpoints["a" /* default */].getBreakpointSize();

      if (breakpoint === 'lg' || breakpoint === 'md') {
        this.columns = 3;
      } else if (breakpoint === 'sm') {
        this.columns = 2;
      } else {
        this.columns = 1;
      }
    }
  },
  mounted: function mounted() {
    this.scrollHandlerWrapper = this.scrollHandler.bind(this);
    this.setColumnCountWrapper = this.setColumnCount.bind(this);
    this.setColumnCount();

    this.$refs.list.addEventListener('scroll', this.scrollHandlerWrapper);
    window.addEventListener('resize', this.setColumnCountWrapper);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.list.removeEventListener('scroll', this.scrollHandlerWrapper);
    window.removeEventListener('resize', this.setColumnCountWrapper);
  },

  components: {
    'issue-card-inner': gl.issueBoards.IssueCardInner
  },
  template: '\n    <section\n      class="add-issues-list add-issues-list-columns"\n      ref="list">\n      <div\n        class="empty-state add-issues-empty-state-filter text-center"\n        v-if="issuesCount > 0 && issues.length === 0">\n        <div\n          class="svg-content">\n          <img :src="emptyStateSvg"/>\n        </div>\n        <div class="text-content">\n          <h4>\n            There are no issues to show.\n          </h4>\n        </div>\n      </div>\n      <div\n        v-for="group in groupedIssues"\n        class="add-issues-list-column">\n        <div\n          v-for="issue in group"\n          v-if="showIssue(issue)"\n          class="card-parent">\n          <div\n            class="card"\n            :class="{ \'is-active\': issue.selected }"\n            @click="toggleIssue($event, issue)">\n            <issue-card-inner\n              :issue="issue"\n              :issue-link-base="issueLinkBase"\n              :root-path="rootPath">\n            </issue-card-inner>\n            <span\n              :aria-label="\'Issue #\' + issue.id + \' selected\'"\n              aria-checked="true"\n              v-if="issue.selected"\n              class="issue-card-selected text-center">\n              <i class="fa fa-check"></i>\n            </span>\n          </div>\n        </div>\n      </div>\n    </section>\n  '
});
// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// CONCATENATED MODULE: ./boards/components/modal/lists_dropdown.js


var lists_dropdown_ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalFooterListsDropdown = vue_esm["a" /* default */].extend({
  data: function data() {
    return {
      modal: lists_dropdown_ModalStore.store,
      state: gl.issueBoards.BoardsStore.state
    };
  },

  computed: {
    selected: function selected() {
      return this.modal.selectedList || this.state.lists[1];
    }
  },
  destroyed: function destroyed() {
    this.modal.selectedList = null;
  },

  template: '\n    <div class="dropdown inline">\n      <button\n        class="dropdown-menu-toggle"\n        type="button"\n        data-toggle="dropdown"\n        aria-expanded="false">\n        <span\n          class="dropdown-label-box"\n          :style="{ backgroundColor: selected.label.color }">\n        </span>\n        {{ selected.title }}\n        <i class="fa fa-chevron-down"></i>\n      </button>\n      <div class="dropdown-menu dropdown-menu-selectable dropdown-menu-drop-up">\n        <ul>\n          <li\n            v-for="list in state.lists"\n            v-if="list.type == \'label\'">\n            <a\n              href="#"\n              role="button"\n              :class="{ \'is-active\': list.id == selected.id }"\n              @click.prevent="modal.selectedList = list">\n              <span\n                class="dropdown-label-box"\n                :style="{ backgroundColor: list.label.color }">\n              </span>\n              {{ list.title }}\n            </a>\n          </li>\n        </ul>\n      </div>\n    </div>\n  '
});
// EXTERNAL MODULE: ./lib/utils/text_utility.js
var text_utility = __webpack_require__("./lib/utils/text_utility.js");

// CONCATENATED MODULE: ./boards/components/modal/footer.js






var footer_ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalFooter = vue_esm["a" /* default */].extend({
  mixins: [gl.issueBoards.ModalMixins],
  data: function data() {
    return {
      modal: footer_ModalStore.store,
      state: gl.issueBoards.BoardsStore.state
    };
  },

  computed: {
    submitDisabled: function submitDisabled() {
      return !footer_ModalStore.selectedCount();
    },
    submitText: function submitText() {
      var count = footer_ModalStore.selectedCount();

      return '\u6DFB\u52A0 ' + (count > 0 ? count : '') + ' ' + Object(text_utility["g" /* pluralize */])('问题', count);
    }
  },
  methods: {
    addIssues: function addIssues() {
      var firstListIndex = 1;
      var list = this.modal.selectedList || this.state.lists[firstListIndex];
      var selectedIssues = footer_ModalStore.getSelectedIssues();
      var issueIds = selectedIssues.map(function (issue) {
        return issue.id;
      });

      // Post the data to the backend
      gl.boardService.bulkUpdate(issueIds, {
        add_label_ids: [list.label.id]
      }).catch(function () {
        Object(flash["a" /* default */])(Object(locale["a" /* __ */])('Failed to update issues, please try again.'));

        selectedIssues.forEach(function (issue) {
          list.removeIssue(issue);
          list.issuesSize -= 1;
        });
      });

      // Add the issues on the frontend
      selectedIssues.forEach(function (issue) {
        list.addIssue(issue);
        list.issuesSize += 1;
      });

      this.toggleModal(false);
    }
  },
  components: {
    'lists-dropdown': gl.issueBoards.ModalFooterListsDropdown
  },
  template: '\n    <footer\n      class="form-actions add-issues-footer">\n      <div class="pull-left">\n        <button\n          class="btn btn-success"\n          type="button"\n          :disabled="submitDisabled"\n          @click="addIssues">\n          {{ submitText }}\n        </button>\n        <span class="inline add-issues-footer-to-list">\n          \u5230\u5217\u8868\n        </span>\n        <lists-dropdown></lists-dropdown>\n      </div>\n      <button\n        class="btn btn-default pull-right"\n        type="button"\n        @click="toggleModal(false)">\n        \u53D6\u6D88\n      </button>\n    </footer>\n  '
});
// CONCATENATED MODULE: ./boards/components/modal/empty_state.js


var empty_state_ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalEmptyState = vue_esm["a" /* default */].extend({
  mixins: [gl.issueBoards.ModalMixins],
  data: function data() {
    return empty_state_ModalStore.store;
  },

  props: {
    newIssuePath: {
      type: String,
      required: true
    },
    emptyStateSvg: {
      type: String,
      required: true
    }
  },
  computed: {
    contents: function contents() {
      var obj = {
        title: '您的项目还没有添加任何的问题。',
        content: '\n          \u95EE\u9898\u53EF\u4EE5\u662F\u8981\u8BA8\u8BBA\u7684Bug\uFF0C\u4EFB\u52A1\u6216\u6982\u5FF5\u3002\n          \u6B64\u5916\uFF0C\u95EE\u9898\u662F\u53EF\u641C\u7D22\u3001\u53EF\u8FC7\u6EE4\u7684\u3002\n        '
      };

      if (this.activeTab === 'selected') {
        obj.title = '您还没有选择一个问题';
        obj.content = '\n          \u8FD4\u56DE <strong>\u672A\u5173\u95ED\u95EE\u9898</strong> \u5E76\u9009\u62E9\u4E00\u4E9B\u95EE\u9898\n          \u6765\u589E\u52A0\u5230\u770B\u677F\u3002\n        ';
      }

      return obj;
    }
  },
  template: '\n    <section class="empty-state">\n      <div class="row">\n        <div class="col-xs-12 col-sm-6 col-sm-push-6">\n          <aside class="svg-content"><img :src="emptyStateSvg"/></aside>\n        </div>\n        <div class="col-xs-12 col-sm-6 col-sm-pull-6">\n          <div class="text-content">\n            <h4>{{ contents.title }}</h4>\n            <p v-html="contents.content"></p>\n            <a\n              :href="newIssuePath"\n              class="btn btn-success btn-inverted"\n              v-if="activeTab === \'all\'">\n              \u65B0\u5EFA\u95EE\u9898\n            </a>\n            <button\n              type="button"\n              class="btn btn-default"\n              @click="changeTab(\'all\')"\n              v-if="activeTab === \'selected\'">\n              \u672A\u5173\u95ED\u95EE\u9898\n            </button>\n          </div>\n        </div>\n      </div>\n    </section>\n  '
});
// CONCATENATED MODULE: ./boards/components/modal/index.js
/* global ListIssue */









var modal_ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.IssuesModal = vue_esm["a" /* default */].extend({
  props: {
    newIssuePath: {
      type: String,
      required: true
    },
    emptyStateSvg: {
      type: String,
      required: true
    },
    issueLinkBase: {
      type: String,
      required: true
    },
    rootPath: {
      type: String,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    milestonePath: {
      type: String,
      required: true
    },
    labelPath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return modal_ModalStore.store;
  },

  watch: {
    page: function page() {
      this.loadIssues();
    },
    showAddIssuesModal: function showAddIssuesModal() {
      var _this = this;

      if (this.showAddIssuesModal && !this.issues.length) {
        this.loading = true;
        var loadingDone = function loadingDone() {
          _this.loading = false;
        };

        this.loadIssues().then(loadingDone).catch(loadingDone);
      } else if (!this.showAddIssuesModal) {
        this.issues = [];
        this.selectedIssues = [];
        this.issuesCount = false;
      }
    },

    filter: {
      handler: function handler() {
        var _this2 = this;

        if (this.$el.tagName) {
          this.page = 1;
          this.filterLoading = true;
          var loadingDone = function loadingDone() {
            _this2.filterLoading = false;
          };

          this.loadIssues(true).then(loadingDone).catch(loadingDone);
        }
      },

      deep: true
    }
  },
  methods: {
    loadIssues: function loadIssues() {
      var _this3 = this;

      var clearIssues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.showAddIssuesModal) return false;

      return gl.boardService.getBacklog(Object(query_data["a" /* default */])(this.filter.path, {
        page: this.page,
        per: this.perPage
      })).then(function (res) {
        return res.data;
      }).then(function (data) {
        if (clearIssues) {
          _this3.issues = [];
        }

        data.issues.forEach(function (issueObj) {
          var issue = new ListIssue(issueObj);
          var foundSelectedIssue = modal_ModalStore.findSelectedIssue(issue);
          issue.selected = !!foundSelectedIssue;

          _this3.issues.push(issue);
        });

        _this3.loadingNewPage = false;

        if (!_this3.issuesCount) {
          _this3.issuesCount = data.size;
        }
      }).catch(function () {
        // TODO: handle request error
      });
    }
  },
  computed: {
    showList: function showList() {
      if (this.activeTab === 'selected') {
        return this.selectedIssues.length > 0;
      }

      return this.issuesCount > 0;
    },
    showEmptyState: function showEmptyState() {
      if (!this.loading && this.issuesCount === 0) {
        return true;
      }

      return this.activeTab === 'selected' && this.selectedIssues.length === 0;
    }
  },
  created: function created() {
    this.page = 1;
  },

  components: {
    'modal-header': gl.issueBoards.ModalHeader,
    'modal-list': gl.issueBoards.ModalList,
    'modal-footer': gl.issueBoards.ModalFooter,
    'empty-state': gl.issueBoards.ModalEmptyState,
    loadingIcon: loading_icon["a" /* default */]
  },
  template: '\n    <div\n      class="add-issues-modal"\n      v-if="showAddIssuesModal">\n      <div class="add-issues-container">\n        <modal-header\n          :project-id="projectId"\n          :milestone-path="milestonePath"\n          :label-path="labelPath">\n        </modal-header>\n        <modal-list\n          :issue-link-base="issueLinkBase"\n          :root-path="rootPath"\n          :empty-state-svg="emptyStateSvg"\n          v-if="!loading && showList && !filterLoading"></modal-list>\n        <empty-state\n          v-if="showEmptyState"\n          :new-issue-path="newIssuePath"\n          :empty-state-svg="emptyStateSvg"></empty-state>\n        <section\n          class="add-issues-list text-center"\n          v-if="loading || filterLoading">\n          <div class="add-issues-list-loading">\n            <loading-icon />\n          </div>\n        </section>\n        <modal-footer></modal-footer>\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "./boards/components/new_list_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_label__ = __webpack_require__("./create_label.js");
/* eslint-disable func-names, no-new, space-before-function-paren, one-var,
   promise/catch-or-return */




window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

var Store = gl.issueBoards.BoardsStore;

$(document).off('created.label').on('created.label', function (e, label) {
  Store.new({
    title: label.title,
    position: Store.state.lists.length - 2,
    list_type: 'label',
    label: {
      id: label.id,
      title: label.title,
      color: label.color
    }
  });
});

gl.issueBoards.newListDropdownInit = function () {
  $('.js-new-board-list').each(function () {
    var $this = $(this);
    new __WEBPACK_IMPORTED_MODULE_2__create_label__["a" /* default */]($this.closest('.dropdown').find('.dropdown-new-label'), $this.data('namespacePath'), $this.data('projectPath'));

    $this.glDropdown({
      data: function data(term, callback) {
        __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].get($this.attr('data-list-labels-path')).then(function (_ref) {
          var data = _ref.data;

          callback(data);
        });
      },
      renderRow: function renderRow(label) {
        var active = Store.findList('title', label.title);
        var $li = $('<li />');
        var $a = $('<a />', {
          class: active ? 'is-active js-board-list-' + active.id : '',
          text: label.title,
          href: '#'
        });
        var $labelColor = $('<span />', {
          class: 'dropdown-label-box',
          style: 'background-color: ' + label.color
        });

        return $li.append($a.prepend($labelColor));
      },

      search: {
        fields: ['title']
      },
      filterable: true,
      selectable: true,
      multiSelect: true,
      clicked: function clicked(options) {
        var e = options.e;

        var label = options.selectedObj;
        e.preventDefault();

        if (!Store.findList('title', label.title)) {
          Store.new({
            title: label.title,
            position: Store.state.lists.length - 2,
            list_type: 'label',
            label: {
              id: label.id,
              title: label.title,
              color: label.color
            }
          });

          Store.state.lists = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.sortBy(Store.state.lists, 'position');
        }
      }
    });
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/components/project_select.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./boards/components/project_select.vue
var project_select = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./boards/components/project_select.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d05f4306","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./boards/components/project_select.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"label-light prepend-top-10"},[_vm._v("\n    Project\n  ")]),_vm._v(" "),_c('div',{ref:"projectsDropdown",staticClass:"dropdown"},[_c('button',{staticClass:"dropdown-menu-toggle wide",attrs:{"type":"button","data-toggle":"dropdown","aria-expanded":"false"}},[_vm._v("\n      "+_vm._s(_vm.selectedProjectName)+"\n      "),_c('i',{staticClass:"fa fa-chevron-down",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-selectable dropdown-menu-full-width"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"dropdown-content"}),_vm._v(" "),_c('div',{staticClass:"dropdown-loading"},[_c('loading-icon')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-title"},[_c('span',[_vm._v("Projects")]),_vm._v(" "),_c('button',{staticClass:"dropdown-title-button dropdown-menu-close",attrs:{"aria-label":"Close","type":"button"}},[_c('i',{staticClass:"fa fa-times dropdown-menu-close-icon",attrs:{"aria-hidden":"true","data-hidden":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-input"},[_c('input',{staticClass:"dropdown-input-field",attrs:{"type":"search","placeholder":"Search projects"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-search dropdown-input-search",attrs:{"aria-hidden":"true","data-hidden":"true"}})])}]

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./boards/components/project_select.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  project_select["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_project_select = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./boards/components/sidebar/remove_issue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__("./locale/index.js");




var Store = gl.issueBoards.BoardsStore;

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.RemoveIssueBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    issue: {
      type: Object,
      required: true
    },
    list: {
      type: Object,
      required: true
    },
    issueUpdate: {
      type: String,
      required: true
    }
  },
  computed: {
    updateUrl: function updateUrl() {
      return this.issueUpdate.replace(':project_path', this.issue.project.path);
    }
  },
  methods: {
    removeIssue: function removeIssue() {
      var issue = this.issue;
      var lists = issue.getLists();
      var listLabelIds = lists.map(function (list) {
        return list.label.id;
      });

      var labelIds = issue.labels.map(function (label) {
        return label.id;
      }).filter(function (id) {
        return !listLabelIds.includes(id);
      });
      if (labelIds.length === 0) {
        labelIds = [''];
      }

      var data = {
        issue: {
          label_ids: labelIds
        }
      };

      // Post the remove data
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.patch(this.updateUrl, data).catch(function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('Failed to remove issue from board, please try again.'));

        lists.forEach(function (list) {
          list.addIssue(issue);
        });
      });

      // Remove from the frontend store
      lists.forEach(function (list) {
        list.removeIssue(issue);
      });

      Store.detail.issue = {};
    }
  },
  template: '\n    <div\n      class="block list">\n      <button\n        class="btn btn-default btn-block"\n        type="button"\n        @click="removeIssue">\n        Remove from board\n      </button>\n    </div>\n  '
});

/***/ }),

/***/ "./boards/eventhub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ "./boards/filtered_search_boards.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filtered_search_container__ = __webpack_require__("./filtered_search/container.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtered_search_filtered_search_manager__ = __webpack_require__("./filtered_search/filtered_search_manager.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable class-methods-use-this */



var FilteredSearchBoards = function (_FilteredSearchManage) {
  _inherits(FilteredSearchBoards, _FilteredSearchManage);

  function FilteredSearchBoards(store) {
    var updateUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var cantEdit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    _classCallCheck(this, FilteredSearchBoards);

    var _this = _possibleConstructorReturn(this, (FilteredSearchBoards.__proto__ || Object.getPrototypeOf(FilteredSearchBoards)).call(this, {
      page: 'boards',
      stateFiltersSelector: '.issues-state-filters'
    }));

    _this.store = store;
    _this.updateUrl = updateUrl;

    // Issue boards is slightly different, we handle all the requests async
    // instead or reloading the page, we just re-fire the list ajax requests
    _this.isHandledAsync = true;
    _this.cantEdit = cantEdit.filter(function (i) {
      return typeof i === 'string';
    });
    _this.cantEditWithValue = cantEdit.filter(function (i) {
      return (typeof i === 'undefined' ? 'undefined' : _typeof(i)) === 'object';
    });
    return _this;
  }

  _createClass(FilteredSearchBoards, [{
    key: 'updateObject',
    value: function updateObject(path) {
      this.store.path = path.substr(1);

      if (this.updateUrl) {
        gl.issueBoards.BoardsStore.updateFiltersUrl();
      }
    }
  }, {
    key: 'removeTokens',
    value: function removeTokens() {
      var tokens = __WEBPACK_IMPORTED_MODULE_0__filtered_search_container__["a" /* default */].container.querySelectorAll('.js-visual-token');

      // Remove all the tokens as they will be replaced by the search manager
      [].forEach.call(tokens, function (el) {
        el.parentNode.removeChild(el);
      });

      this.filteredSearchInput.value = '';
    }
  }, {
    key: 'updateTokens',
    value: function updateTokens() {
      this.removeTokens();

      this.loadSearchParamsFromURL();

      // Get the placeholder back if search is empty
      this.filteredSearchInput.dispatchEvent(new Event('input'));
    }
  }, {
    key: 'canEdit',
    value: function canEdit(tokenName, tokenValue) {
      if (this.cantEdit.includes(tokenName)) return false;
      return this.cantEditWithValue.findIndex(function (token) {
        return token.name === tokenName && token.value === tokenValue;
      }) === -1;
    }
  }]);

  return FilteredSearchBoards;
}(__WEBPACK_IMPORTED_MODULE_1__filtered_search_filtered_search_manager__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (FilteredSearchBoards);

/***/ }),

/***/ "./boards/filters/due_date_filters.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* global dateFormat */



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('due-date', function (value) {
  var date = new Date(value);
  return dateFormat(date, 'mmm d, yyyy', true);
});

/***/ }),

/***/ "./boards/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_shared_models_label__ = __webpack_require__("./vue_shared/models/label.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_shared_models_label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__vue_shared_models_label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filtered_search_boards__ = __webpack_require__("./boards/filtered_search_boards.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__eventhub__ = __webpack_require__("./boards/eventhub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sidebar_event_hub__ = __webpack_require__("./sidebar/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_issue__ = __webpack_require__("./boards/models/issue.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_list__ = __webpack_require__("./boards/models/list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_milestone__ = __webpack_require__("./boards/models/milestone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_milestone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__models_milestone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_project__ = __webpack_require__("./boards/models/project.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_assignee__ = __webpack_require__("./boards/models/assignee.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_assignee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__models_assignee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__stores_boards_store__ = __webpack_require__("./boards/stores/boards_store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__stores_modal_store__ = __webpack_require__("./boards/stores/modal_store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__stores_modal_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__stores_modal_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_board_service__ = __webpack_require__("./boards/services/board_service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_modal_mixins__ = __webpack_require__("./boards/mixins/modal_mixins.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_modal_mixins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__mixins_modal_mixins__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_sortable_default_options__ = __webpack_require__("./boards/mixins/sortable_default_options.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__filters_due_date_filters__ = __webpack_require__("./boards/filters/due_date_filters.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_board__ = __webpack_require__("./boards/components/board.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_board_sidebar__ = __webpack_require__("./boards/components/board_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_new_list_dropdown__ = __webpack_require__("./boards/components/new_list_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_modal_index__ = __webpack_require__("./boards/components/modal/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__vue_shared_vue_resource_interceptor__ = __webpack_require__("./vue_shared/vue_resource_interceptor.js");
/* eslint-disable one-var, quote-props, comma-dangle, space-before-function-paren */










 // eslint-disable-line import/first















 // eslint-disable-line import/first

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var $boardApp = document.getElementById('board-app');
  var Store = gl.issueBoards.BoardsStore;
  var ModalStore = gl.issueBoards.ModalStore;

  window.gl = window.gl || {};

  if (gl.IssueBoardsApp) {
    gl.IssueBoardsApp.$destroy(true);
  }

  Store.create();

  // hack to allow sidebar scripts like milestone_select manipulate the BoardsStore
  gl.issueBoards.boardStoreIssueSet = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set.apply(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */], [Store.detail.issue].concat(args));
  };
  gl.issueBoards.boardStoreIssueDelete = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].delete.apply(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */], [Store.detail.issue].concat(args));
  };

  gl.IssueBoardsApp = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: $boardApp,
    components: {
      'board': gl.issueBoards.Board,
      'board-sidebar': gl.issueBoards.BoardSidebar,
      'board-add-issues-modal': gl.issueBoards.IssuesModal
    },
    data: {
      state: Store.state,
      loading: true,
      boardsEndpoint: $boardApp.dataset.boardsEndpoint,
      listsEndpoint: $boardApp.dataset.listsEndpoint,
      boardId: $boardApp.dataset.boardId,
      disabled: $boardApp.dataset.disabled === 'true',
      issueLinkBase: $boardApp.dataset.issueLinkBase,
      rootPath: $boardApp.dataset.rootPath,
      bulkUpdatePath: $boardApp.dataset.bulkUpdatePath,
      detailIssue: Store.detail,
      defaultAvatar: $boardApp.dataset.defaultAvatar
    },
    computed: {
      detailIssueVisible: function detailIssueVisible() {
        return Object.keys(this.detailIssue.issue).length;
      }
    },
    created: function created() {
      gl.boardService = new __WEBPACK_IMPORTED_MODULE_15__services_board_service__["a" /* default */]({
        boardsEndpoint: this.boardsEndpoint,
        listsEndpoint: this.listsEndpoint,
        bulkUpdatePath: this.bulkUpdatePath,
        boardId: this.boardId
      });
      Store.rootPath = this.boardsEndpoint;

      __WEBPACK_IMPORTED_MODULE_6__eventhub__["a" /* default */].$on('updateTokens', this.updateTokens);
      __WEBPACK_IMPORTED_MODULE_6__eventhub__["a" /* default */].$on('newDetailIssue', this.updateDetailIssue);
      __WEBPACK_IMPORTED_MODULE_6__eventhub__["a" /* default */].$on('clearDetailIssue', this.clearDetailIssue);
      __WEBPACK_IMPORTED_MODULE_7__sidebar_event_hub__["a" /* default */].$on('toggleSubscription', this.toggleSubscription);
    },
    beforeDestroy: function beforeDestroy() {
      __WEBPACK_IMPORTED_MODULE_6__eventhub__["a" /* default */].$off('updateTokens', this.updateTokens);
      __WEBPACK_IMPORTED_MODULE_6__eventhub__["a" /* default */].$off('newDetailIssue', this.updateDetailIssue);
      __WEBPACK_IMPORTED_MODULE_6__eventhub__["a" /* default */].$off('clearDetailIssue', this.clearDetailIssue);
      __WEBPACK_IMPORTED_MODULE_7__sidebar_event_hub__["a" /* default */].$off('toggleSubscription', this.toggleSubscription);
    },
    mounted: function mounted() {
      var _this = this;

      this.filterManager = new __WEBPACK_IMPORTED_MODULE_5__filtered_search_boards__["a" /* default */](Store.filter, true, Store.cantEdit);
      this.filterManager.setup();

      Store.disabled = this.disabled;
      gl.boardService.all().then(function (res) {
        return res.data;
      }).then(function (data) {
        data.forEach(function (board) {
          var list = Store.addList(board, _this.defaultAvatar);

          if (list.type === 'closed') {
            list.position = Infinity;
          } else if (list.type === 'backlog') {
            list.position = -1;
          }
        });

        _this.state.lists = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortBy(_this.state.lists, 'position');

        Store.addBlankState();
        _this.loading = false;
      }).catch(function () {
        Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])('获取看板列表出错，请重试。');
      });
    },

    methods: {
      updateTokens: function updateTokens() {
        this.filterManager.updateTokens();
      },
      updateDetailIssue: function updateDetailIssue(newIssue) {
        var sidebarInfoEndpoint = newIssue.sidebarInfoEndpoint;
        if (sidebarInfoEndpoint && newIssue.subscribed === undefined) {
          newIssue.setFetchingState('subscriptions', true);
          __WEBPACK_IMPORTED_MODULE_15__services_board_service__["a" /* default */].getIssueInfo(sidebarInfoEndpoint).then(function (res) {
            return res.data;
          }).then(function (data) {
            newIssue.setFetchingState('subscriptions', false);
            newIssue.updateData({
              subscribed: data.subscribed
            });
          }).catch(function () {
            newIssue.setFetchingState('subscriptions', false);
            Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__locale__["a" /* __ */])('An error occurred while fetching sidebar data'));
          });
        }

        Store.detail.issue = newIssue;
      },
      clearDetailIssue: function clearDetailIssue() {
        Store.detail.issue = {};
      },
      toggleSubscription: function toggleSubscription(id) {
        var issue = Store.detail.issue;
        if (issue.id === id && issue.toggleSubscriptionEndpoint) {
          issue.setFetchingState('subscriptions', true);
          __WEBPACK_IMPORTED_MODULE_15__services_board_service__["a" /* default */].toggleIssueSubscription(issue.toggleSubscriptionEndpoint).then(function () {
            issue.setFetchingState('subscriptions', false);
            issue.updateData({
              subscribed: !issue.subscribed
            });
          }).catch(function () {
            issue.setFetchingState('subscriptions', false);
            Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__locale__["a" /* __ */])('An error occurred when toggling the notification subscription'));
          });
        }
      }
    }
  });

  gl.IssueBoardsSearch = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: document.getElementById('js-add-list'),
    data: {
      filters: Store.state.filters
    },
    mounted: function mounted() {
      gl.issueBoards.newListDropdownInit();
    }
  });

  gl.IssueBoardsModalAddBtn = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: document.getElementById('js-add-issues-btn'),
    mixins: [gl.issueBoards.ModalMixins],
    data: function data() {
      return {
        modal: ModalStore.store,
        store: Store.state,
        canAdminList: this.$options.el.hasAttribute('data-can-admin-list')
      };
    },

    computed: {
      disabled: function disabled() {
        if (!this.store) {
          return true;
        }
        return !this.store.lists.filter(function (list) {
          return !list.preset;
        }).length;
      },
      tooltipTitle: function tooltipTitle() {
        if (this.disabled) {
          return '请先在看板中添加一个列表';
        }

        return '';
      }
    },
    watch: {
      disabled: function disabled() {
        this.updateTooltip();
      }
    },
    mounted: function mounted() {
      this.updateTooltip();
    },

    methods: {
      updateTooltip: function updateTooltip() {
        var _this2 = this;

        var $tooltip = $(this.$refs.addIssuesButton);

        this.$nextTick(function () {
          if (_this2.disabled) {
            $tooltip.tooltip();
          } else {
            $tooltip.tooltip('destroy');
          }
        });
      },
      openModal: function openModal() {
        if (!this.disabled) {
          this.toggleModal(true);
        }
      }
    },
    template: '\n      <div class="board-extra-actions">\n        <button\n          class="btn btn-create prepend-left-10"\n          type="button"\n          data-placement="bottom"\n          ref="addIssuesButton"\n          :class="{ \'disabled\': disabled }"\n          :title="tooltipTitle"\n          :aria-disabled="disabled"\n          v-if="canAdminList"\n          @click="openModal">\n          \u6DFB\u52A0\u95EE\u9898\n        </button>\n      </div>\n    '
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/mixins/modal_mixins.js":
/***/ (function(module, exports) {

var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalMixins = {
  methods: {
    toggleModal: function toggleModal(toggle) {
      ModalStore.store.showAddIssuesModal = toggle;
    },
    changeTab: function changeTab(tab) {
      ModalStore.store.activeTab = tab;
    }
  }
};

/***/ }),

/***/ "./boards/mixins/sortable_default_options.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sortable_sortable_config__ = __webpack_require__("./sortable/sortable_config.js");
/* eslint-disable no-unused-vars, no-mixed-operators, comma-dangle */
/* global DocumentTouch */



window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.onStart = function () {
  $('.has-tooltip').tooltip('hide').tooltip('disable');
  document.body.classList.add('is-dragging');
};

gl.issueBoards.onEnd = function () {
  $('.has-tooltip').tooltip('enable');
  document.body.classList.remove('is-dragging');
};

gl.issueBoards.touchEnabled = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;

gl.issueBoards.getBoardSortableDefaultOptions = function (obj) {
  var defaultSortOptions = Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__sortable_sortable_config__["a" /* default */], {
    filter: '.board-delete, .btn',
    delay: gl.issueBoards.touchEnabled ? 100 : 0,
    scrollSensitivity: gl.issueBoards.touchEnabled ? 60 : 100,
    scrollSpeed: 20,
    onStart: gl.issueBoards.onStart,
    onEnd: gl.issueBoards.onEnd
  });

  Object.keys(obj).forEach(function (key) {
    defaultSortOptions[key] = obj[key];
  });
  return defaultSortOptions;
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/models/assignee.js":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-unused-vars */

var ListAssignee = function ListAssignee(user, defaultAvatar) {
  _classCallCheck(this, ListAssignee);

  this.id = user.id;
  this.name = user.name;
  this.username = user.username;
  this.avatar = user.avatar_url || defaultAvatar;
};

window.ListAssignee = ListAssignee;

/***/ }),

/***/ "./boards/models/issue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project__ = __webpack_require__("./boards/models/project.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-unused-vars, space-before-function-paren, arrow-body-style, arrow-parens, comma-dangle, max-len */
/* global ListLabel */
/* global ListMilestone */
/* global ListAssignee */




var ListIssue = function () {
  function ListIssue(obj, defaultAvatar) {
    var _this = this;

    _classCallCheck(this, ListIssue);

    this.id = obj.id;
    this.iid = obj.iid;
    this.title = obj.title;
    this.confidential = obj.confidential;
    this.dueDate = obj.due_date;
    this.subscribed = obj.subscribed;
    this.labels = [];
    this.assignees = [];
    this.selected = false;
    this.position = obj.relative_position || Infinity;
    this.isFetching = {
      subscriptions: true
    };
    this.isLoading = {};
    this.sidebarInfoEndpoint = obj.issue_sidebar_endpoint;
    this.toggleSubscriptionEndpoint = obj.toggle_subscription_endpoint;
    this.milestone_id = obj.milestone_id;
    this.project_id = obj.project_id;

    if (obj.project) {
      this.project = new __WEBPACK_IMPORTED_MODULE_1__project__["a" /* default */](obj.project);
    }

    if (obj.milestone) {
      this.milestone = new ListMilestone(obj.milestone);
    }

    obj.labels.forEach(function (label) {
      _this.labels.push(new ListLabel(label));
    });

    this.assignees = obj.assignees.map(function (a) {
      return new ListAssignee(a, defaultAvatar);
    });
  }

  _createClass(ListIssue, [{
    key: 'addLabel',
    value: function addLabel(label) {
      if (!this.findLabel(label)) {
        this.labels.push(new ListLabel(label));
      }
    }
  }, {
    key: 'findLabel',
    value: function findLabel(_findLabel) {
      return this.labels.filter(function (label) {
        return label.title === _findLabel.title;
      })[0];
    }
  }, {
    key: 'removeLabel',
    value: function removeLabel(_removeLabel) {
      if (_removeLabel) {
        this.labels = this.labels.filter(function (label) {
          return _removeLabel.title !== label.title;
        });
      }
    }
  }, {
    key: 'removeLabels',
    value: function removeLabels(labels) {
      labels.forEach(this.removeLabel.bind(this));
    }
  }, {
    key: 'addAssignee',
    value: function addAssignee(assignee) {
      if (!this.findAssignee(assignee)) {
        this.assignees.push(new ListAssignee(assignee));
      }
    }
  }, {
    key: 'findAssignee',
    value: function findAssignee(_findAssignee) {
      return this.assignees.filter(function (assignee) {
        return assignee.id === _findAssignee.id;
      })[0];
    }
  }, {
    key: 'removeAssignee',
    value: function removeAssignee(_removeAssignee) {
      if (_removeAssignee) {
        this.assignees = this.assignees.filter(function (assignee) {
          return assignee.id !== _removeAssignee.id;
        });
      }
    }
  }, {
    key: 'removeAllAssignees',
    value: function removeAllAssignees() {
      this.assignees = [];
    }
  }, {
    key: 'getLists',
    value: function getLists() {
      var _this2 = this;

      return gl.issueBoards.BoardsStore.state.lists.filter(function (list) {
        return list.findIssue(_this2.id);
      });
    }
  }, {
    key: 'updateData',
    value: function updateData(newData) {
      Object.assign(this, newData);
    }
  }, {
    key: 'setFetchingState',
    value: function setFetchingState(key, value) {
      this.isFetching[key] = value;
    }
  }, {
    key: 'setLoadingState',
    value: function setLoadingState(key, value) {
      this.isLoading[key] = value;
    }
  }, {
    key: 'update',
    value: function update(url) {
      var data = {
        issue: {
          milestone_id: this.milestone ? this.milestone.id : null,
          due_date: this.dueDate,
          assignee_ids: this.assignees.length > 0 ? this.assignees.map(function (u) {
            return u.id;
          }) : [0],
          label_ids: this.labels.map(function (label) {
            return label.id;
          })
        }
      };

      if (!data.issue.label_ids.length) {
        data.issue.label_ids = [''];
      }

      var projectPath = this.project ? this.project.path : '';
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.patch(url.replace(':project_path', projectPath), data);
    }
  }]);

  return ListIssue;
}();

window.ListIssue = ListIssue;

/* harmony default export */ __webpack_exports__["a"] = (ListIssue);

/***/ }),

/***/ "./boards/models/list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_query_data__ = __webpack_require__("./boards/utils/query_data.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable space-before-function-paren, no-underscore-dangle, class-methods-use-this, consistent-return, no-shadow, no-param-reassign, max-len, no-unused-vars */
/* global ListIssue */
/* global ListLabel */


var PER_PAGE = 20;

var List = function () {
  function List(obj, defaultAvatar) {
    _classCallCheck(this, List);

    this.id = obj.id;
    this._uid = this.guid();
    this.position = obj.position;
    this.title = obj.title;
    this.type = obj.list_type;
    this.preset = ['backlog', 'closed', 'blank'].indexOf(this.type) > -1;
    this.isExpandable = ['backlog', 'closed'].indexOf(this.type) > -1;
    this.isExpanded = true;
    this.page = 1;
    this.loading = true;
    this.loadingMore = false;
    this.issues = [];
    this.issuesSize = 0;
    this.defaultAvatar = defaultAvatar;

    if (obj.label) {
      this.label = new ListLabel(obj.label);
    }

    if (this.type !== 'blank' && this.id) {
      this.getIssues().catch(function () {
        // TODO: handle request error
      });
    }
  }

  _createClass(List, [{
    key: 'guid',
    value: function guid() {
      var s4 = function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      };
      return '' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
  }, {
    key: 'save',
    value: function save() {
      var _this = this;

      return gl.boardService.createList(this.label.id).then(function (res) {
        return res.data;
      }).then(function (data) {
        _this.id = data.id;
        _this.type = data.list_type;
        _this.position = data.position;

        return _this.getIssues();
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var index = gl.issueBoards.BoardsStore.state.lists.indexOf(this);
      gl.issueBoards.BoardsStore.state.lists.splice(index, 1);
      gl.issueBoards.BoardsStore.updateNewListDropdown(this.id);

      gl.boardService.destroyList(this.id).catch(function () {
        // TODO: handle request error
      });
    }
  }, {
    key: 'update',
    value: function update() {
      gl.boardService.updateList(this.id, this.position).catch(function () {
        // TODO: handle request error
      });
    }
  }, {
    key: 'nextPage',
    value: function nextPage() {
      if (this.issuesSize > this.issues.length) {
        if (this.issues.length / PER_PAGE >= 1) {
          this.page += 1;
        }

        return this.getIssues(false);
      }
    }
  }, {
    key: 'getIssues',
    value: function getIssues() {
      var _this2 = this;

      var emptyIssues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var data = Object(__WEBPACK_IMPORTED_MODULE_0__utils_query_data__["a" /* default */])(gl.issueBoards.BoardsStore.filter.path, { page: this.page });

      if (this.label && data.label_name) {
        data.label_name = data.label_name.filter(function (label) {
          return label !== _this2.label.title;
        });
      }

      if (emptyIssues) {
        this.loading = true;
      }

      return gl.boardService.getIssuesForList(this.id, data).then(function (res) {
        return res.data;
      }).then(function (data) {
        _this2.loading = false;
        _this2.issuesSize = data.size;

        if (emptyIssues) {
          _this2.issues = [];
        }

        _this2.createIssues(data.issues);
      });
    }
  }, {
    key: 'newIssue',
    value: function newIssue(issue) {
      var _this3 = this;

      this.addIssue(issue, null, 0);
      this.issuesSize += 1;

      return gl.boardService.newIssue(this.id, issue).then(function (res) {
        return res.data;
      }).then(function (data) {
        issue.id = data.id;
        issue.iid = data.iid;
        issue.project = data.project;

        if (_this3.issuesSize > 1) {
          var moveBeforeId = _this3.issues[1].id;
          gl.boardService.moveIssue(issue.id, null, null, null, moveBeforeId);
        }
      });
    }
  }, {
    key: 'createIssues',
    value: function createIssues(data) {
      var _this4 = this;

      data.forEach(function (issueObj) {
        _this4.addIssue(new ListIssue(issueObj, _this4.defaultAvatar));
      });
    }
  }, {
    key: 'addIssue',
    value: function addIssue(issue, listFrom, newIndex) {
      var moveBeforeId = null;
      var moveAfterId = null;

      if (!this.findIssue(issue.id)) {
        if (newIndex !== undefined) {
          this.issues.splice(newIndex, 0, issue);

          if (this.issues[newIndex - 1]) {
            moveBeforeId = this.issues[newIndex - 1].id;
          }

          if (this.issues[newIndex + 1]) {
            moveAfterId = this.issues[newIndex + 1].id;
          }
        } else {
          this.issues.push(issue);
        }

        if (this.label) {
          issue.addLabel(this.label);
        }

        if (listFrom) {
          this.issuesSize += 1;

          this.updateIssueLabel(issue, listFrom, moveBeforeId, moveAfterId);
        }
      }
    }
  }, {
    key: 'moveIssue',
    value: function moveIssue(issue, oldIndex, newIndex, moveBeforeId, moveAfterId) {
      this.issues.splice(oldIndex, 1);
      this.issues.splice(newIndex, 0, issue);

      gl.boardService.moveIssue(issue.id, null, null, moveBeforeId, moveAfterId).catch(function () {
        // TODO: handle request error
      });
    }
  }, {
    key: 'updateIssueLabel',
    value: function updateIssueLabel(issue, listFrom, moveBeforeId, moveAfterId) {
      gl.boardService.moveIssue(issue.id, listFrom.id, this.id, moveBeforeId, moveAfterId).catch(function () {
        // TODO: handle request error
      });
    }
  }, {
    key: 'findIssue',
    value: function findIssue(id) {
      return this.issues.find(function (issue) {
        return issue.id === id;
      });
    }
  }, {
    key: 'removeIssue',
    value: function removeIssue(_removeIssue) {
      var _this5 = this;

      this.issues = this.issues.filter(function (issue) {
        var matchesRemove = _removeIssue.id === issue.id;

        if (matchesRemove) {
          _this5.issuesSize -= 1;
          issue.removeLabel(_this5.label);
        }

        return !matchesRemove;
      });
    }
  }]);

  return List;
}();

window.List = List;

/***/ }),

/***/ "./boards/models/milestone.js":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-unused-vars */

var ListMilestone = function ListMilestone(obj) {
  _classCallCheck(this, ListMilestone);

  this.id = obj.id;
  this.title = obj.title;
};

window.ListMilestone = ListMilestone;

/***/ }),

/***/ "./boards/models/project.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IssueProject = function IssueProject(obj) {
  _classCallCheck(this, IssueProject);

  this.id = obj.id;
  this.path = obj.path;
};

/* harmony default export */ __webpack_exports__["a"] = (IssueProject);

/***/ }),

/***/ "./boards/services/board_service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var BoardService = function () {
  function BoardService(_ref) {
    var boardsEndpoint = _ref.boardsEndpoint,
        listsEndpoint = _ref.listsEndpoint,
        bulkUpdatePath = _ref.bulkUpdatePath,
        boardId = _ref.boardId;

    _classCallCheck(this, BoardService);

    this.boardsEndpoint = boardsEndpoint;
    this.boardId = boardId;
    this.listsEndpoint = listsEndpoint;
    this.listsEndpointGenerate = listsEndpoint + '/generate.json';
    this.bulkUpdatePath = bulkUpdatePath;
  }

  _createClass(BoardService, [{
    key: 'generateBoardsPath',
    value: function generateBoardsPath(id) {
      return '' + this.boardsEndpoint + (id ? '/' + id : '') + '.json';
    }
  }, {
    key: 'generateIssuesPath',
    value: function generateIssuesPath(id) {
      return '' + this.listsEndpoint + (id ? '/' + id : '') + '/issues';
    }
  }, {
    key: 'all',
    value: function all() {
      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].get(this.listsEndpoint);
    }
  }, {
    key: 'generateDefaultLists',
    value: function generateDefaultLists() {
      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].post(this.listsEndpointGenerate, {});
    }
  }, {
    key: 'createList',
    value: function createList(labelId) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].post(this.listsEndpoint, {
        list: {
          label_id: labelId
        }
      });
    }
  }, {
    key: 'updateList',
    value: function updateList(id, position) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].put(this.listsEndpoint + '/' + id, {
        list: {
          position: position
        }
      });
    }
  }, {
    key: 'destroyList',
    value: function destroyList(id) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].delete(this.listsEndpoint + '/' + id);
    }
  }, {
    key: 'getIssuesForList',
    value: function getIssuesForList(id) {
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var data = { id: id };
      Object.keys(filter).forEach(function (key) {
        data[key] = filter[key];
      });

      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].get(Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_url_utility__["c" /* mergeUrlParams */])(data, this.generateIssuesPath(id)));
    }
  }, {
    key: 'moveIssue',
    value: function moveIssue(id) {
      var fromListId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var toListId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var moveBeforeId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var moveAfterId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].put(BoardService.generateIssuePath(this.boardId, id), {
        from_list_id: fromListId,
        to_list_id: toListId,
        move_before_id: moveBeforeId,
        move_after_id: moveAfterId
      });
    }
  }, {
    key: 'newIssue',
    value: function newIssue(id, issue) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].post(this.generateIssuesPath(id), {
        issue: issue
      });
    }
  }, {
    key: 'getBacklog',
    value: function getBacklog(data) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].get(Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_url_utility__["c" /* mergeUrlParams */])(data, gon.relative_url_root + '/-/boards/' + this.boardId + '/issues.json'));
    }
  }, {
    key: 'bulkUpdate',
    value: function bulkUpdate(issueIds) {
      var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var data = {
        update: Object.assign(extraData, {
          issuable_ids: issueIds.join(',')
        })
      };

      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].post(this.bulkUpdatePath, data);
    }
  }], [{
    key: 'generateIssuePath',
    value: function generateIssuePath(boardId, id) {
      return gon.relative_url_root + '/-/boards/' + (boardId ? '' + boardId : '') + '/issues' + (id ? '/' + id : '');
    }
  }, {
    key: 'getIssueInfo',
    value: function getIssueInfo(endpoint) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].get(endpoint);
    }
  }, {
    key: 'toggleIssueSubscription',
    value: function toggleIssueSubscription(endpoint) {
      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].post(endpoint);
    }
  }]);

  return BoardService;
}();

/* harmony default export */ __webpack_exports__["a"] = (BoardService);


window.BoardService = BoardService;

/***/ }),

/***/ "./boards/stores/boards_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* eslint-disable comma-dangle, space-before-function-paren, one-var, no-shadow, dot-notation, max-len */
/* global List */




window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.BoardsStore = {
  disabled: false,
  filter: {
    path: ''
  },
  state: {},
  detail: {
    issue: {}
  },
  moving: {
    issue: {},
    list: {}
  },
  create: function create() {
    this.state.lists = [];
    this.filter.path = Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__["l" /* getUrlParamsArray */])().join('&');
    this.detail = {
      issue: {}
    };
  },
  addList: function addList(listObj, defaultAvatar) {
    var list = new List(listObj, defaultAvatar);
    this.state.lists.push(list);

    return list;
  },
  new: function _new(listObj) {
    var _this = this;

    var list = this.addList(listObj);
    var backlogList = this.findList('type', 'backlog', 'backlog');

    list.save().then(function () {
      // Remove any new issues from the backlog
      // as they will be visible in the new list
      list.issues.forEach(backlogList.removeIssue.bind(backlogList));
      _this.state.lists = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortBy(_this.state.lists, 'position');
    }).catch(function () {
      // https://gitlab.com/gitlab-org/gitlab-ce/issues/30821
    });
    this.removeBlankState();
  },
  updateNewListDropdown: function updateNewListDropdown(listId) {
    $('.js-board-list-' + listId).removeClass('is-active');
  },
  shouldAddBlankState: function shouldAddBlankState() {
    // Decide whether to add the blank state
    return !this.state.lists.filter(function (list) {
      return list.type !== 'backlog' && list.type !== 'closed';
    })[0];
  },
  addBlankState: function addBlankState() {
    if (!this.shouldAddBlankState() || this.welcomeIsHidden() || this.disabled) return;

    this.addList({
      id: 'blank',
      list_type: 'blank',
      title: '欢迎来到您的问题看板！',
      position: 0
    });

    this.state.lists = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortBy(this.state.lists, 'position');
  },
  removeBlankState: function removeBlankState() {
    this.removeList('blank');

    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('issue_board_welcome_hidden', 'true', {
      expires: 365 * 10,
      path: ''
    });
  },
  welcomeIsHidden: function welcomeIsHidden() {
    return __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('issue_board_welcome_hidden') === 'true';
  },
  removeList: function removeList(id) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blank';

    var list = this.findList('id', id, type);

    if (!list) return;

    this.state.lists = this.state.lists.filter(function (list) {
      return list.id !== id;
    });
  },
  moveList: function moveList(listFrom, orderLists) {
    var _this2 = this;

    orderLists.forEach(function (id, i) {
      var list = _this2.findList('id', parseInt(id, 10));

      list.position = i;
    });
    listFrom.update();
  },
  moveIssueToList: function moveIssueToList(listFrom, listTo, issue, newIndex) {
    var issueTo = listTo.findIssue(issue.id);
    var issueLists = issue.getLists();
    var listLabels = issueLists.map(function (listIssue) {
      return listIssue.label;
    });

    if (!issueTo) {
      // Add to new lists issues if it doesn't already exist
      listTo.addIssue(issue, listFrom, newIndex);
    } else {
      listTo.updateIssueLabel(issue, listFrom);
      issueTo.removeLabel(listFrom.label);
    }

    if (listTo.type === 'closed' && listFrom.type !== 'backlog') {
      issueLists.forEach(function (list) {
        list.removeIssue(issue);
      });
      issue.removeLabels(listLabels);
    } else {
      listFrom.removeIssue(issue);
    }
  },
  moveIssueInList: function moveIssueInList(list, issue, oldIndex, newIndex, idArray) {
    var beforeId = parseInt(idArray[newIndex - 1], 10) || null;
    var afterId = parseInt(idArray[newIndex + 1], 10) || null;

    list.moveIssue(issue, oldIndex, newIndex, beforeId, afterId);
  },
  findList: function findList(key, val) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'label';

    return this.state.lists.filter(function (list) {
      var byType = type ? list['type'] === type : true;

      return list[key] === val && byType;
    })[0];
  },
  updateFiltersUrl: function updateFiltersUrl() {
    history.pushState(null, null, '?' + this.filter.path);
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/stores/modal_store.js":
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

var ModalStore = function () {
  function ModalStore() {
    _classCallCheck(this, ModalStore);

    this.store = {
      columns: 3,
      issues: [],
      issuesCount: false,
      selectedIssues: [],
      showAddIssuesModal: false,
      activeTab: 'all',
      selectedList: null,
      searchTerm: '',
      loading: false,
      loadingNewPage: false,
      filterLoading: false,
      page: 1,
      perPage: 50,
      filter: {
        path: ''
      }
    };
  }

  _createClass(ModalStore, [{
    key: 'selectedCount',
    value: function selectedCount() {
      return this.getSelectedIssues().length;
    }
  }, {
    key: 'toggleIssue',
    value: function toggleIssue(issueObj) {
      var issue = issueObj;
      var selected = issue.selected;

      issue.selected = !selected;

      if (!selected) {
        this.addSelectedIssue(issue);
      } else {
        this.removeSelectedIssue(issue);
      }
    }
  }, {
    key: 'toggleAll',
    value: function toggleAll() {
      var _this = this;

      var select = this.selectedCount() !== this.store.issues.length;

      this.store.issues.forEach(function (issue) {
        var issueUpdate = issue;

        if (issueUpdate.selected !== select) {
          issueUpdate.selected = select;

          if (select) {
            _this.addSelectedIssue(issue);
          } else {
            _this.removeSelectedIssue(issue);
          }
        }
      });
    }
  }, {
    key: 'getSelectedIssues',
    value: function getSelectedIssues() {
      return this.store.selectedIssues.filter(function (issue) {
        return issue.selected;
      });
    }
  }, {
    key: 'addSelectedIssue',
    value: function addSelectedIssue(issue) {
      var index = this.selectedIssueIndex(issue);

      if (index === -1) {
        this.store.selectedIssues.push(issue);
      }
    }
  }, {
    key: 'removeSelectedIssue',
    value: function removeSelectedIssue(issue) {
      var forcePurge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.store.activeTab === 'all' || forcePurge) {
        this.store.selectedIssues = this.store.selectedIssues.filter(function (fIssue) {
          return fIssue.id !== issue.id;
        });
      }
    }
  }, {
    key: 'purgeUnselectedIssues',
    value: function purgeUnselectedIssues() {
      var _this2 = this;

      this.store.selectedIssues.forEach(function (issue) {
        if (!issue.selected) {
          _this2.removeSelectedIssue(issue, true);
        }
      });
    }
  }, {
    key: 'selectedIssueIndex',
    value: function selectedIssueIndex(issue) {
      return this.store.selectedIssues.indexOf(issue);
    }
  }, {
    key: 'findSelectedIssue',
    value: function findSelectedIssue(issue) {
      return this.store.selectedIssues.filter(function (filteredIssue) {
        return filteredIssue.id === issue.id;
      })[0];
    }
  }]);

  return ModalStore;
}();

gl.issueBoards.ModalStore = new ModalStore();

/***/ }),

/***/ "./boards/utils/query_data.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (path, extraData) {
  return path.split('&').reduce(function (dataParam, filterParam) {
    if (filterParam === '') return dataParam;

    var data = dataParam;
    var paramSplit = filterParam.split('=');
    var paramKeyNormalized = paramSplit[0].replace('[]', '');
    var isArray = paramSplit[0].indexOf('[]');
    var value = decodeURIComponent(paramSplit[1].replace(/\+/g, ' '));

    if (isArray !== -1) {
      if (!data[paramKeyNormalized]) {
        data[paramKeyNormalized] = [];
      }

      data[paramKeyNormalized].push(value);
    } else {
      data[paramKeyNormalized] = value;
    }

    return data;
  }, extraData);
});

/***/ }),

/***/ "./create_label.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, prefer-arrow-callback */



var CreateLabelDropdown = function () {
  function CreateLabelDropdown($el, namespacePath, projectPath) {
    _classCallCheck(this, CreateLabelDropdown);

    this.$el = $el;
    this.namespacePath = namespacePath;
    this.projectPath = projectPath;
    this.$dropdownBack = $('.dropdown-menu-back', this.$el.closest('.dropdown'));
    this.$cancelButton = $('.js-cancel-label-btn', this.$el);
    this.$newLabelField = $('#new_label_name', this.$el);
    this.$newColorField = $('#new_label_color', this.$el);
    this.$colorPreview = $('.js-dropdown-label-color-preview', this.$el);
    this.$newLabelError = $('.js-label-error', this.$el);
    this.$newLabelCreateButton = $('.js-new-label-btn', this.$el);
    this.$colorSuggestions = $('.suggest-colors-dropdown a', this.$el);

    this.$newLabelError.hide();
    this.$newLabelCreateButton.disable();

    this.cleanBinding();
    this.addBinding();
  }

  _createClass(CreateLabelDropdown, [{
    key: 'cleanBinding',
    value: function cleanBinding() {
      this.$colorSuggestions.off('click');
      this.$newLabelField.off('keyup change');
      this.$newColorField.off('keyup change');
      this.$dropdownBack.off('click');
      this.$cancelButton.off('click');
      this.$newLabelCreateButton.off('click');
    }
  }, {
    key: 'addBinding',
    value: function addBinding() {
      var self = this;

      this.$colorSuggestions.on('click', function (e) {
        var $this = $(this);
        self.addColorValue(e, $this);
      });

      this.$newLabelField.on('keyup change', this.enableLabelCreateButton.bind(this));
      this.$newColorField.on('keyup change', this.enableLabelCreateButton.bind(this));

      this.$dropdownBack.on('click', this.resetForm.bind(this));

      this.$cancelButton.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        self.resetForm();
        self.$dropdownBack.trigger('click');
      });

      this.$newLabelCreateButton.on('click', this.saveLabel.bind(this));
    }
  }, {
    key: 'addColorValue',
    value: function addColorValue(e, $this) {
      e.preventDefault();
      e.stopPropagation();

      this.$newColorField.val($this.data('color')).trigger('change');
      this.$colorPreview.css('background-color', $this.data('color')).parent().addClass('is-active');
    }
  }, {
    key: 'enableLabelCreateButton',
    value: function enableLabelCreateButton() {
      if (this.$newLabelField.val() !== '' && this.$newColorField.val() !== '') {
        this.$newLabelError.hide();
        this.$newLabelCreateButton.enable();
      } else {
        this.$newLabelCreateButton.disable();
      }
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      this.$newLabelField.val('').trigger('change');

      this.$newColorField.val('').trigger('change');

      this.$colorPreview.css('background-color', '').parent().removeClass('is-active');
    }
  }, {
    key: 'saveLabel',
    value: function saveLabel(e) {
      var _this = this;

      e.preventDefault();
      e.stopPropagation();

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].newLabel(this.namespacePath, this.projectPath, {
        title: this.$newLabelField.val(),
        color: this.$newColorField.val()
      }, function (label) {
        _this.$newLabelCreateButton.enable();

        if (label.message) {
          var errors = void 0;

          if (typeof label.message === 'string') {
            errors = label.message;
          } else {
            errors = Object.keys(label.message).map(function (key) {
              return Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__["f" /* humanize */])(key) + ' ' + label.message[key].join(', ');
            }).join('<br/>');
          }

          _this.$newLabelError.html(errors).show();
        } else {
          _this.$dropdownBack.trigger('click');

          $(document).trigger('created.label', label);
        }
      });
    }
  }]);

  return CreateLabelDropdown;
}();

/* harmony default export */ __webpack_exports__["a"] = (CreateLabelDropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./due_date_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday__ = __webpack_require__("../../../node_modules/pikaday/pikaday.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pikaday__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__ = __webpack_require__("./lib/utils/datefix.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global dateFormat */





var DueDateSelect = function () {
  function DueDateSelect() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        $dropdown = _ref.$dropdown,
        $loading = _ref.$loading;

    _classCallCheck(this, DueDateSelect);

    var $dropdownParent = $dropdown.closest('.dropdown');
    var $block = $dropdown.closest('.block');
    this.$loading = $loading;
    this.$dropdown = $dropdown;
    this.$dropdownParent = $dropdownParent;
    this.$datePicker = $dropdownParent.find('.js-due-date-calendar');
    this.$block = $block;
    this.$selectbox = $dropdown.closest('.selectbox');
    this.$value = $block.find('.value');
    this.$valueContent = $block.find('.value-content');
    this.$sidebarValue = $('.js-due-date-sidebar-value', $block);
    this.fieldName = $dropdown.data('fieldName');
    this.abilityName = $dropdown.data('abilityName');
    this.issueUpdateURL = $dropdown.data('issueUpdate');

    this.rawSelectedDate = null;
    this.displayedDate = null;
    this.datePayload = null;

    this.initGlDropdown();
    this.initRemoveDueDate();
    this.initDatePicker();
  }

  _createClass(DueDateSelect, [{
    key: 'initGlDropdown',
    value: function initGlDropdown() {
      var _this = this;

      this.$dropdown.glDropdown({
        opened: function opened() {
          var calendar = _this.$datePicker.data('pikaday');
          calendar.show();
        },
        hidden: function hidden() {
          _this.$selectbox.hide();
          _this.$value.css('display', '');
        }
      });
    }
  }, {
    key: 'initDatePicker',
    value: function initDatePicker() {
      var _this2 = this;

      var $dueDateInput = $('input[name=\'' + this.fieldName + '\']');
      var calendar = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
        field: $dueDateInput.get(0),
        theme: 'gitlab-theme',
        format: 'yyyy-mm-dd',
        parse: function parse(dateString) {
          return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["a" /* parsePikadayDate */])(dateString);
        },
        toString: function toString(date) {
          return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["b" /* pikadayToString */])(date);
        },
        onSelect: function onSelect(dateText) {
          $dueDateInput.val(calendar.toString(dateText));

          if (_this2.$dropdown.hasClass('js-issue-boards-due-date')) {
            gl.issueBoards.BoardsStore.detail.issue.dueDate = $dueDateInput.val();
            _this2.updateIssueBoardIssue();
          } else {
            _this2.saveDueDate(true);
          }
        }
      });

      calendar.setDate(Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["a" /* parsePikadayDate */])($dueDateInput.val()));
      this.$datePicker.append(calendar.el);
      this.$datePicker.data('pikaday', calendar);
    }
  }, {
    key: 'initRemoveDueDate',
    value: function initRemoveDueDate() {
      var _this3 = this;

      this.$block.on('click', '.js-remove-due-date', function (e) {
        var calendar = _this3.$datePicker.data('pikaday');
        e.preventDefault();

        calendar.setDate(null);

        if (_this3.$dropdown.hasClass('js-issue-boards-due-date')) {
          gl.issueBoards.BoardsStore.detail.issue.dueDate = '';
          _this3.updateIssueBoardIssue();
        } else {
          $('input[name=\'' + _this3.fieldName + '\']').val('');
          _this3.saveDueDate(false);
        }
      });
    }
  }, {
    key: 'saveDueDate',
    value: function saveDueDate(isDropdown) {
      this.parseSelectedDate();
      this.prepSelectedDate();
      this.submitSelectedDate(isDropdown);
    }
  }, {
    key: 'parseSelectedDate',
    value: function parseSelectedDate() {
      this.rawSelectedDate = $('input[name=\'' + this.fieldName + '\']').val();

      if (this.rawSelectedDate.length) {
        // Construct Date object manually to avoid buggy dateString support within Date constructor
        var dateArray = this.rawSelectedDate.split('-').map(function (v) {
          return parseInt(v, 10);
        });
        var dateObj = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
        this.displayedDate = dateFormat(dateObj, 'mmm d, yyyy');
      } else {
        this.displayedDate = 'No due date';
      }
    }
  }, {
    key: 'prepSelectedDate',
    value: function prepSelectedDate() {
      var datePayload = {};
      datePayload[this.abilityName] = {};
      datePayload[this.abilityName].due_date = this.rawSelectedDate;
      this.datePayload = datePayload;
    }
  }, {
    key: 'updateIssueBoardIssue',
    value: function updateIssueBoardIssue() {
      var _this4 = this;

      this.$loading.fadeIn();
      this.$dropdown.trigger('loading.gl.dropdown');
      this.$selectbox.hide();
      this.$value.css('display', '');
      var fadeOutLoader = function fadeOutLoader() {
        _this4.$loading.fadeOut();
      };

      gl.issueBoards.BoardsStore.detail.issue.update(this.$dropdown.attr('data-issue-update')).then(fadeOutLoader).catch(fadeOutLoader);
    }
  }, {
    key: 'submitSelectedDate',
    value: function submitSelectedDate(isDropdown) {
      var _this5 = this;

      var selectedDateValue = this.datePayload[this.abilityName].due_date;
      var displayedDateStyle = this.displayedDate !== 'No due date' ? 'bold' : 'no-value';

      this.$loading.removeClass('hidden').fadeIn();

      if (isDropdown) {
        this.$dropdown.trigger('loading.gl.dropdown');
        this.$selectbox.hide();
      }

      this.$value.css('display', '');
      this.$valueContent.html('<span class=\'' + displayedDateStyle + '\'>' + this.displayedDate + '</span>');
      this.$sidebarValue.html(this.displayedDate);

      $('.js-remove-due-date-holder').toggleClass('hidden', selectedDateValue.length);

      return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].put(this.issueUpdateURL, this.datePayload).then(function () {
        if (isDropdown) {
          _this5.$dropdown.trigger('loaded.gl.dropdown');
          _this5.$dropdown.dropdown('toggle');
        }
        return _this5.$loading.fadeOut();
      });
    }
  }]);

  return DueDateSelect;
}();

var DueDateSelectors = function () {
  function DueDateSelectors() {
    _classCallCheck(this, DueDateSelectors);

    this.initMilestoneDatePicker();
    this.initIssuableSelect();
  }
  // eslint-disable-next-line class-methods-use-this


  _createClass(DueDateSelectors, [{
    key: 'initMilestoneDatePicker',
    value: function initMilestoneDatePicker() {
      $('.datepicker').each(function initPikadayMilestone() {
        var $datePicker = $(this);
        var calendar = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
          field: $datePicker.get(0),
          theme: 'gitlab-theme animate-picker',
          format: 'yyyy-mm-dd',
          container: $datePicker.parent().get(0),
          parse: function parse(dateString) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["a" /* parsePikadayDate */])(dateString);
          },
          toString: function toString(date) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["b" /* pikadayToString */])(date);
          },
          onSelect: function onSelect(dateText) {
            $datePicker.val(calendar.toString(dateText));
          }
        });

        calendar.setDate(Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["a" /* parsePikadayDate */])($datePicker.val()));

        $datePicker.data('pikaday', calendar);
      });

      $('.js-clear-due-date,.js-clear-start-date').on('click', function (e) {
        e.preventDefault();
        var calendar = $(e.target).siblings('.datepicker').data('pikaday');
        calendar.setDate(null);
      });
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'initIssuableSelect',
    value: function initIssuableSelect() {
      var $loading = $('.js-issuable-update .due_date').find('.block-loading').hide();

      $('.js-due-date-select').each(function (i, dropdown) {
        var $dropdown = $(dropdown);
        // eslint-disable-next-line no-new
        new DueDateSelect({
          $dropdown: $dropdown,
          $loading: $loading
        });
      });
    }
  }]);

  return DueDateSelectors;
}();

/* harmony default export */ __webpack_exports__["a"] = (DueDateSelectors);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./filtered_search/filtered_search_manager.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./filtered_search/container.js
var container = __webpack_require__("./filtered_search/container.js");

// EXTERNAL MODULE: ./filtered_search/filtered_search_token_keys.js
var filtered_search_token_keys = __webpack_require__("./filtered_search/filtered_search_token_keys.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// CONCATENATED MODULE: ./filtered_search/event_hub.js


/* harmony default export */ var event_hub = (new vue_esm["a" /* default */]());
// EXTERNAL MODULE: ./filtered_search/filtered_search_tokenizer.js
var filtered_search_tokenizer = __webpack_require__("./filtered_search/filtered_search_tokenizer.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./filtered_search/components/recent_searches_dropdown_content.vue




/* harmony default export */ var recent_searches_dropdown_content = ({
  name: 'RecentSearchesDropdownContent',
  props: {
    items: {
      type: Array,
      required: true
    },
    isLocalStorageAvailable: {
      type: Boolean,
      required: false,
      default: true
    },
    allowedKeys: {
      type: Array,
      required: true
    }
  },
  computed: {
    processedItems: function processedItems() {
      var _this = this;

      return this.items.map(function (item) {
        var _FilteredSearchTokeni = filtered_search_tokenizer["a" /* default */].processTokens(item, _this.allowedKeys),
            tokens = _FilteredSearchTokeni.tokens,
            searchToken = _FilteredSearchTokeni.searchToken;

        var resultantTokens = tokens.map(function (token) {
          return {
            prefix: token.key + ':',
            suffix: '' + token.symbol + token.value
          };
        });

        return {
          text: item,
          tokens: resultantTokens,
          searchToken: searchToken
        };
      });
    },
    hasItems: function hasItems() {
      return this.items.length > 0;
    }
  },
  methods: {
    onItemActivated: function onItemActivated(text) {
      event_hub.$emit('recentSearchesItemSelected', text);
    },
    onRequestClearRecentSearches: function onRequestClearRecentSearches(e) {
      // Stop the dropdown from closing
      e.stopPropagation();

      event_hub.$emit('requestClearRecentSearches');
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21b166e4","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./filtered_search/components/recent_searches_dropdown_content.vue
var recent_searches_dropdown_content_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLocalStorageAvailable)?_c('div',{staticClass:"dropdown-info-note"},[_vm._v("\n    This feature requires local storage to be enabled\n  ")]):(_vm.hasItems)?_c('ul',[_vm._l((_vm.processedItems),function(item,index){return _c('li',{key:("processed-items-" + index)},[_c('button',{staticClass:"filtered-search-history-dropdown-item",attrs:{"type":"button"},on:{"click":function($event){_vm.onItemActivated(item.text)}}},[_c('span',_vm._l((item.tokens),function(token,index){return _c('span',{key:("dropdown-token-" + index),staticClass:"filtered-search-history-dropdown-token"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(token.prefix))]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(token.suffix))])])})),_vm._v(" "),_c('span',{staticClass:"filtered-search-history-dropdown-search-token"},[_vm._v("\n          "+_vm._s(item.searchToken)+"\n        ")])])])}),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('button',{staticClass:"filtered-search-history-clear-button",attrs:{"type":"button"},on:{"click":function($event){_vm.onRequestClearRecentSearches($event)}}},[_vm._v("\n        Clear recent searches\n      ")])])],2):_c('div',{staticClass:"dropdown-info-note"},[_vm._v("\n    You don't have any recent searches\n  ")])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./filtered_search/components/recent_searches_dropdown_content.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  recent_searches_dropdown_content,
  recent_searches_dropdown_content_render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_recent_searches_dropdown_content = (Component.exports);

// CONCATENATED MODULE: ./filtered_search/recent_searches_root.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var recent_searches_root_RecentSearchesRoot = function () {
  function RecentSearchesRoot(recentSearchesStore, recentSearchesService, wrapperElement) {
    _classCallCheck(this, RecentSearchesRoot);

    this.store = recentSearchesStore;
    this.service = recentSearchesService;
    this.wrapperElement = wrapperElement;
  }

  _createClass(RecentSearchesRoot, [{
    key: 'init',
    value: function init() {
      this.bindEvents();
      this.render();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.onRequestClearRecentSearchesWrapper = this.onRequestClearRecentSearches.bind(this);

      event_hub.$on('requestClearRecentSearches', this.onRequestClearRecentSearchesWrapper);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      event_hub.$off('requestClearRecentSearches', this.onRequestClearRecentSearchesWrapper);
    }
  }, {
    key: 'render',
    value: function render() {
      var state = this.store.state;
      this.vm = new vue_esm["a" /* default */]({
        el: this.wrapperElement,
        components: {
          RecentSearchesDropdownContent: components_recent_searches_dropdown_content
        },
        data: function data() {
          return state;
        },

        template: '\n        <recent-searches-dropdown-content\n          :items="recentSearches"\n          :is-local-storage-available="isLocalStorageAvailable"\n          :allowed-keys="allowedKeys"\n          />\n      '
      });
    }
  }, {
    key: 'onRequestClearRecentSearches',
    value: function onRequestClearRecentSearches() {
      var resultantSearches = this.store.setRecentSearches([]);
      this.service.save(resultantSearches);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.unbindEvents();
      if (this.vm) {
        this.vm.$destroy();
      }
    }
  }]);

  return RecentSearchesRoot;
}();

/* harmony default export */ var recent_searches_root = (recent_searches_root_RecentSearchesRoot);
// CONCATENATED MODULE: ./filtered_search/stores/recent_searches_store.js
var recent_searches_store__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function recent_searches_store__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var recent_searches_store_RecentSearchesStore = function () {
  function RecentSearchesStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var allowedKeys = arguments[1];

    recent_searches_store__classCallCheck(this, RecentSearchesStore);

    this.state = Object.assign({
      isLocalStorageAvailable: true,
      recentSearches: [],
      allowedKeys: allowedKeys
    }, initialState);
  }

  recent_searches_store__createClass(RecentSearchesStore, [{
    key: 'addRecentSearch',
    value: function addRecentSearch(newSearch) {
      this.setRecentSearches([newSearch].concat(this.state.recentSearches));

      return this.state.recentSearches;
    }
  }, {
    key: 'setRecentSearches',
    value: function setRecentSearches() {
      var searches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var trimmedSearches = searches.map(function (search) {
        return search.trim();
      });
      this.state.recentSearches = underscore_default.a.uniq(trimmedSearches).slice(0, 5);
      return this.state.recentSearches;
    }
  }]);

  return RecentSearchesStore;
}();

/* harmony default export */ var recent_searches_store = (recent_searches_store_RecentSearchesStore);
// CONCATENATED MODULE: ./filtered_search/services/recent_searches_service_error.js
function recent_searches_service_error__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecentSearchesServiceError = function RecentSearchesServiceError(message) {
  recent_searches_service_error__classCallCheck(this, RecentSearchesServiceError);

  this.name = 'RecentSearchesServiceError';
  this.message = message || 'Recent Searches Service is unavailable';
};

// Can't use `extends` for builtin prototypes and get true inheritance yet


RecentSearchesServiceError.prototype = Error.prototype;

/* harmony default export */ var recent_searches_service_error = (RecentSearchesServiceError);
// EXTERNAL MODULE: ./lib/utils/accessor.js
var accessor = __webpack_require__("./lib/utils/accessor.js");

// CONCATENATED MODULE: ./filtered_search/services/recent_searches_service.js
var recent_searches_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function recent_searches_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var recent_searches_service_RecentSearchesService = function () {
  function RecentSearchesService() {
    var localStorageKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'issuable-recent-searches';

    recent_searches_service__classCallCheck(this, RecentSearchesService);

    this.localStorageKey = localStorageKey;
  }

  recent_searches_service__createClass(RecentSearchesService, [{
    key: 'fetch',
    value: function fetch() {
      if (!RecentSearchesService.isAvailable()) {
        var error = new recent_searches_service_error();
        return Promise.reject(error);
      }

      var input = window.localStorage.getItem(this.localStorageKey);

      var searches = [];
      if (input && input.length > 0) {
        try {
          searches = JSON.parse(input);
        } catch (err) {
          return Promise.reject(err);
        }
      }

      return Promise.resolve(searches);
    }
  }, {
    key: 'save',
    value: function save() {
      var searches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (!RecentSearchesService.isAvailable()) return;

      window.localStorage.setItem(this.localStorageKey, JSON.stringify(searches));
    }
  }], [{
    key: 'isAvailable',
    value: function isAvailable() {
      return accessor["a" /* default */].isLocalStorageAccessSafe();
    }
  }]);

  return RecentSearchesService;
}();

/* harmony default export */ var recent_searches_service = (recent_searches_service_RecentSearchesService);
// EXTERNAL MODULE: ./lib/utils/dom_utils.js
var dom_utils = __webpack_require__("./lib/utils/dom_utils.js");

// EXTERNAL MODULE: ./filtered_search/filtered_search_dropdown_manager.js + 8 modules
var filtered_search_dropdown_manager = __webpack_require__("./filtered_search/filtered_search_dropdown_manager.js");

// EXTERNAL MODULE: ./filtered_search/filtered_search_visual_tokens.js + 1 modules
var filtered_search_visual_tokens = __webpack_require__("./filtered_search/filtered_search_visual_tokens.js");

// EXTERNAL MODULE: ./filtered_search/dropdown_utils.js
var dropdown_utils = __webpack_require__("./filtered_search/dropdown_utils.js");

// CONCATENATED MODULE: ./filtered_search/filtered_search_manager.js
var filtered_search_manager__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtered_search_manager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

















var filtered_search_manager_FilteredSearchManager = function () {
  function FilteredSearchManager(_ref) {
    var page = _ref.page,
        _ref$isGroup = _ref.isGroup,
        isGroup = _ref$isGroup === undefined ? false : _ref$isGroup,
        _ref$isGroupAncestor = _ref.isGroupAncestor,
        isGroupAncestor = _ref$isGroupAncestor === undefined ? false : _ref$isGroupAncestor,
        _ref$isGroupDecendent = _ref.isGroupDecendent,
        isGroupDecendent = _ref$isGroupDecendent === undefined ? false : _ref$isGroupDecendent,
        _ref$filteredSearchTo = _ref.filteredSearchTokenKeys,
        filteredSearchTokenKeys = _ref$filteredSearchTo === undefined ? filtered_search_token_keys["a" /* default */] : _ref$filteredSearchTo,
        _ref$stateFiltersSele = _ref.stateFiltersSelector,
        stateFiltersSelector = _ref$stateFiltersSele === undefined ? '.issues-state-filters' : _ref$stateFiltersSele;

    filtered_search_manager__classCallCheck(this, FilteredSearchManager);

    this.isGroup = isGroup;
    this.isGroupAncestor = isGroupAncestor;
    this.isGroupDecendent = isGroupDecendent;
    this.states = ['opened', 'closed', 'merged', 'all'];

    this.page = page;
    this.container = container["a" /* default */].container;
    this.filteredSearchInput = this.container.querySelector('.filtered-search');
    this.filteredSearchInputForm = this.filteredSearchInput.form;
    this.clearSearchButton = this.container.querySelector('.clear-search');
    this.tokensContainer = this.container.querySelector('.tokens-container');
    this.filteredSearchTokenKeys = filteredSearchTokenKeys;
    this.stateFiltersSelector = stateFiltersSelector;
    this.recentsStorageKeyNames = {
      issues: 'issue-recent-searches',
      merge_requests: 'merge-request-recent-searches'
    };

    this.recentSearchesStore = new recent_searches_store({
      isLocalStorageAvailable: recent_searches_service.isAvailable(),
      allowedKeys: this.filteredSearchTokenKeys.getKeys()
    });
    this.searchHistoryDropdownElement = document.querySelector('.js-filtered-search-history-dropdown');
    var fullPath = this.searchHistoryDropdownElement ? this.searchHistoryDropdownElement.dataset.fullPath : 'project';
    var recentSearchesKey = fullPath + '-' + this.recentsStorageKeyNames[this.page];
    this.recentSearchesService = new recent_searches_service(recentSearchesKey);
  }

  filtered_search_manager__createClass(FilteredSearchManager, [{
    key: 'setup',
    value: function setup() {
      var _this = this;

      // Fetch recent searches from localStorage
      this.fetchingRecentSearchesPromise = this.recentSearchesService.fetch().catch(function (error) {
        if (error.name === 'RecentSearchesServiceError') return undefined;
        // eslint-disable-next-line no-new
        new flash["a" /* default */]('An error occurred while parsing recent searches');
        // Gracefully fail to empty array
        return [];
      }).then(function (searches) {
        if (!searches) {
          return;
        }

        // Put any searches that may have come in before
        // we fetched the saved searches ahead of the already saved ones
        var resultantSearches = _this.recentSearchesStore.setRecentSearches(_this.recentSearchesStore.state.recentSearches.concat(searches));
        _this.recentSearchesService.save(resultantSearches);
      });

      if (this.filteredSearchInput) {
        this.tokenizer = filtered_search_tokenizer["a" /* default */];
        this.dropdownManager = new filtered_search_dropdown_manager["a" /* default */]({
          baseEndpoint: this.filteredSearchInput.getAttribute('data-base-endpoint') || '',
          tokenizer: this.tokenizer,
          page: this.page,
          isGroup: this.isGroup,
          isGroupAncestor: this.isGroupAncestor,
          filteredSearchTokenKeys: this.filteredSearchTokenKeys
        });

        this.recentSearchesRoot = new recent_searches_root(this.recentSearchesStore, this.recentSearchesService, this.searchHistoryDropdownElement);
        this.recentSearchesRoot.init();

        this.bindEvents();
        this.loadSearchParamsFromURL();
        this.dropdownManager.setDropdown();
        this.cleanupWrapper = this.cleanup.bind(this);
        document.addEventListener('beforeunload', this.cleanupWrapper);
      }
    }
  }, {
    key: 'cleanup',
    value: function cleanup() {
      this.unbindEvents();
      document.removeEventListener('beforeunload', this.cleanupWrapper);

      if (this.recentSearchesRoot) {
        this.recentSearchesRoot.destroy();
      }
    }
  }, {
    key: 'bindStateEvents',
    value: function bindStateEvents() {
      var _this2 = this;

      this.stateFilters = document.querySelector('.container-fluid ' + this.stateFiltersSelector);

      if (this.stateFilters) {
        this.searchStateWrapper = this.searchState.bind(this);

        this.applyToStateFilters(function (filterEl) {
          filterEl.addEventListener('click', _this2.searchStateWrapper);
        });
      }
    }
  }, {
    key: 'unbindStateEvents',
    value: function unbindStateEvents() {
      var _this3 = this;

      if (this.stateFilters) {
        this.applyToStateFilters(function (filterEl) {
          filterEl.removeEventListener('click', _this3.searchStateWrapper);
        });
      }
    }
  }, {
    key: 'applyToStateFilters',
    value: function applyToStateFilters(callback) {
      var _this4 = this;

      this.stateFilters.querySelectorAll('a[data-state]').forEach(function (filterEl) {
        if (_this4.states.indexOf(filterEl.dataset.state) > -1) {
          callback(filterEl);
        }
      });
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.setDropdownWrapper = this.dropdownManager.setDropdown.bind(this.dropdownManager);
      this.toggleClearSearchButtonWrapper = this.toggleClearSearchButton.bind(this);
      this.handleInputPlaceholderWrapper = this.handleInputPlaceholder.bind(this);
      this.handleInputVisualTokenWrapper = this.handleInputVisualToken.bind(this);
      this.checkForEnterWrapper = this.checkForEnter.bind(this);
      this.onClearSearchWrapper = this.onClearSearch.bind(this);
      this.checkForBackspaceWrapper = this.checkForBackspace.call(this);
      this.removeSelectedTokenKeydownWrapper = this.removeSelectedTokenKeydown.bind(this);
      this.unselectEditTokensWrapper = this.unselectEditTokens.bind(this);
      this.editTokenWrapper = this.editToken.bind(this);
      this.tokenChange = this.tokenChange.bind(this);
      this.addInputContainerFocusWrapper = this.addInputContainerFocus.bind(this);
      this.removeInputContainerFocusWrapper = this.removeInputContainerFocus.bind(this);
      this.onrecentSearchesItemSelectedWrapper = this.onrecentSearchesItemSelected.bind(this);
      this.removeTokenWrapper = this.removeToken.bind(this);

      this.filteredSearchInputForm.addEventListener('submit', this.handleFormSubmit);
      this.filteredSearchInput.addEventListener('input', this.setDropdownWrapper);
      this.filteredSearchInput.addEventListener('input', this.toggleClearSearchButtonWrapper);
      this.filteredSearchInput.addEventListener('input', this.handleInputPlaceholderWrapper);
      this.filteredSearchInput.addEventListener('input', this.handleInputVisualTokenWrapper);
      this.filteredSearchInput.addEventListener('keydown', this.checkForEnterWrapper);
      this.filteredSearchInput.addEventListener('keyup', this.checkForBackspaceWrapper);
      this.filteredSearchInput.addEventListener('click', this.tokenChange);
      this.filteredSearchInput.addEventListener('keyup', this.tokenChange);
      this.filteredSearchInput.addEventListener('focus', this.addInputContainerFocusWrapper);
      this.tokensContainer.addEventListener('click', this.removeTokenWrapper);
      this.tokensContainer.addEventListener('click', this.editTokenWrapper);
      this.clearSearchButton.addEventListener('click', this.onClearSearchWrapper);
      document.addEventListener('click', this.unselectEditTokensWrapper);
      document.addEventListener('click', this.removeInputContainerFocusWrapper);
      document.addEventListener('keydown', this.removeSelectedTokenKeydownWrapper);
      event_hub.$on('recentSearchesItemSelected', this.onrecentSearchesItemSelectedWrapper);

      this.bindStateEvents();
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.filteredSearchInputForm.removeEventListener('submit', this.handleFormSubmit);
      this.filteredSearchInput.removeEventListener('input', this.setDropdownWrapper);
      this.filteredSearchInput.removeEventListener('input', this.toggleClearSearchButtonWrapper);
      this.filteredSearchInput.removeEventListener('input', this.handleInputPlaceholderWrapper);
      this.filteredSearchInput.removeEventListener('input', this.handleInputVisualTokenWrapper);
      this.filteredSearchInput.removeEventListener('keydown', this.checkForEnterWrapper);
      this.filteredSearchInput.removeEventListener('keyup', this.checkForBackspaceWrapper);
      this.filteredSearchInput.removeEventListener('click', this.tokenChange);
      this.filteredSearchInput.removeEventListener('keyup', this.tokenChange);
      this.filteredSearchInput.removeEventListener('focus', this.addInputContainerFocusWrapper);
      this.tokensContainer.removeEventListener('click', this.removeTokenWrapper);
      this.tokensContainer.removeEventListener('click', this.editTokenWrapper);
      this.clearSearchButton.removeEventListener('click', this.onClearSearchWrapper);
      document.removeEventListener('click', this.unselectEditTokensWrapper);
      document.removeEventListener('click', this.removeInputContainerFocusWrapper);
      document.removeEventListener('keydown', this.removeSelectedTokenKeydownWrapper);
      event_hub.$off('recentSearchesItemSelected', this.onrecentSearchesItemSelectedWrapper);

      this.unbindStateEvents();
    }
  }, {
    key: 'checkForBackspace',
    value: function checkForBackspace() {
      var _this5 = this;

      var backspaceCount = 0;

      // closure for keeping track of the number of backspace keystrokes
      return function (e) {
        // 8 = Backspace Key
        // 46 = Delete Key
        if (e.keyCode === 8 || e.keyCode === 46) {
          var _FilteredSearchVisual = filtered_search_visual_tokens["a" /* default */].getLastVisualTokenBeforeInput(),
              lastVisualToken = _FilteredSearchVisual.lastVisualToken;

          var _DropdownUtils$getVis = dropdown_utils["a" /* default */].getVisualTokenValues(lastVisualToken),
              tokenName = _DropdownUtils$getVis.tokenName,
              tokenValue = _DropdownUtils$getVis.tokenValue;

          var canEdit = tokenName && _this5.canEdit && _this5.canEdit(tokenName, tokenValue);

          if (_this5.filteredSearchInput.value === '' && lastVisualToken && canEdit) {
            backspaceCount += 1;

            if (backspaceCount === 2) {
              backspaceCount = 0;
              _this5.filteredSearchInput.value = filtered_search_visual_tokens["a" /* default */].getLastTokenPartial();
              filtered_search_visual_tokens["a" /* default */].removeLastTokenPartial();
            }
          }

          // Reposition dropdown so that it is aligned with cursor
          _this5.dropdownManager.updateCurrentDropdownOffset();
        } else {
          backspaceCount = 0;
        }
      };
    }
  }, {
    key: 'checkForEnter',
    value: function checkForEnter(e) {
      if (e.keyCode === 38 || e.keyCode === 40) {
        var selectionStart = this.filteredSearchInput.selectionStart;

        e.preventDefault();
        this.filteredSearchInput.setSelectionRange(selectionStart, selectionStart);
      }

      if (e.keyCode === 13) {
        var dropdown = this.dropdownManager.mapping[this.dropdownManager.currentDropdown];
        var dropdownEl = dropdown.element;
        var activeElements = dropdownEl.querySelectorAll('.droplab-item-active');

        e.preventDefault();

        if (!activeElements.length) {
          if (this.isHandledAsync) {
            e.stopImmediatePropagation();

            this.filteredSearchInput.blur();
            this.dropdownManager.resetDropdowns();
          } else {
            // Prevent droplab from opening dropdown
            this.dropdownManager.destroyDroplab();
          }

          this.search();
        }
      }
    }
  }, {
    key: 'addInputContainerFocus',
    value: function addInputContainerFocus() {
      Object(dom_utils["a" /* addClassIfElementExists */])(this.filteredSearchInput.closest('.filtered-search-box'), 'focus');
    }
  }, {
    key: 'removeInputContainerFocus',
    value: function removeInputContainerFocus(e) {
      var inputContainer = this.filteredSearchInput.closest('.filtered-search-box');
      var isElementInFilteredSearch = inputContainer && inputContainer.contains(e.target);
      var isElementInDynamicFilterDropdown = e.target.closest('.filter-dropdown') !== null;
      var isElementInStaticFilterDropdown = e.target.closest('ul[data-dropdown]') !== null;

      if (!isElementInFilteredSearch && !isElementInDynamicFilterDropdown && !isElementInStaticFilterDropdown && inputContainer) {
        inputContainer.classList.remove('focus');
      }
    }
  }, {
    key: 'removeToken',
    value: function removeToken(e) {
      var removeButtonSelected = e.target.closest('.remove-token');

      if (removeButtonSelected) {
        e.preventDefault();
        // Prevent editToken from being triggered after token is removed
        e.stopImmediatePropagation();

        var button = e.target.closest('.selectable');
        filtered_search_visual_tokens["a" /* default */].selectToken(button, true);
        this.removeSelectedToken();
      }
    }
  }, {
    key: 'unselectEditTokens',
    value: function unselectEditTokens(e) {
      var inputContainer = this.container.querySelector('.filtered-search-box');
      var isElementInFilteredSearch = inputContainer && inputContainer.contains(e.target);
      var isElementInFilterDropdown = e.target.closest('.filter-dropdown') !== null;
      var isElementTokensContainer = e.target.classList.contains('tokens-container');

      if (!isElementInFilteredSearch && !isElementInFilterDropdown || isElementTokensContainer) {
        filtered_search_visual_tokens["a" /* default */].moveInputToTheRight();
        this.dropdownManager.resetDropdowns();
      }
    }
  }, {
    key: 'editToken',
    value: function editToken(e) {
      var token = e.target.closest('.js-visual-token');
      var sanitizedTokenName = token && token.querySelector('.name').textContent.trim();
      var canEdit = this.canEdit && this.canEdit(sanitizedTokenName);

      if (token && canEdit) {
        e.preventDefault();
        e.stopPropagation();
        filtered_search_visual_tokens["a" /* default */].editToken(token);
        this.tokenChange();
      }
    }
  }, {
    key: 'toggleClearSearchButton',
    value: function toggleClearSearchButton() {
      var query = dropdown_utils["a" /* default */].getSearchQuery();
      var hidden = 'hidden';
      var hasHidden = this.clearSearchButton.classList.contains(hidden);

      if (query.length === 0 && !hasHidden) {
        this.clearSearchButton.classList.add(hidden);
      } else if (query.length && hasHidden) {
        this.clearSearchButton.classList.remove(hidden);
      }
    }
  }, {
    key: 'handleInputPlaceholder',
    value: function handleInputPlaceholder() {
      var query = dropdown_utils["a" /* default */].getSearchQuery();
      var placeholder = 'Search or filter results...';
      var currentPlaceholder = this.filteredSearchInput.placeholder;

      if (query.length === 0 && currentPlaceholder !== placeholder) {
        this.filteredSearchInput.placeholder = placeholder;
      } else if (query.length > 0 && currentPlaceholder !== '') {
        this.filteredSearchInput.placeholder = '';
      }
    }
  }, {
    key: 'removeSelectedTokenKeydown',
    value: function removeSelectedTokenKeydown(e) {
      // 8 = Backspace Key
      // 46 = Delete Key
      if (e.keyCode === 8 || e.keyCode === 46) {
        this.removeSelectedToken();
      }
    }
  }, {
    key: 'removeSelectedToken',
    value: function removeSelectedToken() {
      filtered_search_visual_tokens["a" /* default */].removeSelectedToken();
      this.handleInputPlaceholder();
      this.toggleClearSearchButton();
      this.dropdownManager.updateCurrentDropdownOffset();
    }
  }, {
    key: 'onClearSearch',
    value: function onClearSearch(e) {
      e.preventDefault();
      this.clearSearch();
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      var _this6 = this;

      this.filteredSearchInput.value = '';

      var removeElements = [];

      [].forEach.call(this.tokensContainer.children, function (t) {
        var canClearToken = t.classList.contains('js-visual-token');

        if (canClearToken) {
          var _DropdownUtils$getVis2 = dropdown_utils["a" /* default */].getVisualTokenValues(t),
              tokenName = _DropdownUtils$getVis2.tokenName,
              tokenValue = _DropdownUtils$getVis2.tokenValue;

          canClearToken = _this6.canEdit && _this6.canEdit(tokenName, tokenValue);
        }

        if (canClearToken) {
          removeElements.push(t);
        }
      });

      removeElements.forEach(function (el) {
        el.parentElement.removeChild(el);
      });

      this.clearSearchButton.classList.add('hidden');
      this.handleInputPlaceholder();

      this.dropdownManager.resetDropdowns();

      if (this.isHandledAsync) {
        this.search();
      }
    }
  }, {
    key: 'handleInputVisualToken',
    value: function handleInputVisualToken() {
      var input = this.filteredSearchInput;

      var _tokenizer$processTok = this.tokenizer.processTokens(input.value, this.filteredSearchTokenKeys.getKeys()),
          tokens = _tokenizer$processTok.tokens,
          searchToken = _tokenizer$processTok.searchToken;

      var _FilteredSearchVisual2 = filtered_search_visual_tokens["a" /* default */].getLastVisualTokenBeforeInput(),
          isLastVisualTokenValid = _FilteredSearchVisual2.isLastVisualTokenValid;

      if (isLastVisualTokenValid) {
        tokens.forEach(function (t) {
          input.value = input.value.replace(t.key + ':' + t.symbol + t.value, '');
          filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(t.key, '' + t.symbol + t.value);
        });

        var fragments = searchToken.split(':');
        if (fragments.length > 1) {
          var inputValues = fragments[0].split(' ');
          var tokenKey = underscore_default.a.last(inputValues);

          if (inputValues.length > 1) {
            inputValues.pop();
            var searchTerms = inputValues.join(' ');

            input.value = input.value.replace(searchTerms, '');
            filtered_search_visual_tokens["a" /* default */].addSearchVisualToken(searchTerms);
          }

          filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(tokenKey);
          input.value = input.value.replace(tokenKey + ':', '');
        }
      } else {
        // Keep listening to token until we determine that the user is done typing the token value
        var valueCompletedRegex = /([~%@]{0,1}".+")|([~%@]{0,1}'.+')|^((?![~%@]')(?![~%@]")(?!')(?!")).*/g;

        if (searchToken.match(valueCompletedRegex) && input.value[input.value.length - 1] === ' ') {
          filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(searchToken);

          // Trim the last space as seen in the if statement above
          input.value = input.value.replace(searchToken, '').trim();
        }
      }
    }
  }, {
    key: 'handleFormSubmit',
    value: function handleFormSubmit(e) {
      e.preventDefault();
      this.search();
    }
  }, {
    key: 'saveCurrentSearchQuery',
    value: function saveCurrentSearchQuery() {
      var _this7 = this;

      // Don't save before we have fetched the already saved searches
      this.fetchingRecentSearchesPromise.then(function () {
        var searchQuery = dropdown_utils["a" /* default */].getSearchQuery();
        if (searchQuery.length > 0) {
          var resultantSearches = _this7.recentSearchesStore.addRecentSearch(searchQuery);
          _this7.recentSearchesService.save(resultantSearches);
        }
      }).catch(function () {
        // https://gitlab.com/gitlab-org/gitlab-ce/issues/30821
      });
    }

    // allows for modifying params array when a param can't be included in the URL (e.g. Service Desk)

  }, {
    key: 'getAllParams',
    value: function getAllParams(urlParams) {
      return this.modifyUrlParams ? this.modifyUrlParams(urlParams) : urlParams;
    }
  }, {
    key: 'loadSearchParamsFromURL',
    value: function loadSearchParamsFromURL() {
      var _this8 = this;

      var urlParams = Object(common_utils["l" /* getUrlParamsArray */])();
      var params = this.getAllParams(urlParams);
      var usernameParams = this.getUsernameParams();
      var hasFilteredSearch = false;

      params.forEach(function (p) {
        var split = p.split('=');
        var keyParam = decodeURIComponent(split[0]);
        var value = split[1];

        // Check if it matches edge conditions listed in this.filteredSearchTokenKeys
        var condition = _this8.filteredSearchTokenKeys.searchByConditionUrl(p);

        if (condition) {
          hasFilteredSearch = true;
          var canEdit = _this8.canEdit && _this8.canEdit(condition.tokenKey);
          filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(condition.tokenKey, condition.value, canEdit);
        } else {
          // Sanitize value since URL converts spaces into +
          // Replace before decode so that we know what was originally + versus the encoded +
          var sanitizedValue = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : value;
          var match = _this8.filteredSearchTokenKeys.searchByKeyParam(keyParam);

          if (match) {
            // Use lastIndexOf because the token key is allowed to contain underscore
            // e.g. 'my_reaction' is the token key of 'my_reaction_emoji'
            var lastIndexOf = keyParam.lastIndexOf('_');
            var sanitizedKey = lastIndexOf !== -1 ? keyParam.slice(0, lastIndexOf) : keyParam;
            // Replace underscore with hyphen in the sanitizedkey.
            // e.g. 'my_reaction' => 'my-reaction'
            sanitizedKey = sanitizedKey.replace('_', '-');
            var symbol = match.symbol;
            var quotationsToUse = '';

            if (sanitizedValue.indexOf(' ') !== -1) {
              // Prefer ", but use ' if required
              quotationsToUse = sanitizedValue.indexOf('"') === -1 ? '"' : '\'';
            }

            hasFilteredSearch = true;
            var _canEdit = _this8.canEdit && _this8.canEdit(sanitizedKey, sanitizedValue);
            filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(sanitizedKey, '' + symbol + quotationsToUse + sanitizedValue + quotationsToUse, _canEdit);
          } else if (!match && keyParam === 'assignee_id') {
            var id = parseInt(value, 10);
            if (usernameParams[id]) {
              hasFilteredSearch = true;
              var tokenName = 'assignee';
              var _canEdit2 = _this8.canEdit && _this8.canEdit(tokenName);
              filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(tokenName, '@' + usernameParams[id], _canEdit2);
            }
          } else if (!match && keyParam === 'author_id') {
            var _id = parseInt(value, 10);
            if (usernameParams[_id]) {
              hasFilteredSearch = true;
              var _tokenName = 'author';
              var _canEdit3 = _this8.canEdit && _this8.canEdit(_tokenName);
              filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(_tokenName, '@' + usernameParams[_id], _canEdit3);
            }
          } else if (!match && keyParam === 'search') {
            hasFilteredSearch = true;
            _this8.filteredSearchInput.value = sanitizedValue;
          }
        }
      });

      this.saveCurrentSearchQuery();

      if (hasFilteredSearch) {
        this.clearSearchButton.classList.remove('hidden');
        this.handleInputPlaceholder();
      }
    }
  }, {
    key: 'searchState',
    value: function searchState(e) {
      e.preventDefault();
      var target = e.currentTarget;
      // remove focus outline after click
      target.blur();

      var state = target.dataset && target.dataset.state;

      if (state) {
        this.search(state);
      }
    }
  }, {
    key: 'search',
    value: function search() {
      var _this9 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var paths = [];
      var searchQuery = dropdown_utils["a" /* default */].getSearchQuery();

      this.saveCurrentSearchQuery();

      var _tokenizer$processTok2 = this.tokenizer.processTokens(searchQuery, this.filteredSearchTokenKeys.getKeys()),
          tokens = _tokenizer$processTok2.tokens,
          searchToken = _tokenizer$processTok2.searchToken;

      var currentState = state || Object(common_utils["i" /* getParameterByName */])('state') || 'opened';
      paths.push('state=' + currentState);

      tokens.forEach(function (token) {
        var condition = _this9.filteredSearchTokenKeys.searchByConditionKeyValue(token.key, token.value.toLowerCase());

        var _ref2 = _this9.filteredSearchTokenKeys.searchByKey(token.key) || {},
            param = _ref2.param;
        // Replace hyphen with underscore to use as request parameter
        // e.g. 'my-reaction' => 'my_reaction'


        var underscoredKey = token.key.replace('-', '_');
        var keyParam = param ? underscoredKey + '_' + param : underscoredKey;
        var tokenPath = '';

        if (condition) {
          tokenPath = condition.url;
        } else {
          var tokenValue = token.value;

          if (tokenValue[0] === '\'' && tokenValue[tokenValue.length - 1] === '\'' || tokenValue[0] === '"' && tokenValue[tokenValue.length - 1] === '"') {
            tokenValue = tokenValue.slice(1, tokenValue.length - 1);
          }

          tokenPath = keyParam + '=' + encodeURIComponent(tokenValue);
        }

        paths.push(tokenPath);
      });

      if (searchToken) {
        var sanitized = searchToken.split(' ').map(function (t) {
          return encodeURIComponent(t);
        }).join('+');
        paths.push('search=' + sanitized);
      }

      var parameterizedUrl = '?scope=all&utf8=%E2%9C%93&' + paths.join('&');

      if (this.updateObject) {
        this.updateObject(parameterizedUrl);
      } else {
        Object(url_utility["g" /* visitUrl */])(parameterizedUrl);
      }
    }
  }, {
    key: 'getUsernameParams',
    value: function getUsernameParams() {
      var usernamesById = {};
      try {
        var attribute = this.filteredSearchInput.getAttribute('data-username-params');
        JSON.parse(attribute).forEach(function (user) {
          usernamesById[user.id] = user.username;
        });
      } catch (e) {
        // do nothing
      }
      return usernamesById;
    }
  }, {
    key: 'tokenChange',
    value: function tokenChange() {
      var dropdown = this.dropdownManager.mapping[this.dropdownManager.currentDropdown];

      if (dropdown) {
        var currentDropdownRef = dropdown.reference;

        this.setDropdownWrapper();
        currentDropdownRef.dispatchInputEvent();
      }
    }
  }, {
    key: 'onrecentSearchesItemSelected',
    value: function onrecentSearchesItemSelected(text) {
      this.clearSearch();
      this.filteredSearchInput.value = text;
      this.filteredSearchInput.dispatchEvent(new CustomEvent('input'));
      this.search();
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'canEdit',
    value: function canEdit() {
      return true;
    }
  }]);

  return FilteredSearchManager;
}();

/* harmony default export */ var filtered_search_manager = __webpack_exports__["a"] = (filtered_search_manager_FilteredSearchManager);

/***/ }),

/***/ "./issuable_bulk_update_actions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* eslint-disable comma-dangle, quotes, consistent-return, func-names, array-callback-return, space-before-function-paren, prefer-arrow-callback, max-len, no-unused-expressions, no-sequences, no-underscore-dangle, no-unused-vars, no-param-reassign */




/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        container = _ref.container,
        form = _ref.form,
        issues = _ref.issues,
        prefixId = _ref.prefixId;

    this.prefixId = prefixId || 'issue_';
    this.form = form || this.getElement('.bulk-update');
    this.$labelDropdown = this.form.find('.js-label-select');
    this.issues = issues || this.getElement('.issues-list .issue');
    this.willUpdateLabels = false;
    this.bindEvents();
  },
  bindEvents: function bindEvents() {
    return this.form.off('submit').on('submit', this.onFormSubmit.bind(this));
  },
  onFormSubmit: function onFormSubmit(e) {
    e.preventDefault();
    return this.submit();
  },
  submit: function submit() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */][this.form.attr('method')](this.form.attr('action'), this.getFormDataAsObject()).then(function () {
      return window.location.reload();
    }).catch(function () {
      return _this.onFormSubmitFailure();
    });
  },
  onFormSubmitFailure: function onFormSubmitFailure() {
    this.form.find('[type="submit"]').enable();
    return new __WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */]("Issue update failed");
  },
  getSelectedIssues: function getSelectedIssues() {
    return this.issues.has('.selected_issue:checked');
  },
  getLabelsFromSelection: function getLabelsFromSelection() {
    var labels = [];
    this.getSelectedIssues().map(function () {
      var labelsData = $(this).data('labels');
      if (labelsData) {
        return labelsData.map(function (labelId) {
          if (labels.indexOf(labelId) === -1) {
            return labels.push(labelId);
          }
        });
      }
    });
    return labels;
  },


  /**
   * Will return only labels that were marked previously and the user has unmarked
   * @return {Array} Label IDs
   */

  getUnmarkedIndeterminedLabels: function getUnmarkedIndeterminedLabels() {
    var result = [];
    var labelsToKeep = this.$labelDropdown.data('indeterminate');

    this.getLabelsFromSelection().forEach(function (id) {
      if (labelsToKeep.indexOf(id) === -1) {
        result.push(id);
      }
    });

    return result;
  },


  /**
   * Simple form serialization, it will return just what we need
   * Returns key/value pairs from form data
   */

  getFormDataAsObject: function getFormDataAsObject() {
    var formData = {
      update: {
        state_event: this.form.find('input[name="update[state_event]"]').val(),
        // For Merge Requests
        assignee_id: this.form.find('input[name="update[assignee_id]"]').val(),
        // For Issues
        assignee_ids: [this.form.find('input[name="update[assignee_ids][]"]').val()],
        milestone_id: this.form.find('input[name="update[milestone_id]"]').val(),
        issuable_ids: this.form.find('input[name="update[issuable_ids]"]').val(),
        subscription_event: this.form.find('input[name="update[subscription_event]"]').val(),
        add_label_ids: [],
        remove_label_ids: []
      }
    };
    if (this.willUpdateLabels) {
      formData.update.add_label_ids = this.$labelDropdown.data('marked');
      formData.update.remove_label_ids = this.$labelDropdown.data('unmarked');
    }
    return formData;
  },
  setOriginalDropdownData: function setOriginalDropdownData() {
    var $labelSelect = $('.bulk-update .js-label-select');
    $labelSelect.data('common', this.getOriginalCommonIds());
    $labelSelect.data('marked', this.getOriginalMarkedIds());
    $labelSelect.data('indeterminate', this.getOriginalIndeterminateIds());
  },


  // From issuable's initial bulk selection
  getOriginalCommonIds: function getOriginalCommonIds() {
    var _this2 = this;

    var labelIds = [];

    this.getElement('.selected_issue:checked').each(function (i, el) {
      labelIds.push(_this2.getElement('#' + _this2.prefixId + el.dataset.id).data('labels'));
    });
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds);
  },


  // From issuable's initial bulk selection
  getOriginalMarkedIds: function getOriginalMarkedIds() {
    var _this3 = this;

    var labelIds = [];
    this.getElement('.selected_issue:checked').each(function (i, el) {
      labelIds.push(_this3.getElement('#' + _this3.prefixId + el.dataset.id).data('labels'));
    });
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds);
  },


  // From issuable's initial bulk selection
  getOriginalIndeterminateIds: function getOriginalIndeterminateIds() {
    var _this4 = this;

    var uniqueIds = [];
    var labelIds = [];
    var issuableLabels = [];

    // Collect unique label IDs for all checked issues
    this.getElement('.selected_issue:checked').each(function (i, el) {
      issuableLabels = _this4.getElement('#' + _this4.prefixId + el.dataset.id).data('labels');
      issuableLabels.forEach(function (labelId) {
        // Store unique IDs
        if (uniqueIds.indexOf(labelId) === -1) {
          uniqueIds.push(labelId);
        }
      });
      // Store array of IDs per issuable
      labelIds.push(issuableLabels);
    });
    // Add uniqueIds to add it as argument for _.intersection
    labelIds.unshift(uniqueIds);
    // Return IDs that are present but not in all selected issueables
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.difference(uniqueIds, __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds));
  },
  getElement: function getElement(selector) {
    this.scopeEl = this.scopeEl || $('.content');
    return this.scopeEl.find(selector);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issuable_context.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__("./breakpoints.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_select__ = __webpack_require__("./users_select.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var IssuableContext = function IssuableContext(currentUser) {
  _classCallCheck(this, IssuableContext);

  this.userSelect = new __WEBPACK_IMPORTED_MODULE_2__users_select__["a" /* default */](currentUser);

  $('select.select2').select2({
    width: 'resolve',
    dropdownAutoWidth: true
  });

  $('.issuable-sidebar .inline-update').on('change', 'select', function onClickSelect() {
    return $(this).submit();
  });
  $('.issuable-sidebar .inline-update').on('change', '.js-assignee', function onClickAssignee() {
    return $(this).submit();
  });
  $(document).off('click', '.issuable-sidebar .dropdown-content a').on('click', '.issuable-sidebar .dropdown-content a', function (e) {
    return e.preventDefault();
  });

  $(document).off('click', '.edit-link').on('click', '.edit-link', function onClickEdit(e) {
    e.preventDefault();
    var $block = $(this).parents('.block');
    var $selectbox = $block.find('.selectbox');
    if ($selectbox.is(':visible')) {
      $selectbox.hide();
      $block.find('.value').show();
    } else {
      $selectbox.show();
      $block.find('.value').hide();
    }

    if ($selectbox.is(':visible')) {
      setTimeout(function () {
        return $block.find('.dropdown-menu-toggle').trigger('click');
      }, 0);
    }
  });

  window.addEventListener('beforeunload', function () {
    // collapsed_gutter cookie hides the sidebar
    var bpBreakpoint = __WEBPACK_IMPORTED_MODULE_1__breakpoints__["a" /* default */].getBreakpointSize();
    if (bpBreakpoint === 'xs' || bpBreakpoint === 'sm') {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('collapsed_gutter', true);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (IssuableContext);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./labels_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__ = __webpack_require__("./issuable_bulk_update_actions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtered_search_dropdown_utils__ = __webpack_require__("./filtered_search/dropdown_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__create_label__ = __webpack_require__("./create_label.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flash__ = __webpack_require__("./flash.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-useless-return, func-names, space-before-function-paren, wrap-iife, no-var, no-underscore-dangle, prefer-arrow-callback, max-len, one-var, no-unused-vars, one-var-declaration-per-line, prefer-template, no-new, consistent-return, object-shorthand, comma-dangle, no-shadow, no-param-reassign, brace-style, vars-on-top, quotes, no-lonely-if, no-else-return, dot-notation, no-empty, no-return-assign, camelcase, prefer-spread */
/* global Issuable */
/* global ListLabel */








var LabelsSelect = function () {
  function LabelsSelect(els) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, LabelsSelect);

    var _this, $els;
    _this = this;

    $els = $(els);

    if (!els) {
      $els = $('.js-label-select');
    }

    $els.each(function (i, dropdown) {
      var $block, $colorPreview, $dropdown, $form, $loading, $selectbox, $sidebarCollapsedValue, $value, abilityName, defaultLabel, enableLabelCreateButton, issueURLSplit, issueUpdateURL, labelUrl, namespacePath, projectPath, saveLabelData, selectedLabel, showAny, showNo, $sidebarLabelTooltip, initialSelected, $toggleText, fieldName, useId, propertyName, showMenuAbove, $container, $dropdownContainer;
      $dropdown = $(dropdown);
      $dropdownContainer = $dropdown.closest('.labels-filter');
      $toggleText = $dropdown.find('.dropdown-toggle-text');
      namespacePath = $dropdown.data('namespacePath');
      projectPath = $dropdown.data('projectPath');
      labelUrl = $dropdown.data('labels');
      issueUpdateURL = $dropdown.data('issueUpdate');
      selectedLabel = $dropdown.data('selected');
      if (selectedLabel != null && !$dropdown.hasClass('js-multiselect')) {
        selectedLabel = selectedLabel.split(',');
      }
      showNo = $dropdown.data('showNo');
      showAny = $dropdown.data('showAny');
      showMenuAbove = $dropdown.data('showMenuAbove');
      defaultLabel = $dropdown.data('defaultLabel');
      abilityName = $dropdown.data('abilityName');
      $selectbox = $dropdown.closest('.selectbox');
      $block = $selectbox.closest('.block');
      $form = $dropdown.closest('form, .js-issuable-update');
      $sidebarCollapsedValue = $block.find('.sidebar-collapsed-icon span');
      $sidebarLabelTooltip = $block.find('.js-sidebar-labels-tooltip');
      $value = $block.find('.value');
      $loading = $block.find('.block-loading').fadeOut();
      fieldName = $dropdown.data('fieldName');
      useId = $dropdown.is('.js-issuable-form-dropdown, .js-filter-bulk-update, .js-label-sidebar-dropdown');
      propertyName = useId ? 'id' : 'title';
      initialSelected = $selectbox.find('input[name="' + $dropdown.data('fieldName') + '"]').map(function () {
        return this.value;
      }).get();
      var handleClick = options.handleClick;

      $sidebarLabelTooltip.tooltip();

      if ($dropdown.closest('.dropdown').find('.dropdown-new-label').length) {
        new __WEBPACK_IMPORTED_MODULE_5__create_label__["a" /* default */]($dropdown.closest('.dropdown').find('.dropdown-new-label'), namespacePath, projectPath);
      }

      saveLabelData = function saveLabelData() {
        var data, selected;
        selected = $dropdown.closest('.selectbox').find("input[name='" + fieldName + "']").map(function () {
          return this.value;
        }).get();

        if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEqual(initialSelected, selected)) return;
        initialSelected = selected;

        data = {};
        data[abilityName] = {};
        data[abilityName].label_ids = selected;
        if (!selected.length) {
          data[abilityName].label_ids = [''];
        }
        $loading.removeClass('hidden').fadeIn();
        $dropdown.trigger('loading.gl.dropdown');
        __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].put(issueUpdateURL, data).then(function (_ref) {
          var data = _ref.data;

          var labelCount, template, labelTooltipTitle, labelTitles;
          $loading.fadeOut();
          $dropdown.trigger('loaded.gl.dropdown');
          $selectbox.hide();
          data.issueUpdateURL = issueUpdateURL;
          labelCount = 0;
          if (data.labels.length && issueUpdateURL) {
            template = LabelsSelect.getLabelTemplate({
              labels: data.labels,
              issueUpdateURL: issueUpdateURL
            });
            labelCount = data.labels.length;
          } else {
            template = '<span class="no-value">None</span>';
          }
          $value.removeAttr('style').html(template);
          $sidebarCollapsedValue.text(labelCount);

          if (data.labels.length) {
            labelTitles = data.labels.map(function (label) {
              return label.title;
            });

            if (labelTitles.length > 5) {
              labelTitles = labelTitles.slice(0, 5);
              labelTitles.push('and ' + (data.labels.length - 5) + ' more');
            }

            labelTooltipTitle = labelTitles.join(', ');
          } else {
            labelTooltipTitle = '';
            $sidebarLabelTooltip.tooltip('destroy');
          }

          $sidebarLabelTooltip.attr('title', labelTooltipTitle).tooltip('fixTitle');

          $('.has-tooltip', $value).tooltip({
            container: 'body'
          });
        }).catch(function () {
          return Object(__WEBPACK_IMPORTED_MODULE_6__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Error saving label update.'));
        });
      };
      $dropdown.glDropdown({
        showMenuAbove: showMenuAbove,
        data: function data(term, callback) {
          __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(labelUrl).then(function (res) {
            var data = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.chain(res.data).groupBy(function (label) {
              return label.title;
            }).map(function (label) {
              var color;
              color = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.map(label, function (dup) {
                return dup.color;
              });
              return {
                id: label[0].id,
                title: label[0].title,
                color: color,
                duplicate: color.length > 1
              };
            }).value();
            if ($dropdown.hasClass('js-extra-options')) {
              var extraData = [];
              if (showNo) {
                extraData.unshift({
                  id: 0,
                  title: '没有标记'
                });
              }
              if (showAny) {
                extraData.unshift({
                  isAny: true,
                  title: '所有标记'
                });
              }
              if (extraData.length) {
                extraData.push('divider');
                data = extraData.concat(data);
              }
            }

            callback(data);
            if (showMenuAbove) {
              $dropdown.data('glDropdown').positionMenuAbove();
            }
          }).catch(function () {
            return Object(__WEBPACK_IMPORTED_MODULE_6__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Error fetching labels.'));
          });
        },
        renderRow: function renderRow(label, instance) {
          var $a, $li, color, colorEl, indeterminate, removesAll, selectedClass, spacing, i, marked, dropdownName, dropdownValue;
          $li = $('<li>');
          $a = $('<a href="#">');
          selectedClass = [];
          removesAll = label.id <= 0 || label.id == null;
          if ($dropdown.hasClass('js-filter-bulk-update')) {
            indeterminate = $dropdown.data('indeterminate') || [];
            marked = $dropdown.data('marked') || [];

            if (indeterminate.indexOf(label.id) !== -1) {
              selectedClass.push('is-indeterminate');
            }

            if (marked.indexOf(label.id) !== -1) {
              // Remove is-indeterminate class if the item will be marked as active
              i = selectedClass.indexOf('is-indeterminate');
              if (i !== -1) {
                selectedClass.splice(i, 1);
              }
              selectedClass.push('is-active');
            }
          } else {
            if (this.id(label)) {
              dropdownName = $dropdown.data('fieldName');
              dropdownValue = this.id(label).toString().replace(/'/g, '\\\'');

              if ($form.find("input[type='hidden'][name='" + dropdownName + "'][value='" + dropdownValue + "']").length) {
                selectedClass.push('is-active');
              }
            }

            if ($dropdown.hasClass('js-multiselect') && removesAll) {
              selectedClass.push('dropdown-clear-active');
            }
          }
          if (label.duplicate) {
            color = __WEBPACK_IMPORTED_MODULE_4__filtered_search_dropdown_utils__["a" /* default */].duplicateLabelColor(label.color);
          } else {
            if (label.color != null) {
              color = label.color[0];
            }
          }
          if (color) {
            colorEl = "<span class='dropdown-label-box' style='background: " + color + "'></span>";
          } else {
            colorEl = '';
          }
          // We need to identify which items are actually labels
          if (label.id) {
            selectedClass.push('label-item');
            $a.attr('data-label-id', label.id);
          }
          $a.addClass(selectedClass.join(' ')).html(colorEl + ' ' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(label.title));
          // Return generated html
          return $li.html($a).prop('outerHTML');
        },
        search: {
          fields: ['title']
        },
        selectable: true,
        filterable: true,
        selected: $dropdown.data('selected') || [],
        toggleLabel: function toggleLabel(selected, el) {
          var $dropdownParent = $dropdown.parent();
          var $dropdownInputField = $dropdownParent.find('.dropdown-input-field');
          var isSelected = el !== null ? el.hasClass('is-active') : false;
          var title = selected.title;
          var selectedLabels = this.selected;

          if ($dropdownInputField.length && $dropdownInputField.val().length) {
            $dropdownParent.find('.dropdown-input-clear').trigger('click');
          }

          if (selected.id === 0) {
            this.selected = [];
            return '无标记';
          } else if (isSelected) {
            this.selected.push(title);
          } else {
            var index = this.selected.indexOf(title);
            this.selected.splice(index, 1);
          }

          if (selectedLabels.length === 1) {
            return selectedLabels;
          } else if (selectedLabels.length) {
            return selectedLabels[0] + " +" + (selectedLabels.length - 1) + " more";
          } else {
            return defaultLabel;
          }
        },
        fieldName: $dropdown.data('fieldName'),
        id: function id(label) {
          if (label.id <= 0) return label.title;

          if ($dropdown.hasClass('js-issuable-form-dropdown')) {
            return label.id;
          }

          if ($dropdown.hasClass("js-filter-submit") && label.isAny == null) {
            return label.title;
          } else {
            return label.id;
          }
        },
        hidden: function hidden() {
          var isIssueIndex, isMRIndex, page, selectedLabels;
          page = $('body').attr('data-page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === 'projects:merge_requests:index';
          $selectbox.hide();
          // display:block overrides the hide-collapse rule
          $value.removeAttr('style');

          if ($dropdown.hasClass('js-issuable-form-dropdown')) {
            return;
          }

          if ($('html').hasClass('issue-boards-page')) {
            return;
          }
          if ($dropdown.hasClass('js-multiselect')) {
            if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
              selectedLabels = $dropdown.closest('form').find("input:hidden[name='" + $dropdown.data('fieldName') + "']");
              Issuable.filterResults($dropdown.closest('form'));
            } else if ($dropdown.hasClass('js-filter-submit')) {
              $dropdown.closest('form').submit();
            } else {
              if (!$dropdown.hasClass('js-filter-bulk-update')) {
                saveLabelData();
              }
            }
          }
        },
        multiSelect: $dropdown.hasClass('js-multiselect'),
        vue: $dropdown.hasClass('js-issue-board-sidebar'),
        clicked: function clicked(clickEvent) {
          var $el = clickEvent.$el,
              e = clickEvent.e,
              isMarking = clickEvent.isMarking;

          var label = clickEvent.selectedObj;

          var isIssueIndex, isMRIndex, page, boardsModel;
          var fadeOutLoader = function fadeOutLoader() {
            $loading.fadeOut();
          };

          page = $('body').attr('data-page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === 'projects:merge_requests:index';

          if ($dropdown.parent().find('.is-active:not(.dropdown-clear-active)').length) {
            $dropdown.parent().find('.dropdown-clear-active').removeClass('is-active');
          }

          if ($dropdown.hasClass('js-issuable-form-dropdown')) {
            return;
          }

          if ($dropdown.hasClass('js-filter-bulk-update')) {
            _this.enableBulkLabelDropdown();
            _this.setDropdownData($dropdown, isMarking, label.id);
            return;
          }

          if ($dropdown.closest('.add-issues-modal').length) {
            boardsModel = gl.issueBoards.ModalStore.store.filter;
          }

          if (boardsModel) {
            if (label.isAny) {
              boardsModel['label_name'] = [];
            } else if ($el.hasClass('is-active')) {
              boardsModel['label_name'].push(label.title);
            }

            e.preventDefault();
            return;
          } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
            if (!$dropdown.hasClass('js-multiselect')) {
              selectedLabel = label.title;
              return Issuable.filterResults($dropdown.closest('form'));
            }
          } else if ($dropdown.hasClass('js-filter-submit')) {
            return $dropdown.closest('form').submit();
          } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
            if ($el.hasClass('is-active')) {
              gl.issueBoards.BoardsStore.detail.issue.labels.push(new ListLabel({
                id: label.id,
                title: label.title,
                color: label.color[0],
                textColor: '#fff'
              }));
            } else {
              var labels = gl.issueBoards.BoardsStore.detail.issue.labels;
              labels = labels.filter(function (selectedLabel) {
                return selectedLabel.id !== label.id;
              });
              gl.issueBoards.BoardsStore.detail.issue.labels = labels;
            }

            $loading.fadeIn();

            gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(fadeOutLoader).catch(fadeOutLoader);
          } else if (handleClick) {
            e.preventDefault();
            handleClick(label);
          } else {
            if ($dropdown.hasClass('js-multiselect')) {} else {
              return saveLabelData();
            }
          }
        }
      });

      // Set dropdown data
      _this.setOriginalDropdownData($dropdownContainer, $dropdown);
    });
    this.bindEvents();
  }

  _createClass(LabelsSelect, [{
    key: 'bindEvents',
    value: function bindEvents() {
      return $('body').on('change', '.selected_issue', this.onSelectCheckboxIssue);
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'onSelectCheckboxIssue',
    value: function onSelectCheckboxIssue() {
      if ($('.selected_issue:checked').length) {
        return;
      }
      return $('.issues-bulk-update .labels-filter .dropdown-toggle-text').text('Label');
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'enableBulkLabelDropdown',
    value: function enableBulkLabelDropdown() {
      __WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__["a" /* default */].willUpdateLabels = true;
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'setDropdownData',
    value: function setDropdownData($dropdown, isMarking, value) {
      var i, markedIds, unmarkedIds, indeterminateIds;

      markedIds = $dropdown.data('marked') || [];
      unmarkedIds = $dropdown.data('unmarked') || [];
      indeterminateIds = $dropdown.data('indeterminate') || [];

      if (isMarking) {
        markedIds.push(value);

        i = indeterminateIds.indexOf(value);
        if (i > -1) {
          indeterminateIds.splice(i, 1);
        }

        i = unmarkedIds.indexOf(value);
        if (i > -1) {
          unmarkedIds.splice(i, 1);
        }
      } else {
        // If marked item (not common) is unmarked
        i = markedIds.indexOf(value);
        if (i > -1) {
          markedIds.splice(i, 1);
        }

        // If an indeterminate item is being unmarked
        if (__WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__["a" /* default */].getOriginalIndeterminateIds().indexOf(value) > -1) {
          unmarkedIds.push(value);
        }

        // If a marked item is being unmarked
        // (a marked item could also be a label that is present in all selection)
        if (__WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__["a" /* default */].getOriginalCommonIds().indexOf(value) > -1) {
          unmarkedIds.push(value);
        }
      }

      $dropdown.data('marked', markedIds);
      $dropdown.data('unmarked', unmarkedIds);
      $dropdown.data('indeterminate', indeterminateIds);
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'setOriginalDropdownData',
    value: function setOriginalDropdownData($container, $dropdown) {
      var labels = [];
      $container.find('[name="label_name[]"]').map(function () {
        return labels.push(this.value);
      });
      $dropdown.data('marked', labels);
    }
  }], [{
    key: 'getLabelTemplate',
    value: function getLabelTemplate(tplData) {
      // We could use ES6 template string here
      // and properly indent markup for readability
      // but that also introduces unintended white-space
      // so best approach is to use traditional way of
      // concatenation
      // see: http://2ality.com/2016/05/template-literal-whitespace.html#joining-arrays
      var tpl = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template(['<% _.each(labels, function(label){ %>', '<a href="<%- issueUpdateURL.slice(0, issueUpdateURL.lastIndexOf("/")) %>?label_name[]=<%- encodeURIComponent(label.title) %>">', '<span class="label has-tooltip color-label" title="<%- label.description %>" style="background-color: <%- label.color %>; color: <%- label.text_color %>;">', '<%- label.title %>', '</span>', '</a>', '<% }); %>'].join(''));

      return tpl(tplData);
    }
  }]);

  return LabelsSelect;
}();

/* harmony default export */ __webpack_exports__["a"] = (LabelsSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/datefix.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pad */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parsePikadayDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pikadayToString; });

var pad = function pad(val) {
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return ('0' + val).slice(-len);
};

/**
 * Formats dates in Pickaday
 * @param {String} dateString Date in yyyy-mm-dd format
 * @return {Date} UTC format
 */
var parsePikadayDate = function parsePikadayDate(dateString) {
  var parts = dateString.split('-');
  var year = parseInt(parts[0], 10);
  var month = parseInt(parts[1] - 1, 10);
  var day = parseInt(parts[2], 10);

  return new Date(year, month, day);
};

/**
 * Used `onSelect` method in pickaday
 * @param {Date} date UTC format
 * @return {String} Date formated in yyyy-mm-dd
 */
var pikadayToString = function pikadayToString(date) {
  var day = pad(date.getDate());
  var month = pad(date.getMonth() + 1);
  var year = date.getFullYear();

  return year + '-' + month + '-' + day;
};

/***/ }),

/***/ "./pages/projects/boards/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users_select__ = __webpack_require__("./users_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortcuts_navigation__ = __webpack_require__("./shortcuts_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__boards__ = __webpack_require__("./boards/index.js");




document.addEventListener('DOMContentLoaded', function () {
  new __WEBPACK_IMPORTED_MODULE_0__users_select__["a" /* default */](); // eslint-disable-line no-new
  new __WEBPACK_IMPORTED_MODULE_1__shortcuts_navigation__["a" /* default */](); // eslint-disable-line no-new
  Object(__WEBPACK_IMPORTED_MODULE_2__boards__["a" /* default */])();
});

/***/ }),

/***/ "./right_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-unused-vars, consistent-return, one-var, one-var-declaration-per-line, quotes, prefer-template, object-shorthand, comma-dangle, no-else-return, no-param-reassign, max-len */






function Sidebar(currentUser) {
  this.toggleTodo = this.toggleTodo.bind(this);
  this.sidebar = $('aside');

  this.removeListeners();
  this.addEventListeners();
}

Sidebar.initialize = function (currentUser) {
  if (!this.instance) {
    this.instance = new Sidebar(currentUser);
  }
};

Sidebar.prototype.removeListeners = function () {
  this.sidebar.off('click', '.sidebar-collapsed-icon');
  this.sidebar.off('hidden.gl.dropdown');
  $('.dropdown').off('loading.gl.dropdown');
  $('.dropdown').off('loaded.gl.dropdown');
  $(document).off('click', '.js-sidebar-toggle');
};

Sidebar.prototype.addEventListeners = function () {
  var $document = $(document);

  this.sidebar.on('click', '.sidebar-collapsed-icon', this, this.sidebarCollapseClicked);
  this.sidebar.on('hidden.gl.dropdown', this, this.onSidebarDropdownHidden);
  $('.dropdown').on('loading.gl.dropdown', this.sidebarDropdownLoading);
  $('.dropdown').on('loaded.gl.dropdown', this.sidebarDropdownLoaded);

  $document.on('click', '.js-sidebar-toggle', this.sidebarToggleClicked);
  return $(document).off('click', '.js-issuable-todo').on('click', '.js-issuable-todo', this.toggleTodo);
};

Sidebar.prototype.sidebarToggleClicked = function (e, triggered) {
  var $allGutterToggleIcons, $this, $thisIcon;
  e.preventDefault();
  $this = $(this);
  $thisIcon = $this.find('i');
  $allGutterToggleIcons = $('.js-sidebar-toggle i');
  if ($thisIcon.hasClass('fa-angle-double-right')) {
    $allGutterToggleIcons.removeClass('fa-angle-double-right').addClass('fa-angle-double-left');
    $('aside.right-sidebar').removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
    $('.layout-page').removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
  } else {
    $allGutterToggleIcons.removeClass('fa-angle-double-left').addClass('fa-angle-double-right');
    $('aside.right-sidebar').removeClass('right-sidebar-collapsed').addClass('right-sidebar-expanded');
    $('.layout-page').removeClass('right-sidebar-collapsed').addClass('right-sidebar-expanded');

    if (gl.lazyLoader) gl.lazyLoader.loadCheck();
  }
  if (!triggered) {
    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set("collapsed_gutter", $('.right-sidebar').hasClass('right-sidebar-collapsed'));
  }
};

Sidebar.prototype.toggleTodo = function (e) {
  var _this = this;

  var $btnText, $this, $todoLoading, ajaxType, url;
  $this = $(e.currentTarget);
  ajaxType = $this.attr('data-delete-path') ? 'delete' : 'post';
  if ($this.attr('data-delete-path')) {
    url = "" + $this.attr('data-delete-path');
  } else {
    url = "" + $this.data('url');
  }

  $this.tooltip('hide');

  $('.js-issuable-todo').disable().addClass('is-loading');

  __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__["a" /* default */][ajaxType](url, {
    issuable_id: $this.data('issuableId'),
    issuable_type: $this.data('issuableType')
  }).then(function (_ref) {
    var data = _ref.data;

    _this.todoUpdateDone(data);
  }).catch(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])('There was an error ' + (ajaxType === 'post' ? 'adding a' : 'deleting the') + ' todo.');
  });
};

Sidebar.prototype.todoUpdateDone = function (data) {
  var deletePath = data.delete_path ? data.delete_path : null;
  var attrPrefix = deletePath ? 'mark' : 'todo';
  var $todoBtns = $('.js-issuable-todo');

  $(document).trigger('todo:toggle', data.count);

  $todoBtns.each(function (i, el) {
    var $el = $(el);
    var $elText = $el.find('.js-issuable-todo-inner');

    $el.removeClass('is-loading').enable().attr('aria-label', $el.data(attrPrefix + 'Text')).attr('data-delete-path', deletePath).attr('title', $el.data(attrPrefix + 'Text'));

    if ($el.hasClass('has-tooltip')) {
      $el.tooltip('fixTitle');
    }

    if ($el.data(attrPrefix + 'Icon')) {
      $elText.html($el.data(attrPrefix + 'Icon'));
    } else {
      $elText.text($el.data(attrPrefix + 'Text'));
    }
  });
};

Sidebar.prototype.sidebarDropdownLoading = function (e) {
  var $loading, $sidebarCollapsedIcon, i, img;
  $sidebarCollapsedIcon = $(this).closest('.block').find('.sidebar-collapsed-icon');
  img = $sidebarCollapsedIcon.find('img');
  i = $sidebarCollapsedIcon.find('i');
  $loading = $('<i class="fa fa-spinner fa-spin"></i>');
  if (img.length) {
    img.before($loading);
    return img.hide();
  } else if (i.length) {
    i.before($loading);
    return i.hide();
  }
};

Sidebar.prototype.sidebarDropdownLoaded = function (e) {
  var $sidebarCollapsedIcon, i, img;
  $sidebarCollapsedIcon = $(this).closest('.block').find('.sidebar-collapsed-icon');
  img = $sidebarCollapsedIcon.find('img');
  $sidebarCollapsedIcon.find('i.fa-spin').remove();
  i = $sidebarCollapsedIcon.find('i');
  if (img.length) {
    return img.show();
  } else {
    return i.show();
  }
};

Sidebar.prototype.sidebarCollapseClicked = function (e) {
  var $block, sidebar;
  if ($(e.currentTarget).hasClass('dont-change-state')) {
    return;
  }
  sidebar = e.data;
  e.preventDefault();
  $block = $(this).closest('.block');
  return sidebar.openDropdown($block);
};

Sidebar.prototype.openDropdown = function (blockOrName) {
  var $block;
  $block = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(blockOrName) ? this.getBlock(blockOrName) : blockOrName;
  if (!this.isOpen()) {
    this.setCollapseAfterUpdate($block);
    this.toggleSidebar('open');
  }

  // Wait for the sidebar to trigger('click') open
  // so it doesn't cause our dropdown to close preemptively
  setTimeout(function () {
    $block.find('.js-sidebar-dropdown-toggle').trigger('click');
  });
};

Sidebar.prototype.setCollapseAfterUpdate = function ($block) {
  $block.addClass('collapse-after-update');
  return $('.layout-page').addClass('with-overlay');
};

Sidebar.prototype.onSidebarDropdownHidden = function (e) {
  var $block, sidebar;
  sidebar = e.data;
  e.preventDefault();
  $block = $(e.target).closest('.block');
  return sidebar.sidebarDropdownHidden($block);
};

Sidebar.prototype.sidebarDropdownHidden = function ($block) {
  if ($block.hasClass('collapse-after-update')) {
    $block.removeClass('collapse-after-update');
    $('.layout-page').removeClass('with-overlay');
    return this.toggleSidebar('hide');
  }
};

Sidebar.prototype.triggerOpenSidebar = function () {
  return this.sidebar.find('.js-sidebar-toggle').trigger('click');
};

Sidebar.prototype.toggleSidebar = function (action) {
  if (action == null) {
    action = 'toggle';
  }
  if (action === 'toggle') {
    this.triggerOpenSidebar();
  }
  if (action === 'open') {
    if (!this.isOpen()) {
      this.triggerOpenSidebar();
    }
  }
  if (action === 'hide') {
    if (this.isOpen()) {
      return this.triggerOpenSidebar();
    }
  }
};

Sidebar.prototype.isOpen = function () {
  return this.sidebar.is('.right-sidebar-expanded');
};

Sidebar.prototype.getBlock = function (name) {
  return this.sidebar.find(".block." + name);
};

/* harmony default export */ __webpack_exports__["a"] = (Sidebar);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./shortcuts_navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__ = __webpack_require__("./shortcuts_dashboard_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shortcuts__ = __webpack_require__("./shortcuts.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ShortcutsNavigation = function (_Shortcuts) {
  _inherits(ShortcutsNavigation, _Shortcuts);

  function ShortcutsNavigation() {
    _classCallCheck(this, ShortcutsNavigation);

    var _this = _possibleConstructorReturn(this, (ShortcutsNavigation.__proto__ || Object.getPrototypeOf(ShortcutsNavigation)).call(this));

    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g p', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g e', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project-activity');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g f', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-tree');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g c', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-commits');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g j', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-builds');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g n', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-network');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g d', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-repository-charts');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issues');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g b', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issue-boards');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g m', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-merge_requests');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g t', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-todos');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g w', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-wiki');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g s', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-snippets');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-new-issue');
    });

    _this.enabledHelp.push('.hidden-shortcut.project');
    return _this;
  }

  return ShortcutsNavigation;
}(__WEBPACK_IMPORTED_MODULE_2__shortcuts__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ShortcutsNavigation);

/***/ }),

/***/ "./sidebar/components/assignees/assignee_title.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AssigneeTitle',
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    numberOfAssignees: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    },
    showToggle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    assigneeTitle: function assigneeTitle() {
      var assignees = this.numberOfAssignees;
      return assignees > 1 ? assignees + ' \u4E2A\u6307\u6D3E' : '个指派';
    }
  },
  template: '\n    <div class="title hide-collapsed">\n      {{assigneeTitle}}\n      <i\n        v-if="loading"\n        aria-hidden="true"\n        class="fa fa-spinner fa-spin block-loading"\n      />\n      <a\n        v-if="editable"\n        class="js-sidebar-dropdown-toggle edit-link pull-right"\n        href="#"\n      >\n        {{ __(\'Edit\') }}\n      </a>\n      <a\n        v-if="showToggle"\n        aria-label="Toggle sidebar"\n        class="gutter-toggle pull-right js-sidebar-toggle"\n        href="#"\n        role="button"\n      >\n        <i\n          aria-hidden="true"\n          data-hidden="true"\n          class="fa fa-angle-double-right"\n        />\n      </a>\n    </div>\n  '
});

/***/ }),

/***/ "./sidebar/components/assignees/assignees.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/assignees/assignees.vue

/* harmony default export */ var assignees = ({
  name: 'Assignees',
  props: {
    rootPath: {
      type: String,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      defaultRenderCount: 5,
      defaultMaxCounter: 99,
      showLess: true
    };
  },

  computed: {
    firstUser: function firstUser() {
      return this.users[0];
    },
    hasMoreThanTwoAssignees: function hasMoreThanTwoAssignees() {
      return this.users.length > 2;
    },
    hasMoreThanOneAssignee: function hasMoreThanOneAssignee() {
      return this.users.length > 1;
    },
    hasAssignees: function hasAssignees() {
      return this.users.length > 0;
    },
    hasNoUsers: function hasNoUsers() {
      return !this.users.length;
    },
    hasOneUser: function hasOneUser() {
      return this.users.length === 1;
    },
    renderShowMoreSection: function renderShowMoreSection() {
      return this.users.length > this.defaultRenderCount;
    },
    numberOfHiddenAssignees: function numberOfHiddenAssignees() {
      return this.users.length - this.defaultRenderCount;
    },
    isHiddenAssignees: function isHiddenAssignees() {
      return this.numberOfHiddenAssignees > 0;
    },
    hiddenAssigneesLabel: function hiddenAssigneesLabel() {
      return '+ ' + this.numberOfHiddenAssignees + ' more';
    },
    collapsedTooltipTitle: function collapsedTooltipTitle() {
      var maxRender = Math.min(this.defaultRenderCount, this.users.length);
      var renderUsers = this.users.slice(0, maxRender);
      var names = renderUsers.map(function (u) {
        return u.name;
      });

      if (this.users.length > maxRender) {
        names.push('+ ' + (this.users.length - maxRender) + ' more');
      }

      return names.join(', ');
    },
    sidebarAvatarCounter: function sidebarAvatarCounter() {
      var counter = '+' + (this.users.length - 1);

      if (this.users.length > this.defaultMaxCounter) {
        counter = this.defaultMaxCounter + '+';
      }

      return counter;
    }
  },
  methods: {
    assignSelf: function assignSelf() {
      this.$emit('assign-self');
    },
    toggleShowLess: function toggleShowLess() {
      this.showLess = !this.showLess;
    },
    renderAssignee: function renderAssignee(index) {
      return !this.showLess || index < this.defaultRenderCount && this.showLess;
    },
    avatarUrl: function avatarUrl(user) {
      return user.avatar || user.avatar_url || gon.default_avatar_url;
    },
    assigneeUrl: function assigneeUrl(user) {
      return '' + this.rootPath + user.username;
    },
    assigneeAlt: function assigneeAlt(user) {
      return user.name + '\'s avatar';
    },
    assigneeUsername: function assigneeUsername(user) {
      return '@' + user.username;
    },
    shouldRenderCollapsedAssignee: function shouldRenderCollapsedAssignee(index) {
      var firstTwo = this.users.length <= 2 && index <= 2;

      return index === 0 || firstTwo;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ce02b48","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/assignees/assignees.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-collapsed-icon sidebar-collapsed-user",class:{ 'multiple-users': _vm.hasMoreThanOneAssignee, 'has-tooltip': _vm.hasAssignees },attrs:{"data-container":"body","data-placement":"left","title":_vm.collapsedTooltipTitle}},[(_vm.hasNoUsers)?_c('i',{staticClass:"fa fa-user",attrs:{"aria-label":"No Assignee"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.users),function(user,index){return (_vm.shouldRenderCollapsedAssignee(index))?_c('button',{key:user.id,staticClass:"btn-link",attrs:{"type":"button"}},[_c('img',{staticClass:"avatar avatar-inline s24",attrs:{"width":"24","alt":_vm.assigneeAlt(user),"src":_vm.avatarUrl(user)}}),_vm._v(" "),_c('span',{staticClass:"author"},[_vm._v("\n        "+_vm._s(user.name)+"\n      ")])]):_vm._e()}),_vm._v(" "),(_vm.hasMoreThanTwoAssignees)?_c('button',{staticClass:"btn-link",attrs:{"type":"button"}},[_c('span',{staticClass:"avatar-counter sidebar-avatar-counter"},[_vm._v("\n        "+_vm._s(_vm.sidebarAvatarCounter)+"\n      ")])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"value hide-collapsed"},[(_vm.hasNoUsers)?[_c('span',{staticClass:"assign-yourself no-value"},[_vm._v("\n        No assignee\n        "),(_vm.editable)?[_vm._v("\n          -\n          "),_c('button',{staticClass:"btn-link",attrs:{"type":"button"},on:{"click":_vm.assignSelf}},[_vm._v("\n            assign yourself\n          ")])]:_vm._e()],2)]:(_vm.hasOneUser)?[_c('a',{staticClass:"author_link bold",attrs:{"href":_vm.assigneeUrl(_vm.firstUser)}},[_c('img',{staticClass:"avatar avatar-inline s32",attrs:{"width":"32","alt":_vm.assigneeAlt(_vm.firstUser),"src":_vm.avatarUrl(_vm.firstUser)}}),_vm._v(" "),_c('span',{staticClass:"author"},[_vm._v("\n          "+_vm._s(_vm.firstUser.name)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"username"},[_vm._v("\n          "+_vm._s(_vm.assigneeUsername(_vm.firstUser))+"\n        ")])])]:[_c('div',{staticClass:"user-list"},_vm._l((_vm.users),function(user,index){return (_vm.renderAssignee(index))?_c('div',{key:user.id,staticClass:"user-item"},[_c('a',{staticClass:"user-link has-tooltip",attrs:{"data-container":"body","data-placement":"bottom","href":_vm.assigneeUrl(user),"data-title":user.name}},[_c('img',{staticClass:"avatar avatar-inline s32",attrs:{"width":"32","alt":_vm.assigneeAlt(user),"src":_vm.avatarUrl(user)}})])]):_vm._e()})),_vm._v(" "),(_vm.renderShowMoreSection)?_c('div',{staticClass:"user-list-more"},[_c('button',{staticClass:"btn-link",attrs:{"type":"button"},on:{"click":_vm.toggleShowLess}},[(_vm.showLess)?[_vm._v("\n            "+_vm._s(_vm.hiddenAssigneesLabel)+"\n          ")]:[_vm._v("\n            - show less\n          ")]],2)]):_vm._e()]],2)])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/assignees/assignees.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  assignees,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var assignees_assignees = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./sidebar/components/subscriptions/subscriptions.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/toggle_button.vue + 2 modules
var toggle_button = __webpack_require__("./vue_shared/components/toggle_button.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./sidebar/event_hub.js
var event_hub = __webpack_require__("./sidebar/event_hub.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/subscriptions/subscriptions.vue







var ICON_ON = 'notifications';
var ICON_OFF = 'notifications-off';
var LABEL_ON = Object(locale["a" /* __ */])('Notifications on');
var LABEL_OFF = Object(locale["a" /* __ */])('Notifications off');

/* harmony default export */ var subscriptions = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    icon: icon["a" /* default */],
    toggleButton: toggle_button["a" /* default */]
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    subscribed: {
      type: Boolean,
      required: false,
      default: null
    },
    id: {
      type: Number,
      required: false,
      default: null
    }
  },
  computed: {
    showLoadingState: function showLoadingState() {
      return this.subscribed === null;
    },
    notificationIcon: function notificationIcon() {
      return this.subscribed ? ICON_ON : ICON_OFF;
    },
    notificationTooltip: function notificationTooltip() {
      return this.subscribed ? LABEL_ON : LABEL_OFF;
    }
  },
  methods: {
    toggleSubscription: function toggleSubscription() {
      event_hub["a" /* default */].$emit('toggleSubscription', this.id);
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-999c2692","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/subscriptions/subscriptions.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-collapsed-icon"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"title":_vm.notificationTooltip,"data-container":"body","data-placement":"left"}},[_c('icon',{staticClass:"sidebar-item-icon is-active",attrs:{"name":_vm.notificationIcon,"size":16,"aria-hidden":"true"}})],1)]),_vm._v(" "),_c('span',{staticClass:"issuable-header-text hide-collapsed pull-left"},[_vm._v("\n    "+_vm._s(_vm.__('Notifications'))+"\n  ")]),_vm._v(" "),_c('toggle-button',{ref:"toggleButton",staticClass:"pull-right hide-collapsed js-issuable-subscribe-button",attrs:{"is-loading":_vm.showLoadingState,"value":_vm.subscribed},on:{"change":_vm.toggleSubscription}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/subscriptions/subscriptions.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  subscriptions,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var subscriptions_subscriptions = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./sidebar/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


var eventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

// TODO: remove eventHub hack after code splitting refactor
window.emitSidebarEvent = function () {
  return eventHub.$emit.apply(eventHub, arguments);
};

/* harmony default export */ __webpack_exports__["a"] = (eventHub);

/***/ }),

/***/ "./sortable/sortable_config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  animation: 200,
  forceFallback: true,
  fallbackClass: 'is-dragging',
  fallbackOnBody: true,
  ghostClass: 'is-ghost'
});

/***/ }),

/***/ "./users_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable func-names, space-before-function-paren, one-var, no-var, prefer-rest-params, wrap-iife, quotes, max-len, one-var-declaration-per-line, vars-on-top, prefer-arrow-callback, consistent-return, comma-dangle, object-shorthand, no-shadow, no-unused-vars, no-else-return, no-self-compare, prefer-template, no-unused-expressions, no-lonely-if, yoda, prefer-spread, no-void, camelcase, no-param-reassign */
/* global Issuable */
/* global emitSidebarEvent */



// TODO: remove eventHub hack after code splitting refactor
window.emitSidebarEvent = window.emitSidebarEvent || $.noop;

function UsersSelect(currentUser, els) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var $els;
  this.users = this.users.bind(this);
  this.user = this.user.bind(this);
  this.usersPath = "/autocomplete/users.json";
  this.userPath = "/autocomplete/users/:id.json";
  if (currentUser != null) {
    if ((typeof currentUser === 'undefined' ? 'undefined' : _typeof(currentUser)) === 'object') {
      this.currentUser = currentUser;
    } else {
      this.currentUser = JSON.parse(currentUser);
    }
  }

  var handleClick = options.handleClick;


  $els = $(els);

  if (!els) {
    $els = $('.js-user-search');
  }

  $els.each(function (_this) {
    return function (i, dropdown) {
      var options = {};
      var $block, $collapsedSidebar, $dropdown, $loading, $selectbox, $value, abilityName, assignTo, assigneeTemplate, collapsedAssigneeTemplate, defaultLabel, defaultNullUser, firstUser, issueURL, selectedId, selectedIdDefault, showAnyUser, showNullUser, showMenuAbove;
      $dropdown = $(dropdown);
      options.projectId = $dropdown.data('projectId');
      options.groupId = $dropdown.data('groupId');
      options.showCurrentUser = $dropdown.data('currentUser');
      options.todoFilter = $dropdown.data('todoFilter');
      options.todoStateFilter = $dropdown.data('todoStateFilter');
      showNullUser = $dropdown.data('nullUser');
      defaultNullUser = $dropdown.data('nullUserDefault');
      showMenuAbove = $dropdown.data('showMenuAbove');
      showAnyUser = $dropdown.data('anyUser');
      firstUser = $dropdown.data('firstUser');
      options.authorId = $dropdown.data('authorId');
      defaultLabel = $dropdown.data('defaultLabel');
      issueURL = $dropdown.data('issueUpdate');
      $selectbox = $dropdown.closest('.selectbox');
      $block = $selectbox.closest('.block');
      abilityName = $dropdown.data('abilityName');
      $value = $block.find('.value');
      $collapsedSidebar = $block.find('.sidebar-collapsed-user');
      $loading = $block.find('.block-loading').fadeOut();
      selectedIdDefault = defaultNullUser && showNullUser ? 0 : null;
      selectedId = $dropdown.data('selected');

      if (selectedId === undefined) {
        selectedId = selectedIdDefault;
      }

      var assignYourself = function assignYourself() {
        var unassignedSelected = $dropdown.closest('.selectbox').find('input[name=\'' + $dropdown.data('fieldName') + '\'][value=0]');

        if (unassignedSelected) {
          unassignedSelected.remove();
        }

        // Save current selected user to the DOM
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = $dropdown.data('fieldName');

        var currentUserInfo = $dropdown.data('currentUserInfo');

        if (currentUserInfo) {
          input.value = currentUserInfo.id;
          input.dataset.meta = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(currentUserInfo.name);
        } else if (_this.currentUser) {
          input.value = _this.currentUser.id;
        }

        if ($selectbox) {
          $dropdown.parent().before(input);
        } else {
          $dropdown.after(input);
        }
      };

      if ($block[0]) {
        $block[0].addEventListener('assignYourself', assignYourself);
      }

      var getSelectedUserInputs = function getSelectedUserInputs() {
        return $selectbox.find('input[name="' + $dropdown.data('fieldName') + '"]');
      };

      var getSelected = function getSelected() {
        return getSelectedUserInputs().map(function (index, input) {
          return parseInt(input.value, 10);
        }).get();
      };

      var checkMaxSelect = function checkMaxSelect() {
        var maxSelect = $dropdown.data('maxSelect');
        if (maxSelect) {
          var selected = getSelected();

          if (selected.length > maxSelect) {
            var firstSelectedId = selected[0];
            var firstSelected = $dropdown.closest('.selectbox').find('input[name=\'' + $dropdown.data('fieldName') + '\'][value=' + firstSelectedId + ']');

            firstSelected.remove();
            emitSidebarEvent('sidebar.removeAssignee', {
              id: firstSelectedId
            });
          }
        }
      };

      var getMultiSelectDropdownTitle = function getMultiSelectDropdownTitle(selectedUser, isSelected) {
        var selectedUsers = getSelected().filter(function (u) {
          return u !== 0;
        });

        var firstUser = getSelectedUserInputs().map(function (index, input) {
          return {
            name: input.dataset.meta,
            value: parseInt(input.value, 10)
          };
        }).filter(function (u) {
          return u.id !== 0;
        }).get(0);

        if (selectedUsers.length === 0) {
          return '未指派';
        } else if (selectedUsers.length === 1) {
          return firstUser.name;
        } else if (isSelected) {
          var otherSelected = selectedUsers.filter(function (s) {
            return s !== selectedUser.id;
          });
          return selectedUser.name + ' + ' + otherSelected.length + ' more';
        } else {
          return firstUser.name + ' + ' + (selectedUsers.length - 1) + ' more';
        }
      };

      $('.assign-to-me-link').on('click', function (e) {
        e.preventDefault();
        $(e.currentTarget).hide();

        if ($dropdown.data('multiSelect')) {
          assignYourself();
          checkMaxSelect();

          var currentUserInfo = $dropdown.data('currentUserInfo');
          $dropdown.find('.dropdown-toggle-text').text(getMultiSelectDropdownTitle(currentUserInfo)).removeClass('is-default');
        } else {
          var $input = $('input[name="' + $dropdown.data('fieldName') + '"]');
          $input.val(gon.current_user_id);
          selectedId = $input.val();
          $dropdown.find('.dropdown-toggle-text').text(gon.current_user_fullname).removeClass('is-default');
        }
      });

      $block.on('click', '.js-assign-yourself', function (e) {
        e.preventDefault();
        return assignTo(_this.currentUser.id);
      });

      assignTo = function assignTo(selected) {
        var data;
        data = {};
        data[abilityName] = {};
        data[abilityName].assignee_id = selected != null ? selected : null;
        $loading.removeClass('hidden').fadeIn();
        $dropdown.trigger('loading.gl.dropdown');

        return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].put(issueURL, data).then(function (_ref) {
          var data = _ref.data;

          var user;
          $dropdown.trigger('loaded.gl.dropdown');
          $loading.fadeOut();
          if (data.assignee) {
            user = {
              name: data.assignee.name,
              username: data.assignee.username,
              avatar: data.assignee.avatar_url
            };
          } else {
            user = {
              name: '未指派',
              username: '',
              avatar: ''
            };
          }
          $value.html(assigneeTemplate(user));
          $collapsedSidebar.attr('title', __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name)).tooltip('fixTitle');
          return $collapsedSidebar.html(collapsedAssigneeTemplate(user));
        });
      };
      collapsedAssigneeTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<% if( avatar ) { %> <a class="author_link" href="/<%- username %>"> <img width="24" class="avatar avatar-inline s24" alt="" src="<%- avatar %>"> </a> <% } else { %> <i class="fa fa-user"></i> <% } %>');
      assigneeTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<% if (username) { %> <a class="author_link bold" href="/<%- username %>"> <% if( avatar ) { %> <img width="32" class="avatar avatar-inline s32" alt="" src="<%- avatar %>"> <% } %> <span class="author"><%- name %></span> <span class="username"> @<%- username %> </span> </a> <% } else { %> <span class="no-value assign-yourself"> No assignee - <a href="#" class="js-assign-yourself"> assign yourself </a> </span> <% } %>');
      return $dropdown.glDropdown({
        showMenuAbove: showMenuAbove,
        data: function data(term, callback) {
          return _this.users(term, options, function (users) {
            // GitLabDropdownFilter returns this.instance
            // GitLabDropdownRemote returns this.options.instance
            var glDropdown = this.instance || this.options.instance;
            glDropdown.options.processData(term, users, callback);
          }.bind(this));
        },
        processData: function processData(term, data, callback) {
          var users = data;

          // Only show assigned user list when there is no search term
          if ($dropdown.hasClass('js-multiselect') && term.length === 0) {
            var selectedInputs = getSelectedUserInputs();

            // Potential duplicate entries when dealing with issue board
            // because issue board is also managed by vue
            var selectedUsers = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.uniq(selectedInputs, false, function (a) {
              return a.value;
            }).filter(function (input) {
              var userId = parseInt(input.value, 10);
              var inUsersArray = users.find(function (u) {
                return u.id === userId;
              });

              return !inUsersArray && userId !== 0;
            }).map(function (input) {
              var userId = parseInt(input.value, 10);
              var _input$dataset = input.dataset,
                  avatarUrl = _input$dataset.avatarUrl,
                  avatar_url = _input$dataset.avatar_url,
                  name = _input$dataset.name,
                  username = _input$dataset.username;

              return {
                avatar_url: avatarUrl || avatar_url,
                id: userId,
                name: name,
                username: username
              };
            });

            users = data.concat(selectedUsers);
          }

          var anyUser = void 0;
          var index = void 0;
          var j = void 0;
          var len = void 0;
          var name = void 0;
          var obj = void 0;
          var showDivider = void 0;
          if (term.length === 0) {
            showDivider = 0;
            if (firstUser) {
              // Move current user to the front of the list
              for (index = j = 0, len = users.length; j < len; index = j += 1) {
                obj = users[index];
                if (obj.username === firstUser) {
                  users.splice(index, 1);
                  users.unshift(obj);
                  break;
                }
              }
            }
            if (showNullUser) {
              showDivider += 1;
              users.unshift({
                beforeDivider: true,
                name: '未指派',
                id: 0
              });
            }
            if (showAnyUser) {
              showDivider += 1;
              name = showAnyUser;
              if (name === true) {
                name = 'Any User';
              }
              anyUser = {
                beforeDivider: true,
                name: name,
                id: null
              };
              users.unshift(anyUser);
            }

            if (showDivider) {
              users.splice(showDivider, 0, 'divider');
            }

            if ($dropdown.hasClass('js-multiselect')) {
              var selected = getSelected().filter(function (i) {
                return i !== 0;
              });

              if (selected.length > 0) {
                if ($dropdown.data('dropdownHeader')) {
                  showDivider += 1;
                  users.splice(showDivider, 0, {
                    header: $dropdown.data('dropdownHeader')
                  });
                }

                var _selectedUsers = users.filter(function (u) {
                  return selected.indexOf(u.id) !== -1;
                }).sort(function (a, b) {
                  return a.name > b.name;
                });

                users = users.filter(function (u) {
                  return selected.indexOf(u.id) === -1;
                });

                _selectedUsers.forEach(function (selectedUser) {
                  showDivider += 1;
                  users.splice(showDivider, 0, selectedUser);
                });

                users.splice(showDivider + 1, 0, 'divider');
              }
            }
          }

          callback(users);
          if (showMenuAbove) {
            $dropdown.data('glDropdown').positionMenuAbove();
          }
        },
        filterable: true,
        filterRemote: true,
        search: {
          fields: ['name', 'username']
        },
        selectable: true,
        fieldName: $dropdown.data('fieldName'),
        toggleLabel: function toggleLabel(selected, el, glDropdown) {
          var inputValue = glDropdown.filterInput.val();

          if (this.multiSelect && inputValue === '') {
            // Remove non-users from the fullData array
            var users = glDropdown.filteredFullData();
            var callback = glDropdown.parseData.bind(glDropdown);

            // Update the data model
            this.processData(inputValue, users, callback);
          }

          if (this.multiSelect) {
            return getMultiSelectDropdownTitle(selected, $(el).hasClass('is-active'));
          }

          if (selected && 'id' in selected && $(el).hasClass('is-active')) {
            $dropdown.find('.dropdown-toggle-text').removeClass('is-default');
            if (selected.text) {
              return selected.text;
            } else {
              return selected.name;
            }
          } else {
            $dropdown.find('.dropdown-toggle-text').addClass('is-default');
            return defaultLabel;
          }
        },
        defaultLabel: defaultLabel,
        hidden: function hidden(e) {
          if ($dropdown.hasClass('js-multiselect')) {
            emitSidebarEvent('sidebar.saveAssignees');
          }

          if (!$dropdown.data('alwaysShowSelectbox')) {
            $selectbox.hide();

            // Recalculate where .value is because vue might have changed it
            $block = $selectbox.closest('.block');
            $value = $block.find('.value');
            // display:block overrides the hide-collapse rule
            $value.css('display', '');
          }
        },
        multiSelect: $dropdown.hasClass('js-multiselect'),
        inputMeta: $dropdown.data('inputMeta'),
        clicked: function clicked(options) {
          var $el = options.$el,
              e = options.e,
              isMarking = options.isMarking;

          var user = options.selectedObj;

          if ($dropdown.hasClass('js-multiselect')) {
            var isActive = $el.hasClass('is-active');
            var previouslySelected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('fieldName') + "'][value!=0]");

            // Enables support for limiting the number of users selected
            // Automatically removes the first on the list if more users are selected
            checkMaxSelect();

            if (user.beforeDivider && user.name.toLowerCase() === '未指派') {
              // Unassigned selected
              previouslySelected.each(function (index, element) {
                var id = parseInt(element.value, 10);
                element.remove();
              });
              emitSidebarEvent('sidebar.removeAllAssignees');
            } else if (isActive) {
              // user selected
              emitSidebarEvent('sidebar.addAssignee', user);

              // Remove unassigned selection (if it was previously selected)
              var unassignedSelected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('fieldName') + "'][value=0]");

              if (unassignedSelected) {
                unassignedSelected.remove();
              }
            } else {
              if (previouslySelected.length === 0) {
                // Select unassigned because there is no more selected users
                this.addInput($dropdown.data('fieldName'), 0, {});
              }

              // User unselected
              emitSidebarEvent('sidebar.removeAssignee', user);
            }

            if (getSelected().find(function (u) {
              return u === gon.current_user_id;
            })) {
              $('.assign-to-me-link').hide();
            } else {
              $('.assign-to-me-link').show();
            }
          }

          var isIssueIndex, isMRIndex, page, selected;
          page = $('body').attr('data-page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === page && page === 'projects:merge_requests:index';
          if ($dropdown.hasClass('js-filter-bulk-update') || $dropdown.hasClass('js-issuable-form-dropdown')) {
            e.preventDefault();

            var isSelecting = user.id !== selectedId;
            selectedId = isSelecting ? user.id : selectedIdDefault;

            if (selectedId === gon.current_user_id) {
              $('.assign-to-me-link').hide();
            } else {
              $('.assign-to-me-link').show();
            }
            return;
          }
          if ($el.closest('.add-issues-modal').length) {
            gl.issueBoards.ModalStore.store.filter[$dropdown.data('fieldName')] = user.id;
          } else if (handleClick) {
            e.preventDefault();
            handleClick(user, isMarking);
          } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
            return Issuable.filterResults($dropdown.closest('form'));
          } else if ($dropdown.hasClass('js-filter-submit')) {
            return $dropdown.closest('form').submit();
          } else if (!$dropdown.hasClass('js-multiselect')) {
            selected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('fieldName') + "']").val();
            return assignTo(selected);
          }

          // Automatically close dropdown after assignee is selected
          // since CE has no multiple assignees
          // EE does not have a max-select
          if ($dropdown.data('maxSelect') && getSelected().length === $dropdown.data('maxSelect')) {
            // Close the dropdown
            $dropdown.dropdown('toggle');
          }
        },
        id: function id(user) {
          return user.id;
        },
        opened: function opened(e) {
          var $el = $(e.currentTarget);
          var selected = getSelected();
          if ($dropdown.hasClass('js-issue-board-sidebar') && selected.length === 0) {
            this.addInput($dropdown.data('fieldName'), 0, {});
          }
          $el.find('.is-active').removeClass('is-active');

          function highlightSelected(id) {
            $el.find('li[data-user-id="' + id + '"] .dropdown-menu-user-link').addClass('is-active');
          }

          if (selected.length > 0) {
            getSelected().forEach(function (selectedId) {
              return highlightSelected(selectedId);
            });
          } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
            highlightSelected(0);
          } else {
            highlightSelected(selectedId);
          }
        },
        updateLabel: $dropdown.data('dropdownTitle'),
        renderRow: function renderRow(user) {
          var avatar, img, listClosingTags, listWithName, listWithUserName, username;
          username = user.username ? "@" + user.username : "";
          avatar = user.avatar_url ? user.avatar_url : gon.default_avatar_url;

          var selected = false;

          if (this.multiSelect) {
            selected = getSelected().find(function (u) {
              return user.id === u;
            });

            var fieldName = this.fieldName;
            var field = $dropdown.closest('.selectbox').find("input[name='" + fieldName + "'][value='" + user.id + "']");

            if (field.length) {
              selected = true;
            }
          } else {
            selected = user.id === selectedId;
          }

          img = "";
          if (user.beforeDivider != null) {
            '<li><a href=\'#\' class=\'' + (selected === true ? 'is-active' : '') + '\'>' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + '</a></li>';
          } else {
            img = "<img src='" + avatar + "' class='avatar avatar-inline' width='32' />";
          }

          return '\n            <li data-user-id=' + user.id + '>\n              <a href=\'#\' class=\'dropdown-menu-user-link ' + (selected === true ? 'is-active' : '') + '\'>\n                ' + img + '\n                <strong class=\'dropdown-menu-user-full-name\'>\n                  ' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + '\n                </strong>\n                ' + (username ? '<span class=\'dropdown-menu-user-username\'>' + username + '</span>' : '') + '\n              </a>\n            </li>\n          ';
        }
      });
    };
  }(this));
  $('.ajax-users-select').each(function (_this) {
    return function (i, select) {
      var firstUser, showAnyUser, showEmailUser, showNullUser;
      var options = {};
      options.skipLdap = $(select).hasClass('skip_ldap');
      options.projectId = $(select).data('projectId');
      options.groupId = $(select).data('groupId');
      options.showCurrentUser = $(select).data('currentUser');
      options.authorId = $(select).data('authorId');
      options.skipUsers = $(select).data('skipUsers');
      showNullUser = $(select).data('nullUser');
      showAnyUser = $(select).data('anyUser');
      showEmailUser = $(select).data('emailUser');
      firstUser = $(select).data('firstUser');
      return $(select).select2({
        placeholder: "Search for a user",
        multiple: $(select).hasClass('multiselect'),
        minimumInputLength: 0,
        query: function query(_query) {
          return _this.users(_query.term, options, function (users) {
            var anyUser, data, emailUser, index, j, len, name, nullUser, obj, ref;
            data = {
              results: users
            };
            if (_query.term.length === 0) {
              if (firstUser) {
                // Move current user to the front of the list
                ref = data.results;
                for (index = j = 0, len = ref.length; j < len; index = j += 1) {
                  obj = ref[index];
                  if (obj.username === firstUser) {
                    data.results.splice(index, 1);
                    data.results.unshift(obj);
                    break;
                  }
                }
              }
              if (showNullUser) {
                nullUser = {
                  name: '未指派',
                  id: 0
                };
                data.results.unshift(nullUser);
              }
              if (showAnyUser) {
                name = showAnyUser;
                if (name === true) {
                  name = 'Any User';
                }
                anyUser = {
                  name: name,
                  id: null
                };
                data.results.unshift(anyUser);
              }
            }
            if (showEmailUser && data.results.length === 0 && _query.term.match(/^[^@]+@[^@]+$/)) {
              var trimmed = _query.term.trim();
              emailUser = {
                name: "邀请 \"" + _query.term + "\" by email",
                username: trimmed,
                id: trimmed,
                invite: true
              };
              data.results.unshift(emailUser);
            }
            return _query.callback(data);
          });
        },
        initSelection: function initSelection() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.initSelection.apply(_this, args);
        },
        formatResult: function formatResult() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.formatResult.apply(_this, args);
        },
        formatSelection: function formatSelection() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.formatSelection.apply(_this, args);
        },
        dropdownCssClass: "ajax-users-dropdown",
        // we do not want to escape markup since we are displaying html in results
        escapeMarkup: function escapeMarkup(m) {
          return m;
        }
      });
    };
  }(this));
}

UsersSelect.prototype.initSelection = function (element, callback) {
  var id, nullUser;
  id = $(element).val();
  if (id === "0") {
    nullUser = {
      name: '未指派'
    };
    return callback(nullUser);
  } else if (id !== "") {
    return this.user(id, callback);
  }
};

UsersSelect.prototype.formatResult = function (user) {
  var avatar;
  if (user.avatar_url) {
    avatar = user.avatar_url;
  } else {
    avatar = gon.default_avatar_url;
  }
  return "<div class='user-result " + (!user.username ? 'no-username' : void 0) + "'> <div class='user-image'><img class='avatar avatar-inline s32' src='" + avatar + "'></div> <div class='user-name dropdown-menu-user-full-name'>" + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + "</div> <div class='user-username dropdown-menu-user-username'>" + (!user.invite ? "@" + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.username) : "") + "</div> </div>";
};

UsersSelect.prototype.formatSelection = function (user) {
  return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name);
};

UsersSelect.prototype.user = function (user_id, callback) {
  if (!/^\d+$/.test(user_id)) {
    return false;
  }

  var url;
  url = this.buildUrl(this.userPath);
  url = url.replace(':id', user_id);
  return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(url).then(function (_ref2) {
    var data = _ref2.data;

    callback(data);
  });
};

// Return users list. Filtered by query
// Only active users retrieved
UsersSelect.prototype.users = function (query, options, callback) {
  var url = this.buildUrl(this.usersPath);
  var params = {
    search: query,
    active: true,
    project_id: options.projectId || null,
    group_id: options.groupId || null,
    skip_ldap: options.skipLdap || null,
    todo_filter: options.todoFilter || null,
    todo_state_filter: options.todoStateFilter || null,
    current_user: options.showCurrentUser || null,
    author_id: options.authorId || null,
    skip_users: options.skipUsers || null
  };
  return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(url, { params: params }).then(function (_ref3) {
    var data = _ref3.data;

    callback(data);
  });
};

UsersSelect.prototype.buildUrl = function (url) {
  if (gon.relative_url_root != null) {
    url = gon.relative_url_root.replace(/\/$/, '') + url;
  }
  return url;
};

/* harmony default export */ __webpack_exports__["a"] = (UsersSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/components/icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/icon.vue


/* This is a re-usable vue component for rendering a svg sprite
  icon

  Sample configuration:

  <icon
    name="retry"
    :size="32"
    css-classes="top"
  />

*/
// only allow classes in images.scss e.g. s12
var validSizes = [8, 12, 16, 18, 24, 32, 48, 72];

/* harmony default export */ var icon = ({
  props: {
    name: {
      type: String,
      required: true
    },

    size: {
      type: Number,
      required: false,
      default: 16,
      validator: function validator(value) {
        return validSizes.includes(value);
      }
    },

    cssClasses: {
      type: String,
      required: false,
      default: ''
    },

    width: {
      type: Number,
      required: false,
      default: null
    },

    height: {
      type: Number,
      required: false,
      default: null
    },

    y: {
      type: Number,
      required: false,
      default: null
    },

    x: {
      type: Number,
      required: false,
      default: null
    }
  },

  computed: {
    spriteHref: function spriteHref() {
      return gon.sprite_icons + '#' + this.name;
    },
    iconSizeClass: function iconSizeClass() {
      return this.size ? 's' + this.size : '';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43441268","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.iconSizeClass, _vm.cssClasses],attrs:{"width":_vm.width,"height":_vm.height,"x":_vm.x,"y":_vm.y}},[_c('use',_vm._b({},'use',{ 'xlink:href':_vm.spriteHref },false))])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/toggle_button.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/toggle_button.vue





var ICON_ON = 'status_success_borderless';
var ICON_OFF = 'status_failed_borderless';
var LABEL_ON = Object(locale["e" /* s__ */])('ToggleButton|Toggle Status: ON');
var LABEL_OFF = Object(locale["e" /* s__ */])('ToggleButton|Toggle Status: OFF');

/* harmony default export */ var toggle_button = ({
  components: {
    icon: icon["a" /* default */],
    loadingIcon: loading_icon["a" /* default */]
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    name: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: Boolean,
      required: false,
      default: null
    },
    disabledInput: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    toggleIcon: function toggleIcon() {
      return this.value ? ICON_ON : ICON_OFF;
    },
    ariaLabel: function ariaLabel() {
      return this.value ? LABEL_ON : LABEL_OFF;
    }
  },

  methods: {
    toggleFeature: function toggleFeature() {
      if (!this.disabledInput) this.$emit('change', !this.value);
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c91d7c","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/toggle_button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"toggle-wrapper"},[(_vm.name)?_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.value}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"project-feature-toggle",class:{
      'is-checked': _vm.value,
      'is-disabled': _vm.disabledInput,
      'is-loading': _vm.isLoading
    },attrs:{"type":"button","aria-label":_vm.ariaLabel},on:{"click":_vm.toggleFeature}},[_c('loadingIcon',{staticClass:"loading-icon"}),_vm._v(" "),_c('span',{staticClass:"toggle-icon"},[_c('icon',{attrs:{"css-classes":"toggle-icon-svg","name":_vm.toggleIcon}})],1)],1)])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/toggle_button.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  toggle_button,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_toggle_button = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_image.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../images/no_avatar.png
var no_avatar = __webpack_require__("../images/no_avatar.png");
var no_avatar_default = /*#__PURE__*/__webpack_require__.n(no_avatar);

// EXTERNAL MODULE: ./lazy_loader.js
var lazy_loader = __webpack_require__("./lazy_loader.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue


/* This is a re-usable vue component for rendering a user avatar that
  does not need to link to the user's profile. The image and an optional
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-image
    :lazy="true"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :tooltip-text="tooltipText"
    tooltip-placement="top"
  />

*/





/* harmony default export */ var user_avatar_image = ({
  name: 'UserAvatarImage',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    lazy: {
      type: Boolean,
      required: false,
      default: false
    },
    imgSrc: {
      type: String,
      required: false,
      default: no_avatar_default.a
    },
    cssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: 'user avatar'
    },
    size: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    }
  },
  computed: {
    // API response sends null when gravatar is disabled and
    // we provide an empty string when we use it inside user avatar link.
    // In both cases we should render the defaultAvatarUrl
    sanitizedSource: function sanitizedSource() {
      return this.imgSrc === '' || this.imgSrc === null ? no_avatar_default.a : this.imgSrc;
    },
    resultantSrcAttribute: function resultantSrcAttribute() {
      return this.lazy ? lazy_loader["b" /* placeholderImage */] : this.sanitizedSource;
    },
    tooltipContainer: function tooltipContainer() {
      return this.tooltipText ? 'body' : null;
    },
    avatarSizeClass: function avatarSizeClass() {
      return 's' + this.size;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75ce3616","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"avatar",class:( _obj = {
    lazy: _vm.lazy
  }, _obj[_vm.avatarSizeClass] = true, _obj[_vm.cssClasses] = true, _obj ),attrs:{"src":_vm.resultantSrcAttribute,"width":_vm.size,"height":_vm.size,"alt":_vm.imgAlt,"data-src":_vm.sanitizedSource,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement,"title":_vm.tooltipText}})
var _obj;}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_avatar_image,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var user_avatar_user_avatar_image = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_link.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue


/* This is a re-usable vue component for rendering a user avatar wrapped in
  a clickable link (likely to the user's profile). The link, image, and
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-link
    :link-href="userProfileUrl"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :img-size="20"
    :tooltip-text="tooltipText"
    :tooltip-placement="top"
    :username="username"
  />

*/




/* harmony default export */ var user_avatar_link = ({
  name: 'UserAvatarLink',
  components: {
    userAvatarImage: user_avatar_image["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    linkHref: {
      type: String,
      required: false,
      default: ''
    },
    imgSrc: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: ''
    },
    imgCssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgSize: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    },
    username: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    shouldShowUsername: function shouldShowUsername() {
      return this.username.length > 0;
    },
    avatarTooltipText: function avatarTooltipText() {
      return this.shouldShowUsername ? '' : this.tooltipText;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dd80867","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"user-avatar-link",attrs:{"href":_vm.linkHref}},[_c('user-avatar-image',{attrs:{"img-src":_vm.imgSrc,"img-alt":_vm.imgAlt,"css-classes":_vm.imgCssClasses,"size":_vm.imgSize,"tooltip-text":_vm.avatarTooltipText,"tooltip-placement":_vm.tooltipPlacement}}),(_vm.shouldShowUsername)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"title":_vm.tooltipText,"tooltip-placement":_vm.tooltipPlacement}},[_vm._v(_vm._s(_vm.username))]):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_avatar_link,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var user_avatar_user_avatar_link = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/directives/tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    $(el).tooltip();
  },
  componentUpdated: function componentUpdated(el) {
    $(el).tooltip('fixTitle');
  },
  unbind: function unbind(el) {
    $(el).tooltip('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/models/label.js":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ListLabel = function ListLabel(obj) {
  _classCallCheck(this, ListLabel);

  this.id = obj.id;
  this.title = obj.title;
  this.type = obj.type;
  this.color = obj.color;
  this.textColor = obj.text_color;
  this.description = obj.description;
  this.priority = obj.priority !== null ? obj.priority : Infinity;
};

window.ListLabel = ListLabel;

/***/ })

},["./pages/projects/boards/index.js"]);


// WEBPACK FOOTER //
// pages.projects.boards.e667fa1cb5ca3124d27e.bundle.js